// Action Types
export default {
  // Loader
  START_LOADER: '@loader/START_LOADER',
  STOP_LOADER: '@loader/STOP_LOADER',
  CANCEL_API_REQUEST: '@api/CANCEL_API_REQUEST',

  // Login
  POST_LOGIN_ACTION: '@login/POST_LOGIN_ACTION',
  POST_LOGIN_REQUEST: '@login/POST_LOGIN_REQUEST',
  POST_LOGIN_SUCCESS: '@login/POST_LOGIN_SUCCESS',
  POST_LOGIN_FAILURE: '@login/POST_LOGIN_FAILURE',
  POST_LOGIN_CLEAR: '@login/POST_LOGIN_CLEAR',
  CLEAR_AUTH_SESSION: '@login/CLEAR_AUTH_SESSION',
  SET_MERCHANT_INFO: '@admin/SET_MERCHANT_INFO',
  CLEAR_MERCHANT_INFO: '@admin/CLEAR_MERCHANT_INFO',
  SET_EXPIRY_TOKEN_NOTIFICATION: '@login/SET_EXPIRY_TOKEN_NOTIFICATION',
  SET_USER_DATA: 'SET_USER_DATA',

  // Login otp
  GET_LOGIN_OTP: '@login/GET_LOGIN_OTP',
  GET_LOGIN_OTP_REQUEST: '@login/GET_LOGIN_OTP_REQUEST',
  GET_LOGIN_OTP_SUCCESS: '@login/GET_LOGIN_OTP_SUCCESS',
  GET_LOGIN_OTP_FAILURE: '@login/GET_LOGIN_OTP_FAILURE',
  GET_LOGIN_OTP_CLEAR: '@login/GET_LOGIN_OTP_CLEAR',
  RESEND_LOGIN_OTP: '@login/RESEND_LOGIN_OTP',
  RESEND_LOGIN_OTP_REQUEST: '@login/RESEND_LOGIN_OTP_REQUEST',
  RESEND_LOGIN_OTP_SUCCESS: '@login/RESEND_LOGIN_OTP_SUCCESS',
  RESEND_LOGIN_OTP_FAILURE: '@login/RESEND_LOGIN_OTP_FAILURE',
  RESEND_LOGIN_OTP_CLEAR: '@login/RESEND_LOGIN_OTP_CLEAR',
  VALIDATE_LOGIN_OTP: '@login/VALIDATE_LOGIN_OTP',
  VALIDATE_LOGIN_OTP_REQUEST: '@login/VALIDATE_LOGIN_OTP_REQUEST',
  VALIDATE_LOGIN_OTP_SUCCESS: '@login/VALIDATE_LOGIN_OTP_SUCCESS',
  VALIDATE_LOGIN_OTP_FAILURE: '@login/VALIDATE_LOGIN_OTP_FAILURE',
  VALIDATE_LOGIN_OTP_CLEAR: '@login/VALIDATE_LOGIN_OTP_CLEAR',
  FETCH_MERCHANT_ACTION: '@login/FETCH_MERCHANT_ACTION',
  FETCH_MERCHANT_REQUEST: '@login/FETCH_MERCHANT_REQUEST',
  FETCH_MERCHANT_SUCCESS: '@login/FETCH_MERCHANT_SUCCESS',
  FETCH_MERCHANT_UPDATE_TOGGLE: '@login/FETCH_MERCHANT_UPDATE_TOGGLE',
  FETCH_MERCHANT_FAILURE: '@login/FETCH_MERCHANT_FAILURE',
  FETCH_MERCHANT_CLEAR: '@login/FETCH_MERCHANT_CLEAR',

  // New SignUp
  POST_NEW_SIGN_UP_ACTION: '@newSignUp/POST_NEW_SIGN_UP_ACTION',
  POST_NEW_SIGN_UP_REQUEST: '@newSignUp/POST_NEW_SIGN_UP_REQUEST',
  POST_NEW_SIGN_UP_SUCCESS: '@newSignUp/POST_NEW_SIGN_UP_SUCCESS',
  POST_NEW_SIGN_UP_FAILURE: '@newSignUp/POST_NEW_SIGN_UP_FAILURE',
  POST_NEW_SIGN_UP_CLEAR: '@newSignUp/POST_NEW_SIGN_UP_CLEAR',

  RESEND_EMAIL_ACTION: '@login/RESEND_EMAIL_ACTION',
  RESEND_EMAIL_REQUEST: '@login/RESEND_EMAIL_REQUEST',
  RESEND_EMAIL_SUCCESS: '@login/RESEND_EMAIL_SUCCESS',
  RESEND_EMAIL_FAILURE: '@login/RESEND_EMAIL_FAILURE',
  RESEND_EMAIL_CLEAR: '@login/RESEND_EMAIL_CLEAR',

  NEWUSER_ACTION: '@login/NEWUSER_ACTION',
  NEWUSER_REQUEST: '@login/NEWUSER_REQUEST',
  NEWUSER_SUCCESS: '@login/NEWUSER_SUCCESS',
  NEWUSER_FAILURE: '@login/NEWUSER_FAILURE',
  NEWUSER_CLEAR: '@login/NEWUSER_CLEAR',

  // Logout
  POST_LOGOUT_ACTION: '@logout/POST_LOGOUT_ACTION',
  POST_LOGOUT_REQUEST: '@logout/POST_LOGOUT_REQUEST',
  POST_LOGOUT_SUCCESS: '@logout/POST_LOGOUT_SUCCESS',
  POST_LOGOUT_FAILURE: '@logout/POST_LOGOUT_FAILURE',
  POST_LOGOUT_CLEAR: '@logout/POST_LOGOUT_CLEAR',

  // Refresh TOken
  POST_REFRESH_TOKEN_ACTION: '@refresh-token/POST_REFRESH_TOKEN_ACTION',
  POST_REFRESH_TOKEN_REQUEST: '@refresh-token/POST_REFRESH_TOKEN_REQUEST',
  POST_REFRESH_TOKEN_SUCCESS: '@refresh-token/POST_REFRESH_TOKEN_SUCCESS',
  POST_REFRESH_TOKEN_FAILURE: '@refresh-token/POST_REFRESH_TOKEN_FAILURE',
  POST_REFRESH_TOKEN_CLEAR: '@refresh-token/POST_REFRESH_TOKEN_CLEAR',

  // Forgot password
  POST_FORGET_PASSWORD_ACTION: '@forget-password/POST_FORGET_PASSWORD_ACTION',
  POST_FORGET_PASSWORD_REQUEST: '@forget-password/POST_FORGET_PASSWORD_REQUEST',
  POST_FORGET_PASSWORD_SUCCESS: '@forget-password/POST_FORGET_PASSWORD_SUCCESS',
  POST_FORGET_PASSWORD_FAILURE: '@forget-password/POST_FORGET_PASSWORD_FAILURE',
  POST_FORGET_PASSWORD_CLEAR: '@forget-password/POST_FORGET_PASSWORD_CLEAR',

  USER_ENV_ACTION: '@forget-password/USER_ENV_ACTION',
  USER_ENV_REQUEST: '@forget-password/USER_ENV_REQUEST',
  USER_ENV_SUCCESS: '@forget-password/USER_ENV_SUCCESS',
  USER_ENV_FAILURE: '@forget-password/USER_ENV_FAILURE',
  USER_ENV_CLEAR: '@forget-password/USER_ENV_CLEAR',

  // Fetch OTP
  POST_FETCH_OTP_ACTION: '@fetch-otp/POST_FETCH_OTP_ACTION',
  POST_FETCH_OTP_REQUEST: '@fetch-otp/POST_FETCH_OTP_REQUEST',
  POST_FETCH_OTP_SUCCESS: '@fetch-otp/POST_FETCH_OTP_SUCCESS',
  POST_FETCH_OTP_FAILURE: '@fetch-otp/POST_FETCH_OTP_FAILURE',
  POST_FETCH_OTP_CLEAR: '@fetch-otp/POST_FETCH_OTP_CLEAR',

  // Validate OTP
  POST_VALIDATE_OTP_ACTION: '@validate-otp/POST_VALIDATE_OTP_ACTION',
  POST_VALIDATE_OTP_REQUEST: '@validate-otp/POST_VALIDATE_OTP_REQUEST',
  POST_VALIDATE_OTP_SUCCESS: '@validate-otp/POST_VALIDATE_OTP_SUCCESS',
  POST_VALIDATE_OTP_FAILURE: '@validate-otp/POST_VALIDATE_OTP_FAILURE',
  POST_VALIDATE_OTP_CLEAR: '@validate-otp/POST_VALIDATE_OTP_CLEAR',

  // Save new password
  POST_SAVE_NEW_PASSWORD_ACTION:
    '@save-new-password/POST_SAVE_NEW_PASSWORD_ACTION',
  POST_SAVE_NEW_PASSWORD_REQUEST:
    '@save-new-password/POST_SAVE_NEW_PASSWORD_REQUEST',
  POST_SAVE_NEW_PASSWORD_SUCCESS:
    '@save-new-password/POST_SAVE_NEW_PASSWORD_SUCCESS',
  POST_SAVE_NEW_PASSWORD_FAILURE:
    '@save-new-password/POST_SAVE_NEW_PASSWORD_FAILURE',
  POST_SAVE_NEW_PASSWORD_CLEAR:
    '@save-new-password/POST_SAVE_NEW_PASSWORD_CLEAR',

  // Sign Up
  POST_SIGN_UP_ACTION: '@signup/POST_SIGN_UP_ACTION',
  POST_SIGN_UP_REQUEST: '@signup/POST_SIGN_UP_REQUEST',
  POST_SIGN_UP_SUCCESS: '@signup/POST_SIGN_UP_SUCCESS',
  POST_SIGN_UP_FAILURE: '@signup/POST_SIGN_UP_FAILURE',
  POST_SIGN_UP_CLEAR: '@signup/POST_SIGN_UP_CLEAR',

  // Sign Up
  POST_EMAIL_VERIFICATION_ACTION: '@signup/POST_EMAIL_VERIFICATION_ACTION',
  POST_EMAIL_VERIFICATION_REQUEST: '@signup/POST_EMAIL_VERIFICATION_REQUEST',
  POST_EMAIL_VERIFICATION_SUCCESS: '@signup/POST_EMAIL_VERIFICATION_SUCCESS',
  POST_EMAIL_VERIFICATION_FAILURE: '@signup/POST_EMAIL_VERIFICATION_FAILURE',
  POST_EMAIL_VERIFICATION_CLEAR: '@signup/POST_EMAIL_VERIFICATION_CLEAR',

  // Sign Up
  POST_RESEND_EMAIL_VERIFICATION_ACTION: '@signup/POST_RESEND_EMAIL_VERIFICATION_ACTION',
  POST_RESEND_EMAIL_VERIFICATION_REQUEST: '@signup/POST_RESEND_EMAIL_VERIFICATION_REQUEST',
  POST_RESEND_EMAIL_VERIFICATION_SUCCESS: '@signup/POST_RESEND_EMAIL_VERIFICATION_SUCCESS',
  POST_RESEND_EMAIL_VERIFICATION_FAILURE: '@signup/POST_RESEND_EMAIL_VERIFICATION_FAILURE',
  POST_RESEND_EMAIL_VERIFICATION_CLEAR: '@signup/POST_RESEND_EMAIL_VERIFICATION_CLEAR',

  // Reset Password With Token
  RESET_PASSWORD_WITH_TOKEN: '@signup/RESET_PASSWORD_WITH_TOKEN',
  RESET_PASSWORD_WITH_TOKEN_REQUEST: '@signup/RESET_PASSWORD_WITH_TOKEN_REQUEST',
  RESET_PASSWORD_WITH_TOKEN_SUCCESS: '@signup/RESET_PASSWORD_WITH_TOKEN_SUCCESS',
  RESET_PASSWORD_WITH_TOKEN_FAILURE: '@signup/RESET_PASSWORD_WITH_TOKEN_FAILURE',
  RESET_PASSWORD_WITH_TOKEN_CLEAR: '@signup/RESET_PASSWORD_WITH_TOKEN_CLEAR',

  // Edge Onboard
  EDGE_ONBOARD_ACTION: '@signup/EDGE_ONBOARD_ACTION',
  EDGE_ONBOARD_REQUEST: '@signup/EDGE_ONBOARD_REQUEST',
  EDGE_ONBOARD_SUCCESS: '@signup/EDGE_ONBOARD_SUCCESS',
  EDGE_ONBOARD_FAILURE: '@signup/EDGE_ONBOARD_FAILURE',
  EDGE_ONBOARD_CLEAR: '@signup/EDGE_ONBOARD_CLEAR',

  //SalesForce Auth
  SALESFORCE_AUTH_ACTION: '@salesforce/SALESFORCE_AUTH_ACTION',
  SALESFORCE_AUTH_REQUEST: '@salesforce/SALESFORCE_AUTH_REQUEST',
  SALESFORCE_AUTH_SUCCESS: '@salesforce/SALESFORCE_AUTH_SUCCESS',
  SALESFORCE_AUTH_FAILURE: '@salesforce/SALESFORCE_AUTH_FAILURE',
  SALESFORCE_AUTH_CLEAR: '@salesforce/SALESFORCE_AUTH_CLEAR',

  // Change password
  POST_CHANGE_PASSWORD_ACTION: '@signup/POST_CHANGE_PASSWORD_ACTION',
  POST_CHANGE_PASSWORD_REQUEST: '@signup/POST_CHANGE_PASSWORD_RCHANGE_PASSWORD',
  POST_CHANGE_PASSWORD_SUCCESS: '@signup/POST_CHANGE_PASSWORD_SUCCESS',
  POST_CHANGE_PASSWORD_FAILURE: '@signup/POST_CHANGE_PASSWORD_FAILURE',
  POST_CHANGE_PASSWORD_CLEAR: '@signup/POST_CHANGE_PASSWORD_CLEAR',

  // Analytics
  POST_ANALYTICS_ACTION: '@analytics/POST_ANALYTICS_ACTION',
  POST_ANALYTICS_REQUEST: '@analytics/POST_ANALYTICS_REQUEST',
  POST_ANALYTICS_SUCCESS: '@analytics/POST_ANALYTICS_SUCCESS',
  POST_ANALYTICS_FAILURE: '@analytics/POST_ANALYTICS_FAILURE',
  POST_ANALYTICS_CLEAR: '@analytics/POST_ANALYTICS_CLEAR',

  // Validation
  POST_VALIDATION_ERRORS_ACTION: '@validation/POST_VALIDATION_ERRORS_ACTION',
  POST_VALIDATION_ERRORS_REQUEST: '@validation/POST_VALIDATION_ERRORS_REQUEST',
  POST_VALIDATION_ERRORS_SUCCESS: '@validation/POST_VALIDATION_ERRORS_SUCCESS',
  POST_VALIDATION_ERRORS_FAILURE: '@validation/POST_VALIDATION_ERRORS_FAILURE',
  POST_VALIDATION_ERRORS_CLEAR: '@validation/POST_VALIDATION_ERRORS_CLEAR',

  // Smart Routing / Get Gateway List
  GET_GATEWAY_LIST_ACTION: '@smart-routing/GET_GATEWAY_LIST_ACTION',
  GET_GATEWAY_LIST_REQUEST: '@smart-routing/GET_GATEWAY_LIST_REQUEST',
  GET_GATEWAY_LIST_SUCCESS: '@smart-routing/GET_GATEWAY_LIST_SUCCESS',
  GET_GATEWAY_LIST_FAILURE: '@smart-routing/GET_GATEWAY_LIST_FAILURE',
  GET_GATEWAY_LIST_CLEAR: '@smart-routing/GET_GATEWAY_LIST_CLEAR',

  // Smart Routing / Get Unmapped Gateway List
  GET_UNMAPPED_GATEWAY_LIST_ACTION:
    '@smart-routing/GET_UNMAPPED_GATEWAY_LIST_ACTION',
  GET_UNMAPPED_GATEWAY_LIST_REQUEST:
    '@smart-routing/GET_UNMAPPED_GATEWAY_LIST_REQUEST',
  GET_UNMAPPED_GATEWAY_LIST_SUCCESS:
    '@smart-routing/GET_UNMAPPED_GATEWAY_LIST_SUCCESS',
  GET_UNMAPPED_GATEWAY_LIST_FAILURE:
    '@smart-routing/GET_UNMAPPED_GATEWAY_LIST_FAILURE',
  GET_UNMAPPED_GATEWAY_LIST_CLEAR:
    '@smart-routing/GET_UNMAPPED_GATEWAY_LIST_CLEAR',

  // Smart Routing / Get Gateway Configurations
  GET_GATEWAY_CONFIGURATIONS_ACTION:
    '@smart-routing/GET_GATEWAY_CONFIGURATIONS_ACTION',
  GET_GATEWAY_CONFIGURATIONS_REQUEST:
    '@smart-routing/GET_GATEWAY_CONFIGURATIONS_REQUEST',
  GET_GATEWAY_CONFIGURATIONS_SUCCESS:
    '@smart-routing/GET_GATEWAY_CONFIGURATIONS_SUCCESS',
  GET_GATEWAY_CONFIGURATIONS_FAILURE:
    '@smart-routing/GET_GATEWAY_CONFIGURATIONS_FAILURE',
  GET_GATEWAY_CONFIGURATIONS_CLEAR:
    '@smart-routing/GET_GATEWAY_CONFIGURATIONS_CLEAR',

  SET_GATEWAY_CONFIGURATIONS_PARAMS:
    '@smart-routing/SET_GATEWAY_CONFIGURATIONS_PARAMS',

  // Save Gateway
  POST_SAVE_GATEWAY_ACTION: '@smart-routing/POST_SAVE_GATEWAY_ACTION',
  POST_SAVE_GATEWAY_REQUEST: '@smart-routing/POST_SAVE_GATEWAY_REQUEST',
  POST_SAVE_GATEWAY_SUCCESS: '@smart-routing/POST_SAVE_GATEWAY_SUCCESS',
  POST_SAVE_GATEWAY_FAILURE: '@smart-routing/POST_SAVE_GATEWAY_FAILURE',
  POST_SAVE_GATEWAY_CLEAR: '@smart-routing/POST_SAVE_GATEWAY_CLEAR',

  // Smart Routing / Get Preference Gateway
  GET_PREFERENCE_GATEWAY_ACTION: '@smart-routing/GET_PREFERENCE_GATEWAY_ACTION',
  GET_PREFERENCE_GATEWAY_REQUEST:
    '@smart-routing/GET_PREFERENCE_GATEWAY_REQUEST',
  GET_PREFERENCE_GATEWAY_SUCCESS:
    '@smart-routing/GET_PREFERENCE_GATEWAY_SUCCESS',
  GET_PREFERENCE_GATEWAY_FAILURE:
    '@smart-routing/GET_PREFERENCE_GATEWAY_FAILURE',
  GET_PREFERENCE_GATEWAY_CLEAR: '@smart-routing/GET_PREFERENCE_GATEWAY_CLEAR',

  // Save Custom Routing Logic
  POST_SAVE_CUSTOM_LOGIC_ACTION: '@smart-routing/POST_SAVE_CUSTOM_LOGIC_ACTION',
  POST_SAVE_CUSTOM_LOGIC_REQUEST:
    '@smart-routing/POST_SAVE_CUSTOM_LOGIC_REQUEST',
  POST_SAVE_CUSTOM_LOGIC_SUCCESS:
    '@smart-routing/POST_SAVE_CUSTOM_LOGIC_SUCCESS',
  POST_SAVE_CUSTOM_LOGIC_FAILURE:
    '@smart-routing/POST_SAVE_CUSTOM_LOGIC_FAILURE',
  POST_SAVE_CUSTOM_LOGIC_CLEAR: '@smart-routing/POST_SAVE_CUSTOM_LOGIC_CLEAR',

  // Smart Routing / Get Active Priority Logic
  GET_ACTIVE_PRIORITY_LOGIC_ACTION:
    '@smart-routing/GET_ACTIVE_PRIORITY_LOGIC_ACTION',
  GET_ACTIVE_PRIORITY_LOGIC_REQUEST:
    '@smart-routing/GET_ACTIVE_PRIORITY_LOGIC_REQUEST',
  GET_ACTIVE_PRIORITY_LOGIC_SUCCESS:
    '@smart-routing/GET_ACTIVE_PRIORITY_LOGIC_SUCCESS',
  GET_ACTIVE_PRIORITY_LOGIC_FAILURE:
    '@smart-routing/GET_ACTIVE_PRIORITY_LOGIC_FAILURE',
  GET_ACTIVE_PRIORITY_LOGIC_CLEAR:
    '@smart-routing/GET_ACTIVE_PRIORITY_LOGIC_CLEAR',

  // Smart Routing / Update Preference Score
  UPDATE_PREFERENCE_SCORE_ACTION:
    '@smart-routing/UPDATE_PREFERENCE_SCORE_ACTION',
  UPDATE_PREFERENCE_SCORE_REQUEST:
    '@smart-routing/UPDATE_PREFERENCE_SCORE_REQUEST',
  UPDATE_PREFERENCE_SCORE_SUCCESS:
    '@smart-routing/UPDATE_PREFERENCE_SCORE_SUCCESS',
  UPDATE_PREFERENCE_SCORE_FAILURE:
    '@smart-routing/UPDATE_PREFERENCE_SCORE_FAILURE',
  UPDATE_PREFERENCE_SCORE_CLEAR: '@smart-routing/UPDATE_PREFERENCE_SCORE_CLEAR',

  // Smart Routing / Get Priority Logics List
  GET_PRIORITY_LOGIC_LIST_ACTION:
    '@smart-routing/GET_PRIORITY_LOGIC_LIST_ACTION',
  GET_PRIORITY_LOGIC_LIST_REQUEST:
    '@smart-routing/GET_PRIORITY_LOGIC_LIST_REQUEST',
  GET_PRIORITY_LOGIC_LIST_SUCCESS:
    '@smart-routing/GET_PRIORITY_LOGIC_LIST_SUCCESS',
  GET_PRIORITY_LOGIC_LIST_FAILURE:
    '@smart-routing/GET_PRIORITY_LOGIC_LIST_FAILURE',
  GET_PRIORITY_LOGIC_LIST_CLEAR: '@smart-routing/GET_PRIORITY_LOGIC_LIST_CLEAR',

  // Smart Routing / Get Preference Score BIN List
  GET_PREFERENCE_SCORE_BIN_LIST_ACTION:
    '@smart-routing/GET_PREFERENCE_SCORE_BIN_LIST_ACTION',
  GET_PREFERENCE_SCORE_BIN_LIST_REQUEST:
    '@smart-routing/GET_PREFERENCE_SCORE_BIN_LIST_REQUEST',
  GET_PREFERENCE_SCORE_BIN_LIST_SUCCESS:
    '@smart-routing/GET_PREFERENCE_SCORE_BIN_LIST_SUCCESS',
  GET_PREFERENCE_SCORE_BIN_LIST_FAILURE:
    '@smart-routing/GET_PREFERENCE_SCORE_BIN_LIST_FAILURE',
  GET_PREFERENCE_SCORE_BIN_LIST_CLEAR:
    '@smart-routing/GET_PREFERENCE_SCORE_BIN_LIST_CLEAR',

  // Smart Routing / Get Preference Score Issuer List
  GET_PREFERENCE_SCORE_ISSUER_LIST_ACTION:
    '@smart-routing/GET_PREFERENCE_SCORE_ISSUER_LIST_ACTION',
  GET_PREFERENCE_SCORE_ISSUER_LIST_REQUEST:
    '@smart-routing/GET_PREFERENCE_SCORE_ISSUER_LIST_REQUEST',
  GET_PREFERENCE_SCORE_ISSUER_LIST_SUCCESS:
    '@smart-routing/GET_PREFERENCE_SCORE_ISSUER_LIST_SUCCESS',
  GET_PREFERENCE_SCORE_ISSUER_LIST_FAILURE:
    '@smart-routing/GET_PREFERENCE_SCORE_ISSUER_LIST_FAILURE',
  GET_PREFERENCE_SCORE_ISSUER_LIST_CLEAR:
    '@smart-routing/GET_PREFERENCE_SCORE_ISSUER_LIST_CLEAR',

  // Smart Routing / Get Preference Score Card Brand List
  GET_PREFERENCE_SCORE_CARD_BRAND_LIST_ACTION:
    '@smart-routing/GET_PREFERENCE_SCORE_CARD_BRAND_LIST_ACTION',
  GET_PREFERENCE_SCORE_CARD_BRAND_LIST_REQUEST:
    '@smart-routing/GET_PREFERENCE_SCORE_CARD_BRAND_LIST_REQUEST',
  GET_PREFERENCE_SCORE_CARD_BRAND_LIST_SUCCESS:
    '@smart-routing/GET_PREFERENCE_SCORE_CARD_BRAND_LIST_SUCCESS',
  GET_PREFERENCE_SCORE_CARD_BRAND_LIST_FAILURE:
    '@smart-routing/GET_PREFERENCE_SCORE_CARD_BRAND_LIST_FAILURE',
  GET_PREFERENCE_SCORE_CARD_BRAND_LIST_CLEAR:
    '@smart-routing/GET_PREFERENCE_SCORE_CARD_BRAND_LIST_CLEAR',

  // Smart Routing / Get All Card Brand Names List
  GET_ALL_CARD_BRAND_NAMES_ACTION:
    '@smart-routing/GET_ALL_CARD_BRAND_NAMES_ACTION',
  GET_ALL_CARD_BRAND_NAMES_REQUEST:
    '@smart-routing/GET_ALL_CARD_BRAND_NAMES_REQUEST',
  GET_ALL_CARD_BRAND_NAMES_SUCCESS:
    '@smart-routing/GET_ALL_CARD_BRAND_NAMES_SUCCESS',
  GET_ALL_CARD_BRAND_NAMES_FAILURE:
    '@smart-routing/GET_ALL_CARD_BRAND_NAMES_FAILURE',
  GET_ALL_CARD_BRAND_NAMES_CLEAR:
    '@smart-routing/GET_ALL_CARD_BRAND_NAMES_CLEAR',

  // Smart Routing / Get All Issuer Name List
  GET_ALL_ISSUER_NAME_LIST_ACTION:
    '@smart-routing/GET_ALL_ISSUER_NAME_LIST_ACTION',
  GET_ALL_ISSUER_NAME_LIST_REQUEST:
    '@smart-routing/GET_ALL_ISSUER_NAME_LIST_REQUEST',
  GET_ALL_ISSUER_NAME_LIST_SUCCESS:
    '@smart-routing/GET_ALL_ISSUER_NAME_LIST_SUCCESS',
  GET_ALL_ISSUER_NAME_LIST_FAILURE:
    '@smart-routing/GET_ALL_ISSUER_NAME_LIST_FAILURE',
  GET_ALL_ISSUER_NAME_LIST_CLEAR:
    '@smart-routing/GET_ALL_ISSUER_NAME_LIST_CLEAR',

  // Smart Routing / Create Preference Score
  POST_CREATE_PREFERENCE_SCORE_ACTION:
    '@smart-routing/POST_CREATE_PREFERENCE_SCORE_ACTION',
  POST_CREATE_PREFERENCE_SCORE_REQUEST:
    '@smart-routing/POST_CREATE_PREFERENCE_SCORE_REQUEST',
  POST_CREATE_PREFERENCE_SCORE_SUCCESS:
    '@smart-routing/POST_CREATE_PREFERENCE_SCORE_SUCCESS',
  POST_CREATE_PREFERENCE_SCORE_FAILURE:
    '@smart-routing/POST_CREATE_PREFERENCE_SCORE_FAILURE',
  POST_CREATE_PREFERENCE_SCORE_CLEAR:
    '@smart-routing/POST_CREATE_PREFERENCE_SCORE_CLEAR',

  // Smart Routing / Delete Preference Score
  POST_DELETE_PREFERENCE_SCORE_ACTION:
    '@smart-routing/POST_DELETE_PREFERENCE_SCORE_ACTION',
  POST_DELETE_PREFERENCE_SCORE_REQUEST:
    '@smart-routing/POST_DELETE_PREFERENCE_SCORE_REQUEST',
  POST_DELETE_PREFERENCE_SCORE_SUCCESS:
    '@smart-routing/POST_DELETE_PREFERENCE_SCORE_SUCCESS',
  POST_DELETE_PREFERENCE_SCORE_FAILURE:
    '@smart-routing/POST_DELETE_PREFERENCE_SCORE_FAILURE',
  POST_DELETE_PREFERENCE_SCORE_CLEAR:
    '@smart-routing/POST_DELETE_PREFERENCE_SCORE_CLEAR',

  // Smart Routing / View Simple Routing Logic
  GET_VIEW_SIMPLE_ROUTING_LOGIC_ACTION:
    '@smart-routing/GET_VIEW_SIMPLE_ROUTING_LOGIC_ACTION',
  GET_VIEW_SIMPLE_ROUTING_LOGIC_REQUEST:
    '@smart-routing/GET_VIEW_SIMPLE_ROUTING_LOGIC_REQUEST',
  GET_VIEW_SIMPLE_ROUTING_LOGIC_SUCCESS:
    '@smart-routing/GET_VIEW_SIMPLE_ROUTING_LOGIC_SUCCESS',
  GET_VIEW_SIMPLE_ROUTING_LOGIC_FAILURE:
    '@smart-routing/GET_VIEW_SIMPLE_ROUTING_LOGIC_FAILURE',
  GET_VIEW_SIMPLE_ROUTING_LOGIC_CLEAR:
    '@smart-routing/GET_VIEW_SIMPLE_ROUTING_LOGIC_CLEAR',

  // Smart Routing / Change Gateway Status
  POST_CHANGE_GATEWAY_STATUS_ACTION:
    '@smart-routing/POST_CHANGE_GATEWAY_STATUS_ACTION',
  POST_CHANGE_GATEWAY_STATUS_REQUEST:
    '@smart-routing/POST_CHANGE_GATEWAY_STATUS_REQUEST',
  POST_CHANGE_GATEWAY_STATUS_SUCCESS:
    '@smart-routing/POST_CHANGE_GATEWAY_STATUS_SUCCESS',
  POST_CHANGE_GATEWAY_STATUS_FAILURE:
    '@smart-routing/POST_CHANGE_GATEWAY_STATUS_FAILURE',
  POST_CHANGE_GATEWAY_STATUS_CLEAR:
    '@smart-routing/POST_CHANGE_GATEWAY_STATUS_CLEAR',

  // Smart Routing / Delete Priority Logic
  DELETE_PRIORITY_LOGIC_ACTION: '@smart-routing/DELETE_PRIORITY_LOGIC_ACTION',
  DELETE_PRIORITY_LOGIC_REQUEST: '@smart-routing/DELETE_PRIORITY_LOGIC_REQUEST',
  DELETE_PRIORITY_LOGIC_SUCCESS: '@smart-routing/DELETE_PRIORITY_LOGIC_SUCCESS',
  DELETE_PRIORITY_LOGIC_FAILURE: '@smart-routing/DELETE_PRIORITY_LOGIC_FAILURE',
  DELETE_PRIORITY_LOGIC_CLEAR: '@smart-routing/DELETE_PRIORITY_LOGIC_CLEAR',

  // Settings / Get Merchent Webhook
  GET_ACTIVE_WEBHOOK_EVENTS: '@settings/GET_ACTIVE_WEBHOOK_EVENTS',
  GET_ACTIVE_WEBHOOK_EVENTS_REQUEST:
    '@settings/GET_ACTIVE_WEBHOOK_EVENTS_REQUEST',
  GET_ACTIVE_WEBHOOK_EVENTS_SUCCESS:
    '@settings/GET_ACTIVE_WEBHOOK_EVENTS_SUCCESS',
  GET_ACTIVE_WEBHOOK_EVENTS_FAILURE:
    '@settings/GET_ACTIVE_WEBHOOK_EVENTS_FAILURE',
  GET_ACTIVE_WEBHOOK_EVENTS_CLEAR: '@settings/GET_ACTIVE_WEBHOOK_EVENTS_CLEAR',

  // Settings / Get Edge Payment Links Webhook
  GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS:
    '@settings/GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS',
  GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_REQUEST:
    '@settings/GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_REQUEST',
  GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_SUCCESS:
    '@settings/GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_SUCCESS',
  GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_FAILURE:
    '@settings/GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_FAILURE',
  GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_CLEAR:
    '@settings/GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_CLEAR',

  // Settings / Update Edge Payment Links Webhook
  UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK:
    '@settings/UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK',
  UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_REQUEST:
    '@settings/UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_REQUEST',
  UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_SUCCESS:
    '@settings/UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_SUCCESS',
  UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_FAILURE:
    '@settings/UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_FAILURE',
  UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_CLEAR:
    '@settings/UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_CLEAR',

  // Settings / Get Merchent Settings
  GET_MERCHENT_SETTINGS: '@settings/GET_MERCHENT_SETTINGS',
  GET_MERCHENT_SETTINGS_REQUEST: '@settings/GET_MERCHENT_SETTINGS_REQUEST',
  GET_MERCHENT_SETTINGS_SUCCESS: '@settings/GET_MERCHENT_SETTINGS_SUCCESS',
  GET_MERCHENT_SETTINGS_FAILURE: '@settings/GET_MERCHENT_SETTINGS_FAILURE',
  GET_MERCHENT_SETTINGS_CLEAR: '@settings/GET_MERCHENT_SETTINGS_CLEAR',

  // Settings / Update Merchent General Settings
  UPDATE_MERCHENT_GENERAL_SETTINGS:
    '@settings/UPDATE_MERCHENT_GENERAL_SETTINGS',
  UPDATE_MERCHENT_GENERAL_SETTINGS_REQUEST:
    '@settings/UPDATE_MERCHENT_GENERAL_SETTINGS_REQUEST',
  UPDATE_MERCHENT_GENERAL_SETTINGS_SUCCESS:
    '@settings/UPDATE_MERCHENT_GENERAL_SETTINGS_SUCCESS',
  UPDATE_MERCHENT_GENERAL_SETTINGS_FAILURE:
    '@settings/UPDATE_MERCHENT_GENERAL_SETTINGS_FAILURE',
  UPDATE_MERCHENT_GENERAL_SETTINGS_CLEAR:
    '@settings/UPDATE_MERCHENT_GENERAL_SETTINGS_CLEAR',

  // Settings / Update Merchent Webhook
  UPDATE_MERCHENT_WEBHOOK: '@settings/UPDATE_MERCHENT_WEBHOOK',
  UPDATE_MERCHENT_WEBHOOK_REQUEST: '@settings/UPDATE_MERCHENT_WEBHOOK_REQUEST',
  UPDATE_MERCHENT_WEBHOOK_SUCCESS: '@settings/UPDATE_MERCHENT_WEBHOOK_SUCCESS',
  UPDATE_MERCHENT_WEBHOOK_FAILURE: '@settings/UPDATE_MERCHENT_WEBHOOK_FAILURE',
  UPDATE_MERCHENT_WEBHOOK_CLEAR: '@settings/UPDATE_MERCHENT_WEBHOOK_CLEAR',

  // Settings / V3 Merchant Webhook
  GET_V3_MERCHANT_WEBHOOK: '@settings/GET_V3_MERCHANT_WEBHOOK',
  GET_V3_MERCHANT_WEBHOOK_REQUEST:
    '@settings/GET_V3_MERCHANT_WEBHOOK_REQUEST',
  GET_V3_MERCHANT_WEBHOOK_SUCCESS:
    '@settings/GET_V3_MERCHANT_WEBHOOK_SUCCESS',
  GET_V3_MERCHANT_WEBHOOK_FAILURE:
    '@settings/GET_V3_MERCHANT_WEBHOOK_FAILURE',
  GET_V3_MERCHANT_WEBHOOK_CLEAR: '@settings/GET_V3_MERCHANT_WEBHOOK_CLEAR',
  UPDATE_V3_MERCHANT_WEBHOOK: '@settings/UPDATE_V3_MERCHANT_WEBHOOK',
  UPDATE_V3_MERCHANT_WEBHOOK_REQUEST:
    '@settings/UPDATE_V3_MERCHANT_WEBHOOK_REQUEST',
  UPDATE_V3_MERCHANT_WEBHOOK_SUCCESS:
    '@settings/UPDATE_V3_MERCHANT_WEBHOOK_SUCCESS',
  UPDATE_V3_MERCHANT_WEBHOOK_FAILURE:
    '@settings/UPDATE_V3_MERCHANT_WEBHOOK_FAILURE',
  UPDATE_V3_MERCHANT_WEBHOOK_CLEAR:
    '@settings/UPDATE_V3_MERCHANT_WEBHOOK_CLEAR',

  // Setting / User Management / Get Active Users
  GET_ACTIVE_USERS_LIST: '@settings/GET_ACTIVE_USERS_LIST',
  GET_ACTIVE_USERS_LIST_REQUEST: '@settings/GET_ACTIVE_USERS_LIST_REQUEST',
  GET_ACTIVE_USERS_LIST_SUCCESS: '@settings/GET_ACTIVE_USERS_LIST_SUCCESS',
  GET_ACTIVE_USERS_LIST_FAILURE: '@settings/GET_ACTIVE_USERS_LIST_FAILURE',
  GET_ACTIVE_USERS_LIST_CLEAR: '@settings/GET_ACTIVE_USERS_LIST_CLEAR',

  // Setting / User Management / Get All Roles
  GET_ALL_ROLES: '@settings/GET_ALL_ROLES',
  GET_ALL_ROLES_REQUEST: '@settings/GET_ALL_ROLES_REQUEST',
  GET_ALL_ROLES_SUCCESS: '@settings/GET_ALL_ROLES_SUCCESS',
  GET_ALL_ROLES_FAILURE: '@settings/GET_ALL_ROLES_FAILURE',
  GET_ALL_ROLES_CLEAR: '@settings/GET_ALL_ROLES_CLEAR',

  // Setting / User Management / Get All Permissions List
  GET_ALL_PERMISSIONS_LIST: '@settings/GET_ALL_PERMISSIONS_LIST',
  GET_ALL_PERMISSIONS_LIST_REQUEST:
    '@settings/GET_ALL_PERMISSIONS_LIST_REQUEST',
  GET_ALL_PERMISSIONS_LIST_SUCCESS:
    '@settings/GET_ALL_PERMISSIONS_LIST_SUCCESS',
  GET_ALL_PERMISSIONS_LIST_FAILURE:
    '@settings/GET_ALL_PERMISSIONS_LIST_FAILURE',
  GET_ALL_PERMISSIONS_LIST_CLEAR: '@settings/GET_ALL_PERMISSIONS_LIST_CLEAR',

  // Setting / User Management / Create New User
  POST_CREATE_NEW_USER: '@settings/POST_CREATE_NEW_USER',
  POST_CREATE_NEW_USER_REQUEST: '@settings/POST_CREATE_NEW_USER_REQUEST',
  POST_CREATE_NEW_USER_SUCCESS: '@settings/POST_CREATE_NEW_USER_SUCCESS',
  POST_CREATE_NEW_USER_FAILURE: '@settings/POST_CREATE_NEW_USER_FAILURE',
  POST_CREATE_NEW_USER_CLEAR: '@settings/POST_CREATE_NEW_USER_CLEAR',

  // Setting / User Management / Update New User
  POST_UPDATE_USER_DETAILS: '@settings/POST_UPDATE_USER_DETAILS',
  POST_UPDATE_USER_DETAILS_REQUEST:
    '@settings/POST_UPDATE_USER_DETAILS_REQUEST',
  POST_UPDATE_USER_DETAILS_SUCCESS:
    '@settings/POST_UPDATE_USER_DETAILS_SUCCESS',
  POST_UPDATE_USER_DETAILS_FAILURE:
    '@settings/POST_UPDATE_USER_DETAILS_FAILURE',
  POST_UPDATE_USER_DETAILS_CLEAR: '@settings/POST_UPDATE_USER_DETAILS_CLEAR',

  // Setting / User Management / Delete User
  DELETE_USER: '@settings/DELETE_USER',
  DELETE_USER_REQUEST: '@settings/DELETE_USER_REQUEST',
  DELETE_USER_SUCCESS: '@settings/DELETE_USER_SUCCESS',
  DELETE_USER_FAILURE: '@settings/DELETE_USER_FAILURE',
  DELETE_USER_CLEAR: '@settings/DELETE_USER_CLEAR',

  // Setting / User Management / Create New Role
  POST_CREATE_NEW_ROLE: '@settings/POST_CREATE_NEW_ROLE',
  POST_CREATE_NEW_ROLE_REQUEST: '@settings/POST_CREATE_NEW_ROLE_REQUEST',
  POST_CREATE_NEW_ROLE_SUCCESS: '@settings/POST_CREATE_NEW_ROLE_SUCCESS',
  POST_CREATE_NEW_ROLE_FAILURE: '@settings/POST_CREATE_NEW_ROLE_FAILURE',
  POST_CREATE_NEW_ROLE_CLEAR: '@settings/POST_CREATE_NEW_ROLE_CLEAR',

  // Setting / User Management / Resend Invitation
  POST_RESEND_INVITATION: '@settings/POST_RESEND_INVITATION',
  POST_RESEND_INVITATION_REQUEST: '@settings/POST_RESEND_INVITATION_REQUEST',
  POST_RESEND_INVITATION_SUCCESS: '@settings/POST_RESEND_INVITATION_SUCCESS',
  POST_RESEND_INVITATION_FAILURE: '@settings/POST_RESEND_INVITATION_FAILURE',
  POST_RESEND_INVITATION_CLEAR: '@settings/POST_RESEND_INVITATION_CLEAR',

  // Setting / Checkout Theme / Get Theme
  GET_CHECKOUT_THEME: '@settings/GET_CHECKOUT_THEME',
  GET_CHECKOUT_THEME_REQUEST: '@settings/GET_CHECKOUT_THEME_REQUEST',
  GET_CHECKOUT_THEME_SUCCESS: '@settings/GET_CHECKOUT_THEME_SUCCESS',
  GET_CHECKOUT_THEME_FAILURE: '@settings/GET_CHECKOUT_THEME_FAILURE',
  GET_CHECKOUT_THEME_CLEAR: '@settings/GET_CHECKOUT_THEME_CLEAR',

  // Setting / Checkout Theme / Update Theme
  POST_UPDATE_CHECKOUT_THEME: '@settings/POST_UPDATE_CHECKOUT_THEME',
  POST_UPDATE_CHECKOUT_THEME_REQUEST:
    '@settings/POST_UPDATE_CHECKOUT_THEME_REQUEST',
  POST_UPDATE_CHECKOUT_THEME_SUCCESS:
    '@settings/POST_UPDATE_CHECKOUT_THEME_SUCCESS',
  POST_UPDATE_CHECKOUT_THEME_FAILURE:
    '@settings/POST_UPDATE_CHECKOUT_THEME_FAILURE',
  POST_UPDATE_CHECKOUT_THEME_CLEAR:
    '@settings/POST_UPDATE_CHECKOUT_THEME_CLEAR',

  // Transactions / Get Listing
  GET_TRANSACTION_LIST: '@payment/GET_TRANSACTION_LIST',
  GET_TRANSACTION_LIST_REQUEST: '@payment/GET_TRANSACTION_LIST_REQUEST',
  GET_TRANSACTION_LIST_SUCCESS: '@payment/GET_TRANSACTION_LIST_SUCCESS',
  GET_TRANSACTION_LIST_FAILURE: '@payment/GET_TRANSACTION_LIST_FAILURE',
  GET_TRANSACTION_LIST_CLEAR: '@payment/GET_TRANSACTION_LIST_CLEAR',

  // Order / Get Listing
  GET_V3_ORDER_LIST: '@payment/GET_V3_ORDER_LIST',
  GET_V3_ORDER_LIST_REQUEST: '@payment/GET_V3_ORDER_LIST_REQUEST',
  GET_V3_ORDER_LIST_SUCCESS: '@payment/GET_V3_ORDER_LIST_SUCCESS',
  GET_V3_ORDER_LIST_FAILURE: '@payment/GET_V3_ORDER_LIST_FAILURE',
  GET_V3_ORDER_LIST_CLEAR: '@payment/GET_V3_ORDER_LIST_CLEAR',

  // Order Level Summary
  GET_ORDER_LEVEL_SUMMARY: '@payment/GET_ORDER_LEVEL_SUMMARY',
  GET_ORDER_LEVEL_SUMMARY_REQUEST: '@payment/GET_ORDER_LEVEL_SUMMARY_REQUEST',
  GET_ORDER_LEVEL_SUMMARY_SUCCESS: '@payment/GET_ORDER_LEVEL_SUMMARY_SUCCESS',
  GET_ORDER_LEVEL_SUMMARY_FAILURE: '@payment/GET_ORDER_LEVEL_SUMMARY_FAILURE',
  GET_ORDER_LEVEL_SUMMARY_CLEAR: '@payment/GET_ORDER_LEVEL_SUMMARY_CLEAR',

  // PACB Upload Invoice
  PACB_UPLOAD_INVOICE: '@payment/PACB_UPLOAD_INVOICE',
  PACB_UPLOAD_INVOICE_REQUEST: '@payment/PACB_UPLOAD_INVOICE_REQUEST',
  PACB_UPLOAD_INVOICE_SUCCESS: '@payment/PACB_UPLOAD_INVOICE_SUCCESS',
  PACB_UPLOAD_INVOICE_FAILURE: '@payment/PACB_UPLOAD_INVOICE_FAILURE',
  PACB_UPLOAD_INVOICE_CLEAR: '@payment/PACB_UPLOAD_INVOICE_CLEAR',

  // PACB Get Invoice Status
  PACB_GET_INVOICE_STATUS: '@payment/PACB_GET_INVOICE_STATUS',
  PACB_GET_INVOICE_STATUS_REQUEST: '@payment/PACB_GET_INVOICE_STATUS_REQUEST',
  PACB_GET_INVOICE_STATUS_SUCCESS: '@payment/PACB_GET_INVOICE_STATUS_SUCCESS',
  PACB_GET_INVOICE_STATUS_FAILURE: '@payment/PACB_GET_INVOICE_STATUS_FAILURE',
  PACB_GET_INVOICE_STATUS_CLEAR: '@payment/PACB_GET_INVOICE_STATUS_CLEAR',

  // PACB Upload AWB
  PACB_UPLOAD_AWB: '@payment/PACB_UPLOAD_AWB',
  PACB_UPLOAD_AWB_REQUEST: '@payment/PACB_UPLOAD_AWB_REQUEST',
  PACB_UPLOAD_AWB_SUCCESS: '@payment/PACB_UPLOAD_AWB_SUCCESS',
  PACB_UPLOAD_AWB_FAILURE: '@payment/PACB_UPLOAD_AWB_FAILURE',
  PACB_UPLOAD_AWB_CLEAR: '@payment/PACB_UPLOAD_AWB_CLEAR',

  // PACB Get AWB Status
  PACB_GET_AWB_STATUS: '@payment/PACB_GET_AWB_STATUS',
  PACB_GET_AWB_STATUS_REQUEST: '@payment/PACB_GET_AWB_STATUS_REQUEST',
  PACB_GET_AWB_STATUS_SUCCESS: '@payment/PACB_GET_AWB_STATUS_SUCCESS',
  PACB_GET_AWB_STATUS_FAILURE: '@payment/PACB_GET_AWB_STATUS_FAILURE',
  PACB_GET_AWB_STATUS_CLEAR: '@payment/PACB_GET_AWB_STATUS_CLEAR',

  // PACB Bulk Upload Payment Details
  PACB_BULK_UPLOAD: '@payment/PACB_BULK_UPLOAD',
  PACB_BULK_UPLOAD_REQUEST: '@payment/PACB_BULK_UPLOAD_REQUEST',
  PACB_BULK_UPLOAD_SUCCESS: '@payment/PACB_BULK_UPLOAD_SUCCESS',
  PACB_BULK_UPLOAD_FAILURE: '@payment/PACB_BULK_UPLOAD_FAILURE',
  PACB_BULK_UPLOAD_CLEAR: '@payment/PACB_BULK_UPLOAD_CLEAR',

  // PACB Bulk Upload History
  PACB_BULK_UPLOAD_HISTORY: '@payment/PACB_BULK_UPLOAD_HISTORY',
  PACB_BULK_UPLOAD_HISTORY_REQUEST: '@payment/PACB_BULK_UPLOAD_HISTORY_REQUEST',
  PACB_BULK_UPLOAD_HISTORY_SUCCESS: '@payment/PACB_BULK_UPLOAD_HISTORY_SUCCESS',
  PACB_BULK_UPLOAD_HISTORY_FAILURE: '@payment/PACB_BULK_UPLOAD_HISTORY_FAILURE',
  PACB_BULK_UPLOAD_HISTORY_CLEAR: '@payment/PACB_BULK_UPLOAD_HISTORY_CLEAR',

  // Order Summary Metrics
  GET_ORDER_SUMMARY_METRICS: '@payment/GET_ORDER_SUMMARY_METRICS',
  GET_ORDER_SUMMARY_METRICS_REQUEST: '@payment/GET_ORDER_SUMMARY_METRICS_REQUEST',
  GET_ORDER_SUMMARY_METRICS_SUCCESS: '@payment/GET_ORDER_SUMMARY_METRICS_SUCCESS',
  GET_ORDER_SUMMARY_METRICS_FAILURE: '@payment/GET_ORDER_SUMMARY_METRICS_FAILURE',
  GET_ORDER_SUMMARY_METRICS_CLEAR: '@payment/GET_ORDER_SUMMARY_METRICS_CLEAR',

  // Settlement Details
  GET_SETTLEMENT_DETAILS: '@payment/GET_SETTLEMENT_DETAILS',
  GET_SETTLEMENT_DETAILS_REQUEST: '@payment/GET_SETTLEMENT_DETAILS_REQUEST',
  GET_SETTLEMENT_DETAILS_SUCCESS: '@payment/GET_SETTLEMENT_DETAILS_SUCCESS',
  GET_SETTLEMENT_DETAILS_FAILURE: '@payment/GET_SETTLEMENT_DETAILS_FAILURE',
  GET_SETTLEMENT_DETAILS_CLEAR: '@payment/GET_SETTLEMENT_DETAILS_CLEAR',

  // Order Details
  GET_ORDER_DETAILS: '@payment/GET_ORDER_DETAILS',
  GET_ORDER_DETAILS_REQUEST: '@payment/GET_ORDER_DETAILS_REQUEST',
  GET_ORDER_DETAILS_SUCCESS: '@payment/GET_ORDER_DETAILS_SUCCESS',
  GET_ORDER_DETAILS_FAILURE: '@payment/GET_ORDER_DETAILS_FAILURE',
  GET_ORDER_DETAILS_CLEAR: '@payment/GET_ORDER_DETAILS_CLEAR',

  // Order Refund Settlement (for timeline)
  GET_ORDER_REFUND_SETTLEMENT: '@payment/GET_ORDER_REFUND_SETTLEMENT',
  GET_ORDER_REFUND_SETTLEMENT_REQUEST: '@payment/GET_ORDER_REFUND_SETTLEMENT_REQUEST',
  GET_ORDER_REFUND_SETTLEMENT_SUCCESS: '@payment/GET_ORDER_REFUND_SETTLEMENT_SUCCESS',
  GET_ORDER_REFUND_SETTLEMENT_FAILURE: '@payment/GET_ORDER_REFUND_SETTLEMENT_FAILURE',
  GET_ORDER_REFUND_SETTLEMENT_CLEAR: '@payment/GET_ORDER_REFUND_SETTLEMENT_CLEAR',

  // Order / Get Orrder Details
  GET_V3_ORDER_DETAILS: '@payment/GET_V3_ORDER_DETAILS',
  GET_V3_ORDER_DETAILS_REQUEST: '@payment/GET_V3_ORDER_DETAILS_REQUEST',
  GET_V3_ORDER_DETAILS_SUCCESS: '@payment/GET_V3_ORDER_DETAILS_SUCCESS',
  GET_V3_ORDER_DETAILS_FAILURE: '@payment/GET_V3_ORDER_DETAILS_FAILURE',
  GET_V3_ORDER_DETAILS_CLEAR: '@payment/GET_V3_ORDER_DETAILS_CLEAR',

  //MPR
  GET_EDGE_MPR_LIST: '@payment/GET_EDGE_MPR_LIST',
  GET_EDGE_MPR_LIST_REQUEST: '@payment/GET_EDGE_MPR_LIST_REQUEST',
  GET_EDGE_MPR_LIST_SUCCESS: '@payment/GET_EDGE_MPR_LIST_SUCCESS',
  GET_EDGE_MPR_LIST_FAILURE: '@payment/GET_EDGE_MPR_LIST_FAILURE',
  GET_EDGE_MPR_LIST_CLEAR: '@payment/GET_EDGE_MPR_LIST_CLEAR',

  GET_TRANSACTION_FILTER_LIST: '@payment/GET_TRANSACTION_FILTER_LIST',
  GET_TRANSACTION_FILTER_LIST_REQUEST:
    '@payment/GET_TRANSACTION_FILTER_LIST_REQUEST',
  GET_TRANSACTION_FILTER_LIST_SUCCESS:
    '@payment/GET_TRANSACTION_FILTER_LIST_SUCCESS',
  GET_TRANSACTION_FILTER_LIST_FAILURE:
    '@payment/GET_TRANSACTION_FILTER_LIST_FAILURE',
  GET_TRANSACTION_FILTER_LIST_CLEAR:
    '@payment/GET_TRANSACTION_FILTER_LIST_CLEAR',

  GET_WALLET_NAME_FILTER_LIST: '@payment/GET_WALLET_NAME_FILTER_LIST',
  GET_WALLET_NAME_FILTER_LIST_REQUEST:
    '@payment/GET_WALLET_NAME_FILTER_LIST_REQUEST',
  GET_WALLET_NAME_FILTER_LIST_SUCCESS:
    '@payment/GET_WALLET_NAME_FILTER_LIST_SUCCESS',
  GET_WALLET_NAME_FILTER_LIST_FAILURE:
    '@payment/GET_WALLET_NAME_FILTER_LIST_FAILURE',
  GET_WALLET_NAME_FILTER_LIST_CLEAR:
    '@payment/GET_WALLET_NAME_FILTER_LIST_CLEAR',

  GET_TRANSACTION_DETAILS: '@payment/GET_TRANSACTION_DETAILS',
  GET_TRANSACTION_DETAILS_REQUEST: '@payment/GET_TRANSACTION_DETAILS_REQUEST',
  GET_TRANSACTION_DETAILS_SUCCESS: '@payment/GET_TRANSACTION_DETAILS_SUCCESS',
  GET_TRANSACTION_DETAILS_FAILURE: '@payment/GET_TRANSACTION_DETAILS_FAILURE',
  GET_TRANSACTION_DETAILS_CLEAR: '@payment/GET_TRANSACTION_DETAILS_CLEAR',

  // Payment / Get Listing
  GET_PAYMENT_LIST: '@payment/GET_PAYMENT_LIST',
  GET_PAYMENT_LIST_REQUEST: '@payment/GET_PAYMENT_LIST_REQUEST',
  GET_PAYMENT_LIST_SUCCESS: '@payment/GET_PAYMENT_LIST_SUCCESS',
  GET_PAYMENT_LIST_FAILURE: '@payment/GET_PAYMENT_LIST_FAILURE',
  GET_PAYMENT_LIST_CLEAR: '@payment/GET_PAYMENT_LIST_CLEAR',

  // Payment / Order Details
  GET_PAYMENT_ORDER_DETAILS: '@payment/GET_PAYMENT_ORDER_DETAILS',
  GET_PAYMENT_ORDER_DETAILS_REQUEST:
    '@payment/GET_PAYMENT_ORDER_DETAILS_REQUEST',
  GET_PAYMENT_ORDER_DETAILS_SUCCESS:
    '@payment/GET_PAYMENT_ORDER_DETAILS_SUCCESS',
  GET_PAYMENT_ORDER_DETAILS_FAILURE:
    '@payment/GET_PAYMENT_ORDER_DETAILS_FAILURE',
  GET_PAYMENT_ORDER_DETAILS_CLEAR: '@payment/GET_PAYMENT_ORDER_DETAILS_CLEAR',

  GET_ALL_ORDER_STATUS_LIST: '@payment/GET_ALL_ORDER_STATUS_LIST',
  GET_ALL_ORDER_STATUS_LIST_REQUEST:
    '@payment/GET_ALL_ORDER_STATUS_LIST_REQUEST',
  GET_ALL_ORDER_STATUS_LIST_SUCCESS:
    '@payment/GET_ALL_ORDER_STATUS_LIST_SUCCESS',
  GET_ALL_ORDER_STATUS_LIST_FAILURE:
    '@payment/GET_ALL_ORDER_STATUS_LIST_FAILURE',
  GET_ALL_ORDER_STATUS_LIST_CLEAR: '@payment/GET_ALL_ORDER_STATUS_LIST_CLEAR',

  GET_ALL_GATEWAYS_LIST: '@payment/GET_ALL_GATEWAYS_LIST',
  GET_ALL_GATEWAYS_LIST_REQUEST: '@payment/GET_ALL_GATEWAYS_LIST_REQUEST',
  GET_ALL_GATEWAYS_LIST_SUCCESS: '@payment/GET_ALL_GATEWAYS_LIST_SUCCESS',
  GET_ALL_GATEWAYS_LIST_FAILURE: '@payment/GET_ALL_GATEWAYS_LIST_FAILURE',
  GET_ALL_GATEWAYS_LIST_CLEAR: '@payment/GET_ALL_GATEWAYS_LIST_CLEAR',

  // Payment Side Modal / Get EMI and Product Details for an EMI txn
  GET_EMI_PRODUCT_DETAILS: '@payment/GET_EMI_PRODUCT_DETAILS',
  GET_EMI_PRODUCT_DETAILS_REQUEST: '@payment/GET_EMI_PRODUCT_DETAILS_REQUEST',
  GET_EMI_PRODUCT_DETAILS_SUCCESS: '@payment/GET_EMI_PRODUCT_DETAILS_SUCCESS',
  GET_EMI_PRODUCT_DETAILS_FAILURE: '@payment/GET_EMI_PRODUCT_DETAILS_FAILURE',
  GET_EMI_PRODUCT_DETAILS_CLEAR: '@payment/GET_EMI_PRODUCT_DETAILS_CLEAR',

  // Refund Side Modal / Get EMI and Product Details for an EMI txn
  GET_EMI_PRODUCT_DETAILS_FOR_REFUND:
    '@refund/GET_EMI_PRODUCT_DETAILS_FOR_REFUND',
  GET_EMI_PRODUCT_DETAILS_FOR_REFUND_REQUEST:
    '@refund/GET_EMI_PRODUCT_DETAILS_FOR_REFUND_REQUEST',
  GET_EMI_PRODUCT_DETAILS_FOR_REFUND_SUCCESS:
    '@refund/GET_EMI_PRODUCT_DETAILS_FOR_REFUND_SUCCESS',
  GET_EMI_PRODUCT_DETAILS_FOR_REFUND_FAILURE:
    '@refund/GET_EMI_PRODUCT_DETAILS_FOR_REFUND_FAILURE',
  GET_EMI_PRODUCT_DETAILS_FOR_REFUND_CLEAR:
    '@refund/GET_EMI_PRODUCT_DETAILS_FOR_REFUND_CLEAR',

  // Refund / Get Listing
  GET_REFUND_LIST: '@refund/GET_REFUND_LIST',
  GET_REFUND_LIST_REQUEST: '@refund/GET_REFUND_LIST_REQUEST',
  GET_REFUND_LIST_SUCCESS: '@refund/GET_REFUND_LIST_SUCCESS',
  GET_REFUND_LIST_FAILURE: '@refund/GET_REFUND_LIST_FAILURE',
  GET_REFUND_LIST_CLEAR: '@refund/GET_REFUND_LIST_CLEAR',

  // Refund / Get Listing
  GET_REF_FILE_REFUND_LIST: '@refund/GET_REF_FILE_REFUND_LIST',
  GET_REF_FILE_REFUND_LIST_REQUEST: '@refund/GET_REF_FILE_REFUND_LIST_REQUEST',
  GET_REF_FILE_REFUND_LIST_SUCCESS: '@refund/GET_REF_FILE_REFUND_LIST_SUCCESS',
  GET_REF_FILE_REFUND_LIST_FAILURE: '@refund/GET_REF_FILE_REFUND_LIST_FAILURE',
  GET_REF_FILE_REFUND_LIST_CLEAR: '@refund/GET_REF_FILE_REFUND_LIST_CLEAR',

   // Refund / Get Listing
   GET_REFUND_DETAIL: '@refund/GET_REFUND_DETAIL',
   GET_REFUND_DETAIL_REQUEST: '@refund/GET_REFUND_DETAIL_REQUEST',
   GET_REFUND_DETAIL_SUCCESS: '@refund/GET_REFUND_DETAIL_SUCCESS',
   GET_REFUND_DETAIL_FAILURE: '@refund/GET_REFUND_DETAIL_FAILURE',
   GET_REFUND_DETAIL_CLEAR: '@refund/GET_REFUND_DETAIL_CLEAR',

  // Refund / create Refund
  POST_CREATE_REFUND: '@refund/POST_CREATE_REFUND',
  POST_CREATE_REFUND_REQUEST: '@refund/POST_CREATE_REFUND_REQUEST',
  POST_CREATE_REFUND_SUCCESS: '@refund/POST_CREATE_REFUND_SUCCESS',
  POST_CREATE_REFUND_FAILURE: '@refund/POST_CREATE_REFUND_FAILURE',
  POST_CREATE_REFUND_CLEAR: '@refund/POST_CREATE_REFUND_CLEAR',
  // Refund / Get Bulk Upload History Listing
  GET_REFUND_BULK_UPLOAD_HISTORY_LIST:
    '@refund/GET_REFUND_BULK_UPLOAD_HISTORY_LIST',
  GET_REFUND_BULK_UPLOAD_HISTORY_LIST_REQUEST:
    '@refund/GET_REFUND_BULK_UPLOAD_HISTORY_LIST_REQUEST',
  GET_REFUND_BULK_UPLOAD_HISTORY_LIST_SUCCESS:
    '@refund/GET_REFUND_BULK_UPLOAD_HISTORY_LIST_SUCCESS',
  GET_REFUND_BULK_UPLOAD_HISTORY_LIST_FAILURE:
    '@refund/GET_REFUND_BULK_UPLOAD_HISTORY_LIST_FAILURE',
  GET_REFUND_BULK_UPLOAD_HISTORY_LIST_CLEAR:
    '@refund/GET_REFUND_BULK_UPLOAD_HISTORY_LIST_CLEAR',

  // Refund / Get Bulk Upload History Listing
  GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST:
    '@refund/GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST',
  GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST_REQUEST:
    '@refund/GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST_REQUEST',
  GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST_SUCCESS:
    '@refund/GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST_SUCCESS',
  GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST_FAILURE:
    '@refund/GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST_FAILURE',
  GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST_CLEAR:
    '@refund/GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST_CLEAR',

  // IMEI / Get Bulk Upload History Listing
  GET_IMEI_BULK_UPLOAD_HISTORY_LIST: '@imei/GET_IMEI_BULK_UPLOAD_HISTORY_LIST',
  GET_IMEI_BULK_UPLOAD_HISTORY_LIST_REQUEST:
    '@imei/GET_IMEI_BULK_UPLOAD_HISTORY_LIST_REQUEST',
  GET_IMEI_BULK_UPLOAD_HISTORY_LIST_SUCCESS:
    '@imei/GET_IMEI_BULK_UPLOAD_HISTORY_LIST_SUCCESS',
  GET_IMEI_BULK_UPLOAD_HISTORY_LIST_FAILURE:
    '@imei/GET_IMEI_BULK_UPLOAD_HISTORY_LIST_FAILURE',
  GET_IMEI_BULK_UPLOAD_HISTORY_LIST_CLEAR:
    '@imei/GET_IMEI_BULK_UPLOAD_HISTORY_LIST_CLEAR',

  // IMEI / Get imei details
  GET_IMEI_DETAILS: '@imei/GET_IMEI_DETAILS',
  GET_IMEI_DETAILS_REQUEST: '@imei/GET_IMEI_DETAILS_REQUEST',
  GET_IMEI_DETAILS_SUCCESS: '@imei/GET_IMEI_DETAILS_SUCCESS',
  GET_IMEI_DETAILS_FAILURE: '@imei/GET_IMEI_DETAILS_FAILURE',
  GET_IMEI_DETAILS_CLEAR: '@imei/GET_IMEI_DETAILS_CLEAR',

  // IMEI / Post validate IMEI
  POST_VALIDATE_IMEI: '@imei/POST_VALIDATE_IMEI',
  POST_VALIDATE_IMEI_REQUEST: '@imei/POST_VALIDATE_IMEI_REQUEST',
  POST_VALIDATE_IMEI_SUCCESS: '@imei/POST_VALIDATE_IMEI_SUCCESS',
  POST_VALIDATE_IMEI_FAILURE: '@imei/POST_VALIDATE_IMEI_FAILURE',
  POST_VALIDATE_IMEI_CLEAR: '@imei/POST_VALIDATE_IMEI_CLEAR',

  // IMEI / Get Listing
  GET_REF_FILE_IMEI_LIST: '@refund/GET_REF_FILE_IMEI_LIST',
  GET_REF_FILE_IMEI_LIST_REQUEST: '@refund/GET_REF_FILE_IMEI_LIST_REQUEST',
  GET_REF_FILE_IMEI_LIST_SUCCESS: '@refund/GET_REF_FILE_IMEI_LIST_SUCCESS',
  GET_REF_FILE_IMEI_LIST_FAILURE: '@refund/GET_REF_FILE_IMEI_LIST_FAILURE',
  GET_REF_FILE_IMEI_LIST_CLEAR: '@refund/GET_REF_FILE_IMEI_LIST_CLEAR',

  // Overview/ Get Today Transactions Data
  GET_TODAY_TRANSACTIONS_DATA: '@overview/GET_TODAY_TRANSACTIONS_DATA',
  GET_TODAY_TRANSACTIONS_DATA_REQUEST:
    '@overview/GET_TODAY_TRANSACTIONS_DATA_REQUEST',
  GET_TODAY_TRANSACTIONS_DATA_SUCCESS:
    '@overview/GET_TODAY_TRANSACTIONS_DATA_SUCCESS',
  GET_TODAY_TRANSACTIONS_DATA_FAILURE:
    '@overview/GET_TODAY_TRANSACTIONS_DATA_FAILURE',
  GET_TODAY_TRANSACTIONS_DATA_CLEAR:
    '@overview/GET_TODAY_TRANSACTIONS_DATA_CLEAR',

  // Overview/ Get Today Transactions Data
  GET_EDGE_TODAY_TRANSACTIONS_DATA:
    '@overview/GET_EDGE_TODAY_TRANSACTIONS_DATA',
  GET_EDGE_TODAY_TRANSACTIONS_DATA_REQUEST:
    '@overview/GET_EDGE_TODAY_TRANSACTIONS_DATA_REQUEST',
  GET_EDGE_TODAY_TRANSACTIONS_DATA_SUCCESS:
    '@overview/GET_EDGE_TODAY_TRANSACTIONS_DATA_SUCCESS',
  GET_EDGE_TODAY_TRANSACTIONS_DATA_FAILURE:
    '@overview/GET_EDGE_TODAY_TRANSACTIONS_DATA_FAILURE',
  GET_EDGE_TODAY_TRANSACTIONS_DATA_CLEAR:
    '@overview/GET_EDGE_TODAY_TRANSACTIONS_DATA_CLEAR',

  // Overview/ Get Today Transactions Data
  GET_OVERVIEW_DATA: '@overview/GET_OVERVIEW_DATA',
  GET_OVERVIEW_DATA_REQUEST: '@overview/GET_OVERVIEW_DATA_REQUEST',
  GET_OVERVIEW_DATA_SUCCESS: '@overview/GET_OVERVIEW_DATA_SUCCESS',
  GET_OVERVIEW_DATA_FAILURE: '@overview/GET_OVERVIEW_DATA_FAILURE',
  GET_OVERVIEW_DATA_CLEAR: '@overview/GET_OVERVIEW_DATA_CLEAR',

  // Beta toggle api

  GET_BETA_TOGGLE: '@overview/GET_BETA_TOGGLE',
  GET_BETA_TOGGLE_REQUEST: '@overview/GET_BETA_TOGGLE_REQUEST',
  GET_BETA_TOGGLE_SUCCESS: '@overview/GET_BETA_TOGGLE_SUCCESS',
  GET_BETA_TOGGLE_FAILURE: '@overview/GET_BETA_TOGGLE_FAILURE',
  CLEAR_BETA_TOGGLE_STATE: '@overview/CLEAR_BETA_TOGGLE_STATE',

  // Overview/ Get Today Transactions Data
  GET_EDGE_OVERVIEW_DATA: '@overview/GET_EDGE_OVERVIEW_DATA',
  GET_EDGE_OVERVIEW_DATA_REQUEST: '@overview/GET_EDGE_OVERVIEW_DATA_REQUEST',
  GET_EDGE_OVERVIEW_DATA_SUCCESS: '@overview/GET_EDGE_OVERVIEW_DATA_SUCCESS',
  GET_EDGE_OVERVIEW_DATA_FAILURE: '@overview/GET_EDGE_OVERVIEW_DATA_FAILURE',
  GET_EDGE_OVERVIEW_DATA_CLEAR: '@overview/GET_EDGE_OVERVIEW_DATA_CLEAR',

  GET_SETTLEMENTS_OVERVIEW_DATA: '@overview/GET_SETTLEMENTS_OVERVIEW_DATA',
  GET_SETTLEMENTS_OVERVIEW_DATA_REQUEST:
    '@overview/GET_SETTLEMENTS_OVERVIEW_DATA_REQUEST',
  GET_SETTLEMENTS_OVERVIEW_DATA_SUCCESS:
    '@overview/GET_SETTLEMENTS_OVERVIEW_DATA_SUCCESS',
  GET_SETTLEMENTS_OVERVIEW_DATA_FAILURE:
    '@overview/GET_SETTLEMENTS_OVERVIEW_DATA_FAILURE',
  GET_SETTLEMENTS_OVERVIEW_DATA_CLEAR:
    '@overview/GET_SETTLEMENTS_OVERVIEW_DATA_CLEAR',

  GET_EDGE_SETTLEMENTS_OVERVIEW_DATA:
    '@overview/GET_EDGE_SETTLEMENTS_OVERVIEW_DATA',
  GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_REQUEST:
    '@overview/GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_REQUEST',
  GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_SUCCESS:
    '@overview/GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_SUCCESS',
  GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_FAILURE:
    '@overview/GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_FAILURE',
  GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_CLEAR:
    '@overview/GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_CLEAR',

  // Settlement/ Get Today Transactions Data
  GET_SETTLEMENT_DATA: '@settlement/GET_SETTLEMENT_DATA',
  GET_SETTLEMENT_DATA_REQUEST: '@settlement/GET_SETTLEMENT_DATA_REQUEST',
  GET_SETTLEMENT_DATA_SUCCESS: '@settlement/GET_SETTLEMENT_DATA_SUCCESS',
  GET_SETTLEMENT_DATA_FAILURE: '@settlement/GET_SETTLEMENT_DATA_FAILURE',
  GET_SETTLEMENT_DATA_CLEAR: '@settlement/GET_SETTLEMENT_DATA_CLEAR',

  // EDGE Settlement/ Get Today Transactions Data
  GET_EDGE_SETTLEMENT_DATA: '@settlement/GET_EDGE_SETTLEMENT_DATA',
  GET_EDGE_SETTLEMENT_DATA_REQUEST:
    '@settlement/GET_EDGE_SETTLEMENT_DATA_REQUEST',
  GET_EDGE_SETTLEMENT_DATA_SUCCESS:
    '@settlement/GET_EDGE_SETTLEMENT_DATA_SUCCESS',
  GET_EDGE_SETTLEMENT_DATA_FAILURE:
    '@settlement/GET_EDGE_SETTLEMENT_DATA_FAILURE',
  GET_EDGE_SETTLEMENT_DATA_CLEAR: '@settlement/GET_EDGE_SETTLEMENT_DATA_CLEAR',

  // EDGE Settlement/ Settlement List
  GET_EDGE_SETTLEMENT_LIST: '@settlement/GET_EDGE_SETTLEMENT_LIST',
  GET_EDGE_SETTLEMENT_LIST_REQUEST:
    '@settlement/GET_EDGE_SETTLEMENT_LIST_REQUEST',
  GET_EDGE_SETTLEMENT_LIST_SUCCESS:
    '@settlement/GET_EDGE_SETTLEMENT_LIST_SUCCESS',
  GET_EDGE_SETTLEMENT_LIST_FAILURE:
    '@settlement/GET_EDGE_SETTLEMENT_LIST_FAILURE',
  GET_EDGE_SETTLEMENT_LIST_CLEAR: '@settlement/GET_EDGE_SETTLEMENT_LIST_CLEAR',

  // Disputes / Chargebacks
  GET_DISPUTE_LIST: '@disputes/GET_DISPUTE_LIST',
  GET_DISPUTE_LIST_REQUEST: '@disputes/GET_DISPUTE_LIST_REQUEST',
  GET_DISPUTE_LIST_SUCCESS: '@disputes/GET_DISPUTE_LIST_SUCCESS',
  GET_DISPUTE_LIST_FAILURE: '@disputes/GET_DISPUTE_LIST_FAILURE',
  GET_DISPUTE_LIST_CLEAR: '@disputes/GET_DISPUTE_LIST_CLEAR',
  GET_DISPUTE_DOCUMENT_CONFIG: '@disputes/GET_DISPUTE_DOCUMENT_CONFIG',
  GET_DISPUTE_DOCUMENT_CONFIG_SUCCESS: '@disputes/GET_DISPUTE_DOCUMENT_CONFIG_SUCCESS',
  GET_DISPUTE_DOCUMENT_CONFIG_FAILURE: '@disputes/GET_DISPUTE_DOCUMENT_CONFIG_FAILURE',
  GET_DISPUTE_DOCUMENT_CONFIG_REQUEST: '@disputes/GET_DISPUTE_DOCUMENT_CONFIG_REQUEST',

  GET_DISPUTE_DETAILS: '@disputes/GET_DISPUTE_DETAILS',
  GET_DISPUTE_DETAILS_REQUEST: '@disputes/GET_DISPUTE_DETAILS_REQUEST',
  GET_DISPUTE_DETAILS_SUCCESS: '@disputes/GET_DISPUTE_DETAILS_SUCCESS',
  GET_DISPUTE_DETAILS_FAILURE: '@disputes/GET_DISPUTE_DETAILS_FAILURE',
  GET_DISPUTE_DETAILS_CLEAR: '@disputes/GET_DISPUTE_DETAILS_CLEAR',
  GET_DISPUTE_ORDER_DETAILS_V3: '@disputes/GET_DISPUTE_ORDER_DETAILS_V3',
  GET_DISPUTE_ORDER_DETAILS_V3_REQUEST:
    '@disputes/GET_DISPUTE_ORDER_DETAILS_V3_REQUEST',
  GET_DISPUTE_ORDER_DETAILS_V3_SUCCESS:
    '@disputes/GET_DISPUTE_ORDER_DETAILS_V3_SUCCESS',
  GET_DISPUTE_ORDER_DETAILS_V3_FAILURE:
    '@disputes/GET_DISPUTE_ORDER_DETAILS_V3_FAILURE',
  GET_DISPUTE_ORDER_DETAILS_V3_CLEAR:
    '@disputes/GET_DISPUTE_ORDER_DETAILS_V3_CLEAR',
  GET_DISPUTE_ORDER_LIST_V3: '@disputes/GET_DISPUTE_ORDER_LIST_V3',
  GET_DISPUTE_ORDER_LIST_V3_REQUEST:
    '@disputes/GET_DISPUTE_ORDER_LIST_V3_REQUEST',
  GET_DISPUTE_ORDER_LIST_V3_SUCCESS:
    '@disputes/GET_DISPUTE_ORDER_LIST_V3_SUCCESS',
  GET_DISPUTE_ORDER_LIST_V3_FAILURE:
    '@disputes/GET_DISPUTE_ORDER_LIST_V3_FAILURE',
  GET_DISPUTE_ORDER_LIST_V3_CLEAR:
    '@disputes/GET_DISPUTE_ORDER_LIST_V3_CLEAR',

  // Dispute Filters State Management
  SET_DISPUTE_FILTERS: '@disputes/SET_DISPUTE_FILTERS',
  CLEAR_DISPUTE_FILTERS: '@disputes/CLEAR_DISPUTE_FILTERS',

  // Chargeback Defend Modal State Management
  SET_CHARGEBACK_DEFEND_MODAL: '@disputes/SET_CHARGEBACK_DEFEND_MODAL',
  CLEAR_CHARGEBACK_DEFEND_MODAL: '@disputes/CLEAR_CHARGEBACK_DEFEND_MODAL',

  //Upload Chargeback Document
  UPLOAD_CHARGEBACK_DOCUMENT: '@disputes/UPLOAD_CHARGEBACK_DOCUMENT',
  UPLOAD_CHARGEBACK_DOCUMENT_REQUEST: '@disputes/UPLOAD_CHARGEBACK_DOCUMENT_REQUEST',
  UPLOAD_CHARGEBACK_DOCUMENT_SUCCESS: '@disputes/UPLOAD_CHARGEBACK_DOCUMENT_SUCCESS',
  UPLOAD_CHARGEBACK_DOCUMENT_FAILURE: '@disputes/UPLOAD_CHARGEBACK_DOCUMENT_FAILURE',
  UPLOAD_CHARGEBACK_DOCUMENT_CLEAR: '@disputes/UPLOAD_CHARGEBACK_DOCUMENT_CLEAR',

  //Reupload Chargeback Document
  REUPLOAD_CHARGEBACK_DOCUMENT: '@disputes/REUPLOAD_CHARGEBACK_DOCUMENT',
  REUPLOAD_CHARGEBACK_DOCUMENT_REQUEST: '@disputes/REUPLOAD_CHARGEBACK_DOCUMENT_REQUEST',
  REUPLOAD_CHARGEBACK_DOCUMENT_SUCCESS: '@disputes/REUPLOAD_CHARGEBACK_DOCUMENT_SUCCESS',
  REUPLOAD_CHARGEBACK_DOCUMENT_FAILURE: '@disputes/REUPLOAD_CHARGEBACK_DOCUMENT_FAILURE',
  REUPLOAD_CHARGEBACK_DOCUMENT_CLEAR: '@disputes/REUPLOAD_CHARGEBACK_DOCUMENT_CLEAR',
  GET_DISPUTES_FEATURE_FLAG: '@disputes/GET_DISPUTES_FEATURE_FLAG',
  GET_DISPUTES_FEATURE_FLAG_REQUEST: '@disputes/GET_DISPUTES_FEATURE_FLAG_REQUEST',
  GET_DISPUTES_FEATURE_FLAG_SUCCESS: '@disputes/GET_DISPUTES_FEATURE_FLAG_SUCCESS',
  GET_DISPUTES_FEATURE_FLAG_FAILURE: '@disputes/GET_DISPUTES_FEATURE_FLAG_FAILURE',
  // Merchant Search
  SETTLEMENTS_SEARCH: '@merchant-listing/SETTLEMENTS_SEARCH',
  SETTLEMENTS_SEARCH_REQUEST: '@merchant-listing/SETTLEMENTS_SEARCH_REQUEST',
  SETTLEMENTS_SEARCH_SUCCESS: '@merchant-listing/SETTLEMENTS_SEARCH_SUCCESS',
  SETTLEMENTS_SEARCH_FAILURE: '@merchant-listing/SETTLEMENTS_SEARCH_FAILURE',
  SETTLEMENTS_SEARCH_CLEAR: '@merchant-listing/SETTLEMENTS_SEARCH_CLEAR',

  // EDGE Settlement/ Overview Data
  GET_EDGE_SETTLEMENT_OVERVIEW_DATA: '@settlement/GET_EDGE_SETTLEMENT_DATA_OVERVIEW_DATA',
  GET_EDGE_SETTLEMENT_DATA_OVERVIEW_REQUEST:
    '@settlement/GET_EDGE_SETTLEMENT_DATA_OVERVIEW_REQUEST',
  GET_EDGE_SETTLEMENT_DATA_OVERVIEW_SUCCESS:
    '@settlement/GET_EDGE_SETTLEMENT_DATA_OVERVIEW_SUCCESS',
  GET_EDGE_SETTLEMENT_DATA_OVERVIEW_FAILURE:
    '@settlement/GET_EDGE_SETTLEMENT_DATA_OVERVIEW_FAILURE',
  GET_EDGE_SETTLEMENT_DATA_OVERVIEW_CLEAR: '@settlement/GET_EDGE_SETTLEMENT_DATA_OVERVIEW_CLEAR',

  // Pending Settlements
  GET_PENDING_SETTLEMENTS_LIST: '@settlement/GET_PENDING_SETTLEMENTS_LIST',
  GET_PENDING_SETTLEMENTS_LIST_REQUEST: '@settlement/GET_PENDING_SETTLEMENTS_LIST_REQUEST',
  GET_PENDING_SETTLEMENTS_LIST_SUCCESS: '@settlement/GET_PENDING_SETTLEMENTS_LIST_SUCCESS',
  GET_PENDING_SETTLEMENTS_LIST_FAILURE: '@settlement/GET_PENDING_SETTLEMENTS_LIST_FAILURE',

  // Sidebar
  UPDATE_SIDEBAR_VIEW: '@sidebar/UPDATE_SIDEBAR_VIEW',

  // Payment Links / Get Listing
  GET_PAYMENT_LINKS_LIST: '@payment-link/GET_PAYMENT_LINKS_LIST',
  GET_PAYMENT_LINKS_LIST_REQUEST:
    '@payment-link/GET_PAYMENT_LINKS_LIST_REQUEST',
  GET_PAYMENT_LINKS_LIST_SUCCESS:
    '@payment-link/GET_PAYMENT_LINKS_LIST_SUCCESS',
  GET_PAYMENT_LINKS_LIST_FAILURE:
    '@payment-link/GET_PAYMENT_LINKS_LIST_FAILURE',
  GET_PAYMENT_LINKS_LIST_CLEAR: '@payment-link/GET_PAYMENT_LINKS_LIST_CLEAR',

   // EDGE Payment Links / Get Listing
   GET_EDGE_PAYMENT_LINKS_LIST: '@payment-link/GET_EDGE_PAYMENT_LINKS_LIST',
   GET_EDGE_PAYMENT_LINKS_LIST_REQUEST:
     '@payment-link/GET_EDGE_PAYMENT_LINKS_LIST_REQUEST',
   GET_EDGE_PAYMENT_LINKS_LIST_SUCCESS:
     '@payment-link/GET_EDGE_PAYMENT_LINKS_LIST_SUCCESS',
   GET_EDGE_PAYMENT_LINKS_LIST_FAILURE:
     '@payment-link/GET_EDGE_PAYMENT_LINKS_LIST_FAILURE',
   GET_EDGE_PAYMENT_LINKS_LIST_CLEAR: '@payment-link/GET_EDGE_PAYMENT_LINKS_LIST_CLEAR',

  //  EDGE V3 Payment Links / Get Listing
  GET_EDGE_V3_PAYMENT_LINKS_LIST: '@payment-link/GET_EDGE_V3_PAYMENT_LINKS_LIST',
  GET_EDGE_V3_PAYMENT_LINKS_LIST_REQUEST:
    '@payment-link/GET_EDGE_V3_PAYMENT_LINKS_LIST_REQUEST',
  GET_EDGE_V3_PAYMENT_LINKS_LIST_SUCCESS:
    '@payment-link/GET_EDGE_V3_PAYMENT_LINKS_LIST_SUCCESS',
  GET_EDGE_V3_PAYMENT_LINKS_LIST_FAILURE:
    '@payment-link/GET_EDGE_V3_PAYMENT_LINKS_LIST_FAILURE',
  GET_EDGE_V3_PAYMENT_LINKS_LIST_CLEAR: '@payment-link/GET_EDGE_V3_PAYMENT_LINKS_LIST_CLEAR',


  // Payment Links / Create Payment Link
  MANAGE_PAYMENT_LINK: '@payment-link/MANAGE_PAYMENT_LINK',
  MANAGE_PAYMENT_LINK_REQUEST: '@payment-link/MANAGE_PAYMENT_LINK_REQUEST',
  MANAGE_PAYMENT_LINK_SUCCESS: '@payment-link/MANAGE_PAYMENT_LINK_SUCCESS',
  MANAGE_PAYMENT_LINK_FAILURE: '@payment-link/MANAGE_PAYMENT_LINK_FAILURE',
  MANAGE_PAYMENT_LINK_CLEAR: '@payment-link/MANAGE_PAYMENT_LINK_CLEAR',
 
  //Edge payment links / create payment link
  MANAGE_EDGE_PAYMENT_LINK_REQUEST: '@payment-link/MANAGE_EDGE_PAYMENT_LINK_REQUEST',
  MANAGE_EDGE_PAYMENT_LINK_SUCCESS: '@payment-link/MANAGE_EDGE_PAYMENT_LINK_SUCCESS',
  MANAGE_EDGE_PAYMENT_LINK_FAILURE: '@payment-link/MANAGE_EDGE_PAYMENT_LINK_FAILURE',
  MANAGE_EDGE_PAYMENT_LINK_CLEAR: '@payment-link/ MANAGE_EDGE_PAYMENT_LINK_CLEAR',

  // Payment Links / Get Listing
  GET_EDGE_MERCANT_CONFIG: '@payment-link/GET_EDGE_MERCANT_CONFIG',
  GET_EDGE_MERCANT_CONFIG_REQUEST:
    '@payment-link/GET_EDGE_MERCANT_CONFIG_REQUEST',
  GET_EDGE_MERCANT_CONFIG_SUCCESS:
    '@payment-link/GET_EDGE_MERCANT_CONFIG_SUCCESS',
  GET_EDGE_MERCANT_CONFIG_FAILURE:
    '@payment-link/GET_EDGE_MERCANT_CONFIG_FAILURE',
  GET_EDGE_MERCANT_CONFIG_CLEAR: '@payment-link/GET_EDGE_MERCANT_CONFIG_CLEAR',

  // Payment Links / Cancel Payment Link
  POST_CANCEL_PAYMENT_LINK: '@payment-link/POST_CANCEL_PAYMENT_LINK',
  POST_CANCEL_PAYMENT_LINK_REQUEST:
    '@payment-link/POST_CANCEL_PAYMENT_LINK_REQUEST',
  POST_CANCEL_PAYMENT_LINK_SUCCESS:
    '@payment-link/POST_CANCEL_PAYMENT_LINK_SUCCESS',
  POST_CANCEL_PAYMENT_LINK_FAILURE:
    '@payment-link/POST_CANCEL_PAYMENT_LINK_FAILURE',
  POST_CANCEL_PAYMENT_LINK_CLEAR:
    '@payment-link/POST_CANCEL_PAYMENT_LINK_CLEAR',

  // Payment Links / Get available payment mode list
  GET_AVAILABLE_PAYMENT_MODE_LIST:
    '@payment-link/GET_AVAILABLE_PAYMENT_MODE_LIST',
  GET_AVAILABLE_PAYMENT_MODE_LIST_REQUEST:
    '@payment-link/GET_AVAILABLE_PAYMENT_MODE_LIST_REQUEST',
  GET_AVAILABLE_PAYMENT_MODE_LIST_SUCCESS:
    '@payment-link/GET_AVAILABLE_PAYMENT_MODE_LIST_SUCCESS',
  GET_AVAILABLE_PAYMENT_MODE_LIST_FAILURE:
    '@payment-link/GET_AVAILABLE_PAYMENT_MODE_LIST_FAILURE',

  // Merchant Listing
  GET_MERCHANT_LIST: '@merchant-listing/GET_MERCHANT_LIST',
  GET_MERCHANT_LIST_REQUEST: '@merchant-listing/GET_MERCHANT_LIST_REQUEST',
  GET_MERCHANT_LIST_SUCCESS: '@merchant-listing/GET_MERCHANT_LIST_SUCCESS',
  GET_MERCHANT_LIST_FAILURE: '@merchant-listing/GET_MERCHANT_LIST_FAILURE',
  GET_MERCHANT_LIST_CLEAR: '@merchant-listing/GET_MERCHANT_LIST_CLEAR',

    // Scheduled Reports Delete
    DELETE_SCHEDULED_REPORT: '@reports/DELETE_SCHEDULED_REPORT',
    DELETE_SCHEDULED_REPORT_REQUEST: '@reports/DELETE_SCHEDULED_REPORT_REQUEST',
    DELETE_SCHEDULED_REPORT_SUCCESS: '@reports/DELETE_SCHEDULED_REPORT_SUCCESS',
    DELETE_SCHEDULED_REPORT_FAILURE: '@reports/DELETE_SCHEDULED_REPORT_FAILURE',
    DELETE_SCHEDULED_REPORT_CLEAR: '@reports/DELETE_SCHEDULED_REPORT_CLEAR',

  // Merchant Listing
  GET_MERCHANT_MIGRATION_DATA: '@merchant-listing/GET_MERCHANT_MIGRATION_DATA',
  GET_MERCHANT_MIGRATION_DATA_REQUEST: '@merchant-listing/GET_MERCHANT_MIGRATION_DATA_REQUEST',
  GET_MERCHANT_MIGRATION_DATA_SUCCESS: '@merchant-listing/GET_MERCHANT_MIGRATION_DATA_SUCCESS',
  GET_MERCHANT_MIGRATION_DATA_FAILURE: '@merchant-listing/GET_MERCHANT_MIGRATION_DATA_FAILURE',
  GET_MERCHANT_MIGRATION_DATA_CLEAR: '@merchant-listing/GET_MERCHANT_MIGRATION_DATA_CLEAR',

  // Admin Custom Routing List
  GET_ADMIN_CUSTOM_ROUTING_LIST:
    '@admin-routing-list/GET_ADMIN_CUSTOM_ROUTING_LIST',
  GET_ADMIN_CUSTOM_ROUTING_LIST_REQUEST:
    '@admin-routing-list/GET_ADMIN_CUSTOM_ROUTING_LIST_REQUEST',
  GET_ADMIN_CUSTOM_ROUTING_LIST_SUCCESS:
    '@admin-routing-list/GET_ADMIN_CUSTOM_ROUTING_LIST_SUCCESS',
  GET_ADMIN_CUSTOM_ROUTING_LIST_FAILURE:
    '@admin-routing-list/GET_ADMIN_CUSTOM_ROUTING_LIST_FAILURE',
  GET_ADMIN_CUSTOM_ROUTING_LIST_CLEAR:
    '@admin-routing-list/GET_ADMIN_CUSTOM_ROUTING_LIST_CLEAR',

  // Get Admin Custom Routing Logic
  GET_ADMIN_PRIORITY_LOGIC: '@admin-priority-logic/GET_ADMIN_PRIORITY_LOGIC',
  GET_ADMIN_PRIORITY_LOGIC_REQUEST:
    '@admin-priority-logic/GET_ADMIN_PRIORITY_LOGIC_REQUEST',
  GET_ADMIN_PRIORITY_LOGIC_SUCCESS:
    '@admin-priority-logic/GET_ADMIN_PRIORITY_LOGIC_SUCCESS',
  GET_ADMIN_PRIORITY_LOGIC_FAILURE:
    '@admin-priority-logic/GET_ADMIN_PRIORITY_LOGIC_FAILURE',
  GET_ADMIN_PRIORITY_LOGIC_CLEAR:
    '@admin-priority-logic/GET_ADMIN_PRIORITY_LOGIC_CLEAR',

  // Approve Or Reject Routing Logic
  PUT_APPROVE_OR_REJECT_LOGIC:
    '@admin-approved-or-reject/PUT_APPROVE_OR_REJECT_LOGIC',
  PUT_APPROVE_OR_REJECT_LOGIC_REQUEST:
    '@admin-approved-or-reject/PUT_APPROVE_OR_REJECT_LOGIC_REQUEST',
  PUT_APPROVE_OR_REJECT_LOGIC_SUCCESS:
    '@admin-approved-or-reject/PUT_APPROVE_OR_REJECT_LOGIC_SUCCESS',
  PUT_APPROVE_OR_REJECT_LOGIC_FAILURE:
    '@admin-approved-or-reject/PUT_APPROVE_OR_REJECT_LOGIC_FAILURE',
  PUT_APPROVE_OR_REJECT_LOGIC_CLEAR:
    '@admin-approved-or-reject/PUT_APPROVE_OR_REJECT_LOGIC_CLEAR',

  // Update Admin Routing Logic
  UPDATE_ADMIN_PRIORITY_LOGIC:
    '@admin-routing-logic/UPDATE_ADMIN_PRIORITY_LOGIC',
  UPDATE_ADMIN_PRIORITY_LOGIC_REQUEST:
    '@admin-routing-logic/UPDATE_ADMIN_PRIORITY_LOGIC_REQUEST',
  UPDATE_ADMIN_PRIORITY_LOGIC_SUCCESS:
    '@admin-routing-logic/UPDATE_ADMIN_PRIORITY_LOGIC_SUCCESS',
  UPDATE_ADMIN_PRIORITY_LOGIC_FAILURE:
    '@admin-routing-logic/UPDATE_ADMIN_PRIORITY_LOGIC_FAILURE',
  UPDATE_ADMIN_PRIORITY_LOGIC_CLEAR:
    '@admin-routing-logic/UPDATE_ADMIN_PRIORITY_LOGIC_CLEAR',

  // Admin Custom Routing List
  GET_ADMIN_CUSTOM_ROUTING_AUTO_SUGGEST_LIST:
    '@admin-routing-list/GET_ADMIN_CUSTOM_ROUTING_AUTO_SUGGEST_LIST',
  GET_ADMIN_CUSTOM_ROUTING_AUTO_SUGGEST_LIST_REQUEST:
    '@admin-routing-list/GET_ADMIN_CUSTOM_ROUTING_AUTO_SUGGEST_LIST_REQUEST',
  GET_ADMIN_CUSTOM_ROUTING_AUTO_SUGGEST_LIST_SUCCESS:
    '@admin-routing-list/GET_ADMIN_CUSTOM_ROUTING_AUTO_SUGGEST_LIST_SUCCESS',
  GET_ADMIN_CUSTOM_ROUTING_AUTO_SUGGEST_LIST_FAILURE:
    '@admin-routing-list/GET_ADMIN_CUSTOM_ROUTING_AUTO_SUGGEST_LIST_FAILURE',
  GET_ADMIN_CUSTOM_ROUTING_AUTO_SUGGEST_LIST_CLEAR:
    '@admin-routing-list/GET_ADMIN_CUSTOM_ROUTING_AUTO_SUGGEST_LIST_CLEAR',

  // Update Merchant TRM Status
  PUT_UPDATE_MERCHANT_TRM_STATUS_ACTION:
    '@admin/PUT_UPDATE_MERCHANT_TRM_STATUS_ACTION',
  PUT_UPDATE_MERCHANT_TRM_STATUS_REQUEST:
    '@admin/PUT_UPDATE_MERCHANT_TRM_STATUS_REQUEST',
  PUT_UPDATE_MERCHANT_TRM_STATUS_SUCCESS:
    '@admin/PUT_UPDATE_MERCHANT_TRM_STATUS_SUCCESS',
  PUT_UPDATE_MERCHANT_TRM_STATUS_FAILURE:
    '@admin/PUT_UPDATE_MERCHANT_TRM_STATUS_FAILURE',
  PUT_UPDATE_MERCHANT_TRM_STATUS_CLEAR:
    '@admin/PUT_UPDATE_MERCHANT_TRM_STATUS_CLEAR',

  // Merchant Search
  MERCHANT_SEARCH: '@merchant-listing/MERCHANT_SEARCH',
  MERCHANT_SEARCH_REQUEST: '@merchant-listing/MERCHANT_SEARCH_REQUEST',
  MERCHANT_SEARCH_SUCCESS: '@merchant-listing/MERCHANT_SEARCH_SUCCESS',
  MERCHANT_SEARCH_FAILURE: '@merchant-listing/MERCHANT_SEARCH_FAILURE',
  MERCHANT_SEARCH_CLEAR: '@merchant-listing/MERCHANT_SEARCH_CLEAR',

  // Merchant Search
  MIGRATED_MERCHANT_SEARCH: '@merchant-listing/MIGRATED_MERCHANT_SEARCH',
  MIGRATED_MERCHANT_SEARCH_REQUEST: '@merchant-listing/MIGRATED_MERCHANT_SEARCH_REQUEST',
  MIGRATED_MERCHANT_SEARCH_SUCCESS: '@merchant-listing/MIGRATED_MERCHANT_SEARCH_SUCCESS',
  MIGRATED_MERCHANT_SEARCH_FAILURE: '@merchant-listing/MIGRATED_MERCHANT_SEARCH_FAILURE',
  MIGRATED_MERCHANT_SEARCH_CLEAR: '@merchant-listing/MIGRATED_MERCHANT_SEARCH_CLEAR',

  // Captcha
  CLIENT_SECRET_KEY_ACTION: '@Captcha/CLIENT_SECRET_KEY_ACTION',
  CLIENT_SECRET_KEY_REQUEST: '@Captcha/CLIENT_SECRET_KEY_REQUEST',
  CLIENT_SECRET_KEY_SUCCESS: '@Captcha/CLIENT_SECRET_KEY_SUCCESS',
  CLIENT_SECRET_KEY_FAILURE: '@Captcha/CLIENT_SECRET_KEY_FAILURE',
  CLIENT_SECRET_KEY_CLEAR: '@Captcha/CLIENT_SECRET_KEY_CLEAR',

  // Verify Captcha
  CAPTCHA_VERIFY_ACTION: '@Captcha/CAPTCHA_VERIFY_ACTION',
  CAPTCHA_VERIFY_REQUEST: '@Captcha/CAPTCHA_VERIFY_REQUEST',
  CAPTCHA_VERIFY_SUCCESS: '@Captcha/CAPTCHA_VERIFY_SUCCESS',
  CAPTCHA_VERIFY_FAILURE: '@Captcha/CAPTCHA_VERIFY_FAILURE',
  CAPTCHA_VERIFY_CLEAR: '@Captcha/CAPTCHA_VERIFY_CLEAR',

  // Payment Link Bulk Upload History
  GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_ACTION:
    '@payment-link/GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_ACTION',
  GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_REQUEST:
    '@payment-link/GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_REQUEST',
  GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_SUCCESS:
    '@payment-link/GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_SUCCESS',
  GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_FAILURE:
    '@payment-link/GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_FAILURE',
  GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_CLEAR:
    '@payment-link/GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_CLEAR',

  // Payment Link Status Code
  GET_PAYMENT_LINK_STATUS_CODE_ACTION:
    '@payment-link/GET_PAYMENT_LINK_STATUS_CODE_ACTION',
  GET_PAYMENT_LINK_STATUS_CODE_REQUEST:
    '@payment-link/GET_PAYMENT_LINK_STATUS_CODE_REQUEST',
  GET_PAYMENT_LINK_STATUS_CODE_SUCCESS:
    '@payment-link/GET_PAYMENT_LINK_STATUS_CODE_SUCCESS',
  GET_PAYMENT_LINK_STATUS_CODE_FAILURE:
    '@payment-link/GET_PAYMENT_LINK_STATUS_CODE_FAILURE',
  GET_PAYMENT_LINK_STATUS_CODE_CLEAR:
    '@payment-link/GET_PAYMENT_LINK_STATUS_CODE_CLEAR',

  // refund
  GET_ALL_REFUND_STATUS_LIST: '@refund/GET_ALL_REFUND_STATUS_LIST',
  GET_ALL_REFUND_STATUS_LIST_REQUEST:
    '@refund/GET_ALL_REFUND_STATUS_LIST_REQUEST',
  GET_ALL_REFUND_STATUS_LIST_SUCCESS:
    '@refund/GET_ALL_REFUND_STATUS_LIST_SUCCESS',
  GET_ALL_REFUND_STATUS_LIST_FAILURE:
    '@refund/GET_ALL_REFUND_STATUS_LIST_FAILURE',
  GET_ALL_REFUND_STATUS_LIST_CLEAR: '@refund/GET_ALL_REFUND_STATUS_LIST_CLEAR',

  // Download CSV
  GET_DOWNLOAD_CSV_ACTION: '@file-download/GET_DOWNLOAD_CSV_ACTION',
  GET_DOWNLOAD_CSV_REQUEST: '@file-download/GET_DOWNLOAD_CSV_REQUEST',

  // get trm login link
  GET_TRM_REDIRECT_URL: '@refund/GET_TRM_REDIRECT_URL',
  GET_TRM_REDIRECT_URL_REQUEST: '@refund/GET_TRM_REDIRECT_URL_REQUEST',
  GET_TRM_REDIRECT_URL_SUCCESS: '@refund/GET_TRM_REDIRECT_URL_SUCCESS',
  GET_TRM_REDIRECT_URL_FAILURE: '@refund/GET_TRM_REDIRECT_URL_FAILURE',
  GET_TRM_REDIRECT_URL_CLEAR: '@refund/GET_TRM_REDIRECT_URL_CLEAR',

  // validate register token url
  GET_VALIDATE_INVITATION_URL: '@register/GET_VALIDATE_INVITATION_URL',
  GET_VALIDATE_INVITATION_URL_REQUEST:
    '@register/GET_VALIDATE_INVITATION_URL_REQUEST',
  GET_VALIDATE_INVITATION_URL_SUCCESS:
    '@register/GET_VALIDATE_INVITATION_URL_SUCCESS',
  GET_VALIDATE_INVITATION_URL_FAILURE:
    '@register/GET_VALIDATE_INVITATION_URL_FAILURE',
  GET_VALIDATE_INVITATION_URL_CLEAR:
    '@register/GET_VALIDATE_INVITATION_URL_CLEAR',

  // login OTP timer
  SET_IS_TIMER_COMPTLETE: 'SET_IS_TIMER_COMPTLETE',

  // get All UDFs
  GET_PAYMENT_LINK_UDF_ACTION: '@payment-link/GET_PAYMENT_LINK_UDF_ACTION',
  GET_PAYMENT_LINK_UDF_REQUEST: '@payment-link/GET_PAYMENT_LINK_UDF_REQUEST',
  GET_PAYMENT_LINK_UDF_SUCCESS: '@payment-link/GET_PAYMENT_LINK_UDF_SUCCESS',
  GET_PAYMENT_LINK_UDF_FAILURE: '@payment-link/GET_PAYMENT_LINK_UDF_FAILURE',
  GET_PAYMENT_LINK_UDF_CLEAR: '@payment-link/GET_PAYMENT_LINK_UDF_CLEAR',

  //get all Edge UDF
  GET_EDGE_PAYMENT_LINK_UDF_ACTION: '@payment-link/GET_EDGE_PAYMENT_LINK_UDF_ACTION',
  GET_EDGE_PAYMENT_LINK_UDF_REQUEST: '@payment-link/GET_EDGE_PAYMENT_LINK_UDF_REQUEST',
  GET_EDGE_PAYMENT_LINK_UDF_SUCCESS: '@payment-link/GET_EDGE_PAYMENT_LINK_UDF_SUCCESS',
  GET_EDGE_PAYMENT_LINK_UDF_FAILURE: '@payment-link/GET_EDGE_PAYMENT_LINK_UDF_FAILURE',
  GET_EDGE_PAYMENT_LINK_UDF_CLEAR: '@payment-link/GET_EDGE_PAYMENT_LINK_UDF_CLEAR',

  // get All UDFs
  UPDATE_ALL_UDF_ACTION: '@payment-link/UPDATE_ALL_UDF_ACTION',
  UPDATE_ALL_UDF_REQUEST: '@payment-link/UPDATE_ALL_UDF_REQUEST',
  UPDATE_ALL_UDF_SUCCESS: '@payment-link/UPDATE_ALL_UDF_SUCCESS',
  UPDATE_ALL_UDF_FAILURE: '@payment-link/UPDATE_ALL_UDF_FAILURE',
  UPDATE_ALL_UDF_CLEAR: '@payment-link/UPDATE_ALL_UDF_CLEAR',

  //GET all Edge UDFs
  UPDATE_ALL_EDGE_UDF_ACTION: '@payment-link/UPDATE_ALL_EDGE_UDF_ACTION',
  UPDATE_ALL_EDGE_UDF_REQUEST: '@payment-link/UPDATE_ALL_EDGE_UDF_REQUEST',
  UPDATE_ALL_EDGE_UDF_SUCCESS: '@payment-link/UPDATE_ALL_EDGE_UDF_SUCCESS',
  UPDATE_ALL_EDGE_UDF_FAILURE: '@payment-link/UPDATE_ALL_EDGE_UDF_FAILURE',
  UPDATE_ALL_EDGE_UDF_CLEAR: '@payment-link/UPDATE_ALL_EDGE_UDF_CLEAR',

  // Payment Links / Create Payment Link
  CUSTOMIZATION_PAYMENT_LINKS_TOGGLE:
    '@payment-link/CUSTOMIZATION_PAYMENT_LINKS_TOGGLE',
  CUSTOMIZATION_PAYMENT_LINKS_TOGGLE_REQUEST:
    '@payment-link/CUSTOMIZATION_PAYMENT_LINKS_TOGGLE_REQUEST',
  CUSTOMIZATION_PAYMENT_LINKS_TOGGLE_SUCCESS:
    '@payment-link/CUSTOMIZATION_PAYMENT_LINKS_TOGGLE_SUCCESS',
  CUSTOMIZATION_PAYMENT_LINKS_TOGGLE_FAILURE:
    '@payment-link/CUSTOMIZATION_PAYMENT_LINKS_TOGGLE_FAILURE',
  CUSTOMIZATION_PAYMENT_LINKS_TOGGLE_CLEAR:
    '@payment-link/CUSTOMIZATION_PAYMENT_LINKS_TOGGLE_CLEAR',

  // Payment Links / Create Payment Link Edge
  CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE:
    '@payment-link/CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE',
  CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE_REQUEST:
    '@payment-link/CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE_REQUEST',
  CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE_SUCCESS:
    '@payment-link/CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE_SUCCESS',
  CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE_FAILURE:
    '@payment-link/CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE_FAILURE',
  CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE_CLEAR:
    '@payment-link/CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE_CLEAR',

  // Payment Links / Get Custom Payment Link Email Template Data
  GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA:
    '@payment-link/GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA',
  GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA_REQUEST:
    '@payment-link/GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA_REQUEST',
  GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA_SUCCESS:
    '@payment-link/GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA_SUCCESS',
  GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA_FAILURE:
    '@payment-link/GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA_FAILURE',
  GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA_CLEAR:
    '@payment-link/GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA_CLEAR',

  // Payment Links / Post Custom Payment Link Email Template Data
  POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL:
    '@payment-link/POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL',
  POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_REQUEST:
    '@payment-link/POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_REQUEST',
  POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_SUCCESS:
    '@payment-link/POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_SUCCESS',
  POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_FAILURE:
    '@payment-link/POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_FAILURE',
  POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_CLEAR:
    '@payment-link/POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_CLEAR',
  
  // Payment Links / Get Edge Custom Payment Link Email Template Data
  GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA:
    '@payment-link/GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA',
  GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA_REQUEST:
    '@payment-link/GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA_REQUEST',
  GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA_SUCCESS:
    '@payment-link/GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA_SUCCESS',
  GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA_FAILURE:
    '@payment-link/GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA_FAILURE',
  GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA_CLEAR:
    '@payment-link/GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA_CLEAR',
 // Payment Links / Post Custom Payment Link Email Template Data
 POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL:
 '@payment-link/POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL',
POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_REQUEST:
 '@payment-link/POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_REQUEST',
POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_SUCCESS:
 '@payment-link/POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_SUCCESS',
POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_FAILURE:
 '@payment-link/POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_FAILURE',
POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_CLEAR:
 '@payment-link/POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_CLEAR',

  // Add new beneficiary
  POST_ADD_NEW_BENEFICIARY: '@payouts/POST_ADD_NEW_BENEFICIARY',
  POST_ADD_NEW_BENEFICIARY_REQUEST: '@payouts/POST_ADD_NEW_BENEFICIARY_REQUEST',
  POST_ADD_NEW_BENEFICIARY_SUCCESS: '@payouts/POST_ADD_NEW_BENEFICIARY_SUCCESS',
  POST_ADD_NEW_BENEFICIARY_FAILURE: '@payouts/POST_ADD_NEW_BENEFICIARY_FAILURE',
  POST_ADD_NEW_BENEFICIARY_CLEAR: '@payouts/POST_ADD_NEW_BENEFICIARY_CLEAR',

  // get beneficiary list
  GET_BENEFICIARY_LIST: '@payouts/GET_BENEFICIARY_LIST',
  GET_BENEFICIARY_LIST_REQUEST: '@payouts/GET_BENEFICIARY_LIST_REQUEST',
  GET_BENEFICIARY_LIST_SUCCESS: '@payouts/GET_BENEFICIARY_LIST_SUCCESS',
  GET_BENEFICIARY_LIST_FAILURE: '@payouts/GET_BENEFICIARY_LIST_FAILURE',
  GET_BENEFICIARY_LIST_CLEAR: '@payouts/GET_BENEFICIARY_LIST_CLEAR',

  // approve beneficiary
  POST_APPROVE_BENEFICIARY: '@payouts/POST_APPROVE_BENEFICIARY',
  POST_APPROVE_BENEFICIARY_REQUEST: '@payouts/POST_APPROVE_BENEFICIARY_REQUEST',
  POST_APPROVE_BENEFICIARY_SUCCESS: '@payouts/POST_APPROVE_BENEFICIARY_SUCCESS',
  POST_APPROVE_BENEFICIARY_FAILURE: '@payouts/POST_APPROVE_BENEFICIARY_FAILURE',
  POST_APPROVE_BENEFICIARY_CLEAR: '@payouts/POST_APPROVE_BENEFICIARY_CLEAR',

  // reject beneficiary
  POST_REJECT_BENEFICIARY: '@payouts/POST_REJECT_BENEFICIARY',
  POST_REJECT_BENEFICIARY_REQUEST: '@payouts/POST_REJECT_BENEFICIARY_REQUEST',
  POST_REJECT_BENEFICIARY_SUCCESS: '@payouts/POST_REJECT_BENEFICIARY_SUCCESS',
  POST_REJECT_BENEFICIARY_FAILURE: '@payouts/POST_REJECT_BENEFICIARY_FAILURE',
  POST_REJECT_BENEFICIARY_CLEAR: '@payouts/POST_REJECT_BENEFICIARY_CLEAR',

  // deactivate beneficiary
  PUT_DEACTIVATE_BENEFICIARY: '@payouts/PUT_DEACTIVATE_BENEFICIARY',
  PUT_DEACTIVATE_BENEFICIARY_REQUEST:
    '@payouts/PUT_DEACTIVATE_BENEFICIARY_REQUEST',
  PUT_DEACTIVATE_BENEFICIARY_SUCCESS:
    '@payouts/PUT_DEACTIVATE_BENEFICIARY_SUCCESS',
  PUT_DEACTIVATE_BENEFICIARY_FAILURE:
    '@payouts/PUT_DEACTIVATE_BENEFICIARY_FAILURE',
  PUT_DEACTIVATE_BENEFICIARY_CLEAR: '@payouts/PUT_DEACTIVATE_BENEFICIARY_CLEAR',

  // get payouts list
  GET_BENEFICIARY_BY_BENEFICIARY_CODE:
    '@payouts/GET_BENEFICIARY_BY_BENEFICIARY_CODE',
  GET_BENEFICIARY_BY_BENEFICIARY_CODE_REQUEST:
    '@payouts/GET_BENEFICIARY_BY_BENEFICIARY_CODE_REQUEST',
  GET_BENEFICIARY_BY_BENEFICIARY_CODE_SUCCESS:
    '@payouts/GET_BENEFICIARY_BY_BENEFICIARY_CODE_SUCCESS',
  GET_BENEFICIARY_BY_BENEFICIARY_CODE_FAILURE:
    '@payouts/GET_BENEFICIARY_BY_BENEFICIARY_CODE_FAILURE',
  GET_BENEFICIARY_BY_BENEFICIARY_CODE_CLEAR:
    '@payouts/GET_BENEFICIARY_BY_BENEFICIARY_CODE_CLEAR',

  // get payouts list
  GET_INDIVIDUAL_PAYOUTS_LIST: '@payouts/GET_INDIVIDUAL_PAYOUTS_LIST',
  GET_INDIVIDUAL_PAYOUTS_LIST_REQUEST:
    '@payouts/GET_INDIVIDUAL_PAYOUTS_LIST_REQUEST',
  GET_INDIVIDUAL_PAYOUTS_LIST_SUCCESS:
    '@payouts/GET_INDIVIDUAL_PAYOUTS_LIST_SUCCESS',
  GET_INDIVIDUAL_PAYOUTS_LIST_FAILURE:
    '@payouts/GET_INDIVIDUAL_PAYOUTS_LIST_FAILURE',
  GET_INDIVIDUAL_PAYOUTS_LIST_CLEAR:
    '@payouts/GET_INDIVIDUAL_PAYOUTS_LIST_CLEAR',

  // post new individual payout
  POST_ADD_INDIVIDUAL_PAYOUT: '@payouts/POST_ADD_INDIVIDUAL_PAYOUT',
  POST_ADD_INDIVIDUAL_PAYOUT_REQUEST:
    '@payouts/POST_ADD_INDIVIDUAL_PAYOUT_REQUEST',
  POST_ADD_INDIVIDUAL_PAYOUT_SUCCESS:
    '@payouts/POST_ADD_INDIVIDUAL_PAYOUT_SUCCESS',
  POST_ADD_INDIVIDUAL_PAYOUT_FAILURE:
    '@payouts/POST_ADD_INDIVIDUAL_PAYOUT_FAILURE',
  POST_ADD_INDIVIDUAL_PAYOUT_CLEAR: '@payouts/POST_ADD_INDIVIDUAL_PAYOUT_CLEAR',

  // get bulk payout list
  GET_BULK_PAYOUT_LIST: '@payouts/GET_BULK_PAYOUT_LIST',
  GET_BULK_PAYOUT_LIST_REQUEST: '@payouts/GET_BULK_PAYOUT_LIST_REQUEST',
  GET_BULK_PAYOUT_LIST_SUCCESS: '@payouts/GET_BULK_PAYOUT_LIST_SUCCESS',
  GET_BULK_PAYOUT_LIST_FAILURE: '@payouts/GET_BULK_PAYOUT_LIST_FAILURE',
  GET_BULK_PAYOUT_LIST_CLEAR: '@payouts/GET_BULK_PAYOUT_LIST_CLEAR',

  // get bulk payout list
  GET_BULK_PAYOUT_FAILED_RECORDS: '@payouts/GET_BULK_PAYOUT_FAILED_RECORDS',
  GET_BULK_PAYOUT_FAILED_RECORDS_REQUEST:
    '@payouts/GET_BULK_PAYOUT_FAILED_RECORDS_REQUEST',
  GET_BULK_PAYOUT_FAILED_RECORDS_SUCCESS:
    '@payouts/GET_BULK_PAYOUT_FAILED_RECORDS_SUCCESS',
  GET_BULK_PAYOUT_FAILED_RECORDS_FAILURE:
    '@payouts/GET_BULK_PAYOUT_FAILED_RECORDS_FAILURE',
  GET_BULK_PAYOUT_FAILED_RECORDS_CLEAR:
    '@payouts/GET_BULK_PAYOUT_FAILED_RECORDS_CLEAR',

  // update payout module status
  PUT_UPDATE_PAYOUT_MODULE_STATUS: '@payouts/PUT_UPDATE_PAYOUT_MODULE_STATUS',
  PUT_UPDATE_PAYOUT_MODULE_STATUS_REQUEST:
    '@payouts/PUT_UPDATE_PAYOUT_MODULE_STATUS_REQUEST',
  PUT_UPDATE_PAYOUT_MODULE_STATUS_SUCCESS:
    '@payouts/PUT_UPDATE_PAYOUT_MODULE_STATUS_SUCCESS',
  PUT_UPDATE_PAYOUT_MODULE_STATUS_FAILURE:
    '@payouts/PUT_UPDATE_PAYOUT_MODULE_STATUS_FAILURE',
  PUT_UPDATE_PAYOUT_MODULE_STATUS_CLEAR:
    '@payouts/PUT_UPDATE_PAYOUT_MODULE_STATUS_CLEAR',

  // cancel payout
  CANCEL_INDIVIDUAL_PAYOUT: '@payouts/CANCEL_INDIVIDUAL_PAYOUT',
  CANCEL_INDIVIDUAL_PAYOUT_REQUEST: '@payouts/CANCEL_INDIVIDUAL_PAYOUT_REQUEST',
  CANCEL_INDIVIDUAL_PAYOUT_SUCCESS: '@payouts/CANCEL_INDIVIDUAL_PAYOUT_SUCCESS',
  CANCEL_INDIVIDUAL_PAYOUT_FAILURE: '@payouts/CANCEL_INDIVIDUAL_PAYOUT_FAILURE',
  CANCEL_INDIVIDUAL_PAYOUT_CLEAR: '@payouts/CANCEL_INDIVIDUAL_PAYOUT_CLEAR',

  // reschedule payout
  RESCHEDULE_INDIVIDUAL_PAYOUT: '@payouts/RESCHEDULE_INDIVIDUAL_PAYOUT',
  RESCHEDULE_INDIVIDUAL_PAYOUT_REQUEST:
    '@payouts/RESCHEDULE_INDIVIDUAL_PAYOUT_REQUEST',
  RESCHEDULE_INDIVIDUAL_PAYOUT_SUCCESS:
    '@payouts/RESCHEDULE_INDIVIDUAL_PAYOUT_SUCCESS',
  RESCHEDULE_INDIVIDUAL_PAYOUT_FAILURE:
    '@payouts/RESCHEDULE_INDIVIDUAL_PAYOUT_FAILURE',
  RESCHEDULE_INDIVIDUAL_PAYOUT_CLEAR:
    '@payouts/RESCHEDULE_INDIVIDUAL_PAYOUT_CLEAR',

  // get payout overview pending summary
  GET_PAYOUT_OVERVIEW_PENDING_SUMMARY:
    '@payouts/GET_PAYOUT_OVERVIEW_PENDING_SUMMARY',
  GET_PAYOUT_OVERVIEW_PENDING_SUMMARY_REQUEST:
    '@payouts/GET_PAYOUT_OVERVIEW_PENDING_SUMMARY_REQUEST',
  GET_PAYOUT_OVERVIEW_PENDING_SUMMARY_SUCCESS:
    '@payouts/GET_PAYOUT_OVERVIEW_PENDING_SUMMARY_SUCCESS',
  GET_PAYOUT_OVERVIEW_PENDING_SUMMARY_FAILURE:
    '@payouts/GET_PAYOUT_OVERVIEW_PENDING_SUMMARY_FAILURE',

  // get payout overview status summary
  GET_PAYOUT_OVERVIEW_STATUS_SUMMARY:
    '@payouts/GET_PAYOUT_OVERVIEW_STATUS_SUMMARY',
  GET_PAYOUT_OVERVIEW_STATUS_SUMMARY_REQUEST:
    '@payouts/GET_PAYOUT_OVERVIEW_STATUS_SUMMARY_REQUEST',
  GET_PAYOUT_OVERVIEW_STATUS_SUMMARY_SUCCESS:
    '@payouts/GET_PAYOUT_OVERVIEW_STATUS_SUMMARY_SUCCESS',
  GET_PAYOUT_OVERVIEW_STATUS_SUMMARY_FAILURE:
    '@payouts/GET_PAYOUT_OVERVIEW_STATUS_SUMMARY_FAILURE',

  // get payout overview transaction summary
  GET_PAYOUT_OVERVIEW_TRANSACTION_SUMMARY:
    '@payouts/GET_PAYOUT_OVERVIEW_TRANSACTION_SUMMARY',
  GET_PAYOUT_OVERVIEW_TRANSACTION_SUMMARY_REQUEST:
    '@payouts/GET_PAYOUT_OVERVIEW_TRANSACTION_SUMMARY_REQUEST',
  GET_PAYOUT_OVERVIEW_TRANSACTION_SUMMARY_SUCCESS:
    '@payouts/GET_PAYOUT_OVERVIEW_TRANSACTION_SUMMARY_SUCCESS',
  GET_PAYOUT_OVERVIEW_TRANSACTION_SUMMARY_FAILURE:
    '@payouts/GET_PAYOUT_OVERVIEW_TRANSACTION_SUMMARY_FAILURE',

  // clear payout overview error state
  CLEAR_PAYOUT_OVERVIEW_ERROR_STATE:
    '@payouts/CLEAR_PAYOUT_OVERVIEW_ERROR_STATE',

  // get payout balance
  GET_PAYOUT_ACCOUNT_BALANCE: '@payouts/GET_PAYOUT_ACCOUNT_BALANCE',
  GET_PAYOUT_ACCOUNT_BALANCE_REQUEST:
    '@payouts/GET_PAYOUT_ACCOUNT_BALANCE_REQUEST',
  GET_PAYOUT_ACCOUNT_BALANCE_SUCCESS:
    '@payouts/GET_PAYOUT_ACCOUNT_BALANCE_SUCCESS',
  GET_PAYOUT_ACCOUNT_BALANCE_FAILURE:
    '@payouts/GET_PAYOUT_ACCOUNT_BALANCE_FAILURE',
  GET_PAYOUT_ACCOUNT_BALANCE_CLEAR: '@payouts/GET_PAYOUT_ACCOUNT_BALANCE_CLEAR',

  // get remitter accounts list
  GET_PAYOUT_REMITTER_ACCOUNTS_LIST:
    '@payouts/GET_PAYOUT_REMITTER_ACCOUNTS_LIST',
  GET_PAYOUT_REMITTER_ACCOUNTS_LIST_REQUEST:
    '@payouts/GET_PAYOUT_REMITTER_ACCOUNTS_LIST_REQUEST',
  GET_PAYOUT_REMITTER_ACCOUNTS_LIST_SUCCESS:
    '@payouts/GET_PAYOUT_REMITTER_ACCOUNTS_LIST_SUCCESS',
  GET_PAYOUT_REMITTER_ACCOUNTS_LIST_FAILURE:
    '@payouts/GET_PAYOUT_REMITTER_ACCOUNTS_LIST_FAILURE',
  GET_PAYOUT_REMITTER_ACCOUNTS_LIST_CLEAR:
    '@payouts/GET_PAYOUT_REMITTER_ACCOUNTS_LIST_CLEAR',

  // get current accounts list
  GET_PAYOUT_CURRENT_ACCOUNTS_LIST: '@payouts/GET_PAYOUT_CURRENT_ACCOUNTS_LIST',
  GET_PAYOUT_CURRENT_ACCOUNTS_LIST_REQUEST:
    '@payouts/GET_PAYOUT_CURRENT_ACCOUNTS_LIST_REQUEST',
  GET_PAYOUT_CURRENT_ACCOUNTS_LIST_SUCCESS:
    '@payouts/GET_PAYOUT_CURRENT_ACCOUNTS_LIST_SUCCESS',
  GET_PAYOUT_CURRENT_ACCOUNTS_LIST_FAILURE:
    '@payouts/GET_PAYOUT_CURRENT_ACCOUNTS_LIST_FAILURE',
  GET_PAYOUT_CURRENT_ACCOUNTS_LIST_CLEAR:
    '@payouts/GET_PAYOUT_CURRENT_ACCOUNTS_LIST_CLEAR',

  // get upi accounts list
  GET_PAYOUT_UPI_ACCOUNTS_LIST: '@payouts/GET_PAYOUT_UPI_ACCOUNTS_LIST',
  GET_PAYOUT_UPI_ACCOUNTS_LIST_REQUEST:
    '@payouts/GET_PAYOUT_UPI_ACCOUNTS_LIST_REQUEST',
  GET_PAYOUT_UPI_ACCOUNTS_LIST_SUCCESS:
    '@payouts/GET_PAYOUT_UPI_ACCOUNTS_LIST_SUCCESS',
  GET_PAYOUT_UPI_ACCOUNTS_LIST_FAILURE:
    '@payouts/GET_PAYOUT_UPI_ACCOUNTS_LIST_FAILURE',
  GET_PAYOUT_UPI_ACCOUNTS_LIST_CLEAR:
    '@payouts/GET_PAYOUT_UPI_ACCOUNTS_LIST_CLEAR',

  // post add remitter account
  POST_ADD_PAYOUT_REMITTER_ACCOUNT: '@payouts/POST_ADD_PAYOUT_REMITTER_ACCOUNT',
  POST_ADD_PAYOUT_REMITTER_ACCOUNT_REQUEST:
    '@payouts/POST_ADD_PAYOUT_REMITTER_ACCOUNT_REQUEST',
  POST_ADD_PAYOUT_REMITTER_ACCOUNT_SUCCESS:
    '@payouts/POST_ADD_PAYOUT_REMITTER_ACCOUNT_SUCCESS',
  POST_ADD_PAYOUT_REMITTER_ACCOUNT_FAILURE:
    '@payouts/POST_ADD_PAYOUT_REMITTER_ACCOUNT_FAILURE',
  POST_ADD_PAYOUT_REMITTER_ACCOUNT_CLEAR:
    '@payouts/POST_ADD_PAYOUT_REMITTER_ACCOUNT_CLEAR',

  // post add current account
  POST_ADD_PAYOUT_CURRENT_ACCOUNT: '@payouts/POST_ADD_PAYOUT_CURRENT_ACCOUNT',
  POST_ADD_PAYOUT_CURRENT_ACCOUNT_REQUEST:
    '@payouts/POST_ADD_PAYOUT_CURRENT_ACCOUNT_REQUEST',
  POST_ADD_PAYOUT_CURRENT_ACCOUNT_SUCCESS:
    '@payouts/POST_ADD_PAYOUT_CURRENT_ACCOUNT_SUCCESS',
  POST_ADD_PAYOUT_CURRENT_ACCOUNT_FAILURE:
    '@payouts/POST_ADD_PAYOUT_CURRENT_ACCOUNT_FAILURE',
  POST_ADD_PAYOUT_CURRENT_ACCOUNT_CLEAR:
    '@payouts/POST_ADD_PAYOUT_CURRENT_ACCOUNT_CLEAR',

  // Update Current Account
  PUT_UPDATE_PAYOUT_CURRENT_ACCOUNT: '@payouts/PUT_UPDATE_PAYOUT_CURRENT_ACCOUNT',
  PUT_UPDATE_PAYOUT_CURRENT_ACCOUNT_REQUEST: '@payouts/PUT_UPDATE_PAYOUT_CURRENT_ACCOUNT_REQUEST',
  PUT_UPDATE_PAYOUT_CURRENT_ACCOUNT_SUCCESS: '@payouts/PUT_UPDATE_PAYOUT_CURRENT_ACCOUNT_SUCCESS',
  PUT_UPDATE_PAYOUT_CURRENT_ACCOUNT_FAILURE: '@payouts/PUT_UPDATE_PAYOUT_CURRENT_ACCOUNT_FAILURE',
  PUT_UPDATE_PAYOUT_CURRENT_ACCOUNT_CLEAR: '@payouts/PUT_UPDATE_PAYOUT_CURRENT_ACCOUNT_CLEAR',

  // post add upi account
  POST_ADD_PAYOUT_UPI_ACCOUNT: '@payouts/POST_ADD_PAYOUT_UPI_ACCOUNT',
  POST_ADD_PAYOUT_UPI_ACCOUNT_REQUEST:
    '@payouts/POST_ADD_PAYOUT_UPI_ACCOUNT_REQUEST',
  POST_ADD_PAYOUT_UPI_ACCOUNT_SUCCESS:
    '@payouts/POST_ADD_PAYOUT_UPI_ACCOUNT_SUCCESS',
  POST_ADD_PAYOUT_UPI_ACCOUNT_FAILURE:
    '@payouts/POST_ADD_PAYOUT_UPI_ACCOUNT_FAILURE',
  POST_ADD_PAYOUT_UPI_ACCOUNT_CLEAR:
    '@payouts/POST_ADD_PAYOUT_UPI_ACCOUNT_CLEAR',

  // post add remitter account
  POST_UPDATE_PAYOUT_REMITTER_ACCOUNT:
    '@payouts/POST_UPDATE_PAYOUT_REMITTER_ACCOUNT',
  POST_UPDATE_PAYOUT_REMITTER_ACCOUNT_REQUEST:
    '@payouts/POST_UPDATE_PAYOUT_REMITTER_ACCOUNT_REQUEST',
  POST_UPDATE_PAYOUT_REMITTER_ACCOUNT_SUCCESS:
    '@payouts/POST_UPDATE_PAYOUT_REMITTER_ACCOUNT_SUCCESS',
  POST_UPDATE_PAYOUT_REMITTER_ACCOUNT_FAILURE:
    '@payouts/POST_UPDATE_PAYOUT_REMITTER_ACCOUNT_FAILURE',
  POST_UPDATE_PAYOUT_REMITTER_ACCOUNT_CLEAR:
    '@payouts/POST_UPDATE_PAYOUT_REMITTER_ACCOUNT_CLEAR',

  // post activate current account
  POST_ACTIVATE_PAYOUT_CURRENT_ACCOUNT:
    '@payouts/POST_ACTIVATE_PAYOUT_CURRENT_ACCOUNT',
  POST_ACTIVATE_PAYOUT_CURRENT_ACCOUNT_REQUEST:
    '@payouts/POST_ACTIVATE_PAYOUT_CURRENT_ACCOUNT_REQUEST',
  POST_ACTIVATE_PAYOUT_CURRENT_ACCOUNT_SUCCESS:
    '@payouts/POST_ACTIVATE_PAYOUT_CURRENT_ACCOUNT_SUCCESS',
  POST_ACTIVATE_PAYOUT_CURRENT_ACCOUNT_FAILURE:
    '@payouts/POST_ACTIVATE_PAYOUT_CURRENT_ACCOUNT_FAILURE',
  POST_ACTIVATE_PAYOUT_CURRENT_ACCOUNT_CLEAR:
    '@payouts/POST_ACTIVATE_PAYOUT_CURRENT_ACCOUNT_CLEAR',

  // post activate upi account
  POST_ACTIVATE_PAYOUT_UPI_ACCOUNT: '@payouts/POST_ACTIVATE_PAYOUT_UPI_ACCOUNT',
  POST_ACTIVATE_PAYOUT_UPI_ACCOUNT_REQUEST:
    '@payouts/POST_ACTIVATE_PAYOUT_UPI_ACCOUNT_REQUEST',
  POST_ACTIVATE_PAYOUT_UPI_ACCOUNT_SUCCESS:
    '@payouts/POST_ACTIVATE_PAYOUT_UPI_ACCOUNT_SUCCESS',
  POST_ACTIVATE_PAYOUT_UPI_ACCOUNT_FAILURE:
    '@payouts/POST_ACTIVATE_PAYOUT_UPI_ACCOUNT_FAILURE',
  POST_ACTIVATE_PAYOUT_UPI_ACCOUNT_CLEAR:
    '@payouts/POST_ACTIVATE_PAYOUT_UPI_ACCOUNT_CLEAR',

  // post add public key
  POST_ADD_PUBLIC_KEY: '@payouts/POST_ADD_PUBLIC_KEY',
  POST_ADD_PUBLIC_KEY_REQUEST: '@payouts/POST_ADD_PUBLIC_KEY_REQUEST',
  POST_ADD_PUBLIC_KEY_SUCCESS: '@payouts/POST_ADD_PUBLIC_KEY_SUCCESS',
  POST_ADD_PUBLIC_KEY_FAILURE: '@payouts/POST_ADD_PUBLIC_KEY_FAILURE',
  POST_ADD_PUBLIC_KEY_CLEAR: '@payouts/POST_ADD_PUBLIC_KEY_CLEAR',

  // get payout merchant details
  GET_MERCHANT_DETAILS: '@payouts/GET_MERCHANT_DETAILS',
  GET_MERCHANT_DETAILS_REQUEST: '@payouts/GET_MERCHANT_DETAILS_REQUEST',
  GET_MERCHANT_DETAILS_SUCCESS: '@payouts/GET_MERCHANT_DETAILS_SUCCESS',
  GET_MERCHANT_DETAILS_FAILURE: '@payouts/GET_MERCHANT_DETAILS_FAILURE',
  GET_MERCHANT_DETAILS_CLEAR: '@payouts/GET_MERCHANT_DETAILS_CLEAR',

  // get payout bank list
  GET_PAYOUT_BANK_LIST: '@payouts/GET_PAYOUT_BANK_LIST',
  GET_PAYOUT_BANK_LIST_REQUEST: '@payouts/GET_PAYOUT_BANK_LIST_REQUEST',
  GET_PAYOUT_BANK_LIST_SUCCESS: '@payouts/GET_PAYOUT_BANK_LIST_SUCCESS',
  GET_PAYOUT_BANK_LIST_FAILURE: '@payouts/GET_PAYOUT_BANK_LIST_FAILURE',
  GET_PAYOUT_BANK_LIST_CLEAR: '@payouts/GET_PAYOUT_BANK_LIST_CLEAR',

  //Sync now
  GET_SYNC_NOW: '@settlement/GET_SYNC_NOW',
  GET_SYNC_NOW_REQUEST: '@settlement/GET_SYNC_NOW_REQUEST',
  GET_SYNC_NOW_SUCCESS: '@settlement/GET_SYNC_NOW_SUCCESS',
  GET_SYNC_NOW_FAILURE: '@settlement/GET_SYNC_NOW_FAILURE',

  //Get Pg list
  GET_PG_LIST: '@settlement/GET_PG_LIST',
  GET_PG_LIST_REQUEST: '@settlement/GET_PG_LIST_REQUEST',
  GET_PG_LIST_SUCCESS: '@settlement/GET_PG_LIST_SUCCESS',
  GET_PG_LIST_FAILURE: '@settlement/GET_PG_LIST_FAILURE',

  // Get Status List
  GET_SETTLEMENT_STATUS_LIST: '@settlement/GET_SETTLEMENT_STATUS_LIST_ACTION',
  GET_SETTLEMENT_STATUS_LIST_REQUEST:
    '@settlement/GET_SETTLEMENT_STATUS_LIST_REQUEST',
  GET_SETTLEMENT_STATUS_LIST_SUCCESS:
    '@settlement/GET_SETTLEMENT_STATUS_LIST_SUCCESS',
  GET_SETTLEMENT_STATUS_LIST_FAILURE:
    '@settlement/GET_SETTLEMENT_STATUS_LIST_FAILURE',

  // Get Settlement details
  GET_SETTLEMENT_DETAIL_SUMMARY: '@settlement/GET_SETTLEMENT_DETAIL_SUMMARY',
  GET_SETTLEMENT_DETAIL_SUMMARY_SUCCESS:
    '@settlement/GET_SETTLEMENT_DETAIL_SUMMARY_SUCCESS',
  GET_SETTLEMENT_DETAIL_SUMMARY_FAILURE:
    '@settlement/GET_SETTLEMENT_DETAIL_SUMMARY_FAILURE',
  GET_SETTLEMENT_DETAIL_SUMMARY_REQUEST:
    '@settlement/GET_SETTLEMENT_DETAIL_SUMMARY_REQUEST',
  // Get edge Settlement details
  GET_EDGE_SETTLEMENT_DETAIL_SUMMARY:
    '@settlement/GET_EDGE_SETTLEMENT_DETAIL_SUMMARY',
  GET_EDGE_SETTLEMENT_DETAIL_SUMMARY_SUCCESS:
    '@settlement/GET_EDGE_SETTLEMENT_DETAIL_SUMMARY_SUCCESS',
  GET_EDGE_SETTLEMENT_DETAIL_SUMMARY_FAILURE:
    '@settlement/GET_EDGE_SETTLEMENT_DETAIL_SUMMARY_FAILURE',
  GET_EDGE_SETTLEMENT_DETAIL_SUMMARY_REQUEST:
    '@settlement/GET_EDGE_SETTLEMENT_DETAIL_SUMMARY_REQUEST',
  GET_EDGE_SETTLEMENT_DETAIL_SUMMARY_CLEAR:
    '@settlement/GET_EDGE_SETTLEMENT_DETAIL_SUMMARY_REQUEST',

  // Download settlements
  GET_SETTLEMENT_DOWNLOAD: '@settlement/GET_SETTLEMENT_DATA_DOWNLOAD',
  GET_SETTLEMENT_DOWNLOAD_SUCCESS:
    '@settlement/GET_SETTLEMENT_DATA_DOWNLOAD_SUCCESS',
  GET_SETTLEMENT_DOWNLOAD_FAILURE:
    '@settlement/GET_SETTLEMENT_DATA_DOWNLOAD_FAILURE',
  GET_SETTLEMENT_DOWNLOAD_REQUEST:
    '@settlement/GET_SETTLEMENT_DATA_DOWNLOAD_REQUEST',
  GET_SETTLEMENT_DOWNLOAD_CLEAR:
    '@settlement/GET_SETTLEMENT_DATA_DOWNLOAD_CLEAR',

  // get payout merchant kyc entity types
  GET_MERCHANT_KYC_ENTITY_TYPES_LIST:
    '@payouts/GET_MERCHANT_KYC_ENTITY_TYPES_LIST',
  GET_MERCHANT_KYC_ENTITY_TYPES_LIST_REQUEST:
    '@payouts/GET_MERCHANT_KYC_ENTITY_TYPES_LIST_REQUEST',
  GET_MERCHANT_KYC_ENTITY_TYPES_LIST_SUCCESS:
    '@payouts/GET_MERCHANT_KYC_ENTITY_TYPES_LIST_SUCCESS',
  GET_MERCHANT_KYC_ENTITY_TYPES_LIST_FAILURE:
    '@payouts/GET_MERCHANT_KYC_ENTITY_TYPES_LIST_FAILURE',
  GET_MERCHANT_KYC_ENTITY_TYPES_LIST_CLEAR:
    '@payouts/GET_MERCHANT_KYC_ENTITY_TYPES_LIST_CLEAR',

  // get merchant kyc details
  GET_MERCHANT_KYC_DETAILS: '@payouts/GET_MERCHANT_KYC_DETAILS',
  GET_MERCHANT_KYC_DETAILS_REQUEST: '@payouts/GET_MERCHANT_KYC_DETAILS_REQUEST',
  GET_MERCHANT_KYC_DETAILS_SUCCESS: '@payouts/GET_MERCHANT_KYC_DETAILS_SUCCESS',
  GET_MERCHANT_KYC_DETAILS_FAILURE: '@payouts/GET_MERCHANT_KYC_DETAILS_FAILURE',
  GET_MERCHANT_KYC_DETAILS_CLEAR: '@payouts/GET_MERCHANT_KYC_DETAILS_CLEAR',

  // get penny drop pending count
  GET_PENNY_DROP_PENDING_COUNT: '@payouts/GET_PENNY_DROP_PENDING_COUNT',
  GET_PENNY_DROP_PENDING_COUNT_REQUEST:
    '@payouts/GET_PENNY_DROP_PENDING_COUNT_REQUEST',
  GET_PENNY_DROP_PENDING_COUNT_SUCCESS:
    '@payouts/GET_PENNY_DROP_PENDING_COUNT_SUCCESS',
  GET_PENNY_DROP_PENDING_COUNT_FAILURE:
    '@payouts/GET_PENNY_DROP_PENDING_COUNT_FAILURE',
  GET_PENNY_DROP_PENDING_COUNT_CLEAR:
    '@payouts/GET_PENNY_DROP_PENDING_COUNT_CLEAR',

  // get payout pending count
  GET_PAYOUT_PENDING_COUNT: '@payouts/GET_PAYOUT_PENDING_COUNT',
  GET_PAYOUT_PENDING_COUNT_REQUEST: '@payouts/GET_PAYOUT_PENDING_COUNT_REQUEST',
  GET_PAYOUT_PENDING_COUNT_SUCCESS: '@payouts/GET_PAYOUT_PENDING_COUNT_SUCCESS',
  GET_PAYOUT_PENDING_COUNT_FAILURE: '@payouts/GET_PAYOUT_PENDING_COUNT_FAILURE',
  GET_PAYOUT_PENDING_COUNT_CLEAR: '@payouts/GET_PAYOUT_PENDING_COUNT_CLEAR',

  // create/update merchant kyc details
  POST_UPDATE_MERCHANT_KYC_DETAILS: '@payouts/POST_UPDATE_MERCHANT_KYC_DETAILS',
  POST_UPDATE_MERCHANT_KYC_DETAILS_REQUEST:
    '@payouts/POST_UPDATE_MERCHANT_KYC_DETAILS_REQUEST',
  POST_UPDATE_MERCHANT_KYC_DETAILS_SUCCESS:
    '@payouts/POST_UPDATE_MERCHANT_KYC_DETAILS_SUCCESS',
  POST_UPDATE_MERCHANT_KYC_DETAILS_FAILURE:
    '@payouts/POST_UPDATE_MERCHANT_KYC_DETAILS_FAILURE',
  POST_UPDATE_MERCHANT_KYC_DETAILS_CLEAR:
    '@payouts/POST_UPDATE_MERCHANT_KYC_DETAILS_CLEAR',

  // get bulk beneficiary list
  GET_BULK_BENEFICIARY_LIST: '@payouts/GET_BULK_BENEFICIARY_LIST',
  GET_BULK_BENEFICIARY_LIST_REQUEST:
    '@payouts/GET_BULK_BENEFICIARY_LIST_REQUEST',
  GET_BULK_BENEFICIARY_LIST_SUCCESS:
    '@payouts/GET_BULK_BENEFICIARY_LIST_SUCCESS',
  GET_BULK_BENEFICIARY_LIST_FAILURE:
    '@payouts/GET_BULK_BENEFICIARY_LIST_FAILURE',
  GET_BULK_BENEFICIARY_LIST_CLEAR: '@payouts/GET_BULK_BENEFICIARY_LIST_CLEAR',

  // low balance email alert
  LOW_BALANCE_EMAIL_ALERT: '@payouts/LOW_BALANCE_EMAIL_ALERT',
  LOW_BALANCE_EMAIL_ALERT_REQUEST: '@payouts/LOW_BALANCE_EMAIL_ALERT_REQUEST',
  LOW_BALANCE_EMAIL_ALERT_SUCCESS: '@payouts/LOW_BALANCE_EMAIL_ALERT_SUCCESS',
  LOW_BALANCE_EMAIL_ALERT_FAILURE: '@payouts/LOW_BALANCE_EMAIL_ALERT_FAILURE',
  LOW_BALANCE_EMAIL_ALERT_CLEAR: '@payouts/LOW_BALANCE_EMAIL_ALERT_CLEAR',

  // manage email alert
  MANAGE_EMAIL_ALERT: '@payouts/MANAGE_EMAIL_ALERT',
  MANAGE_EMAIL_ALERT_REQUEST: '@payouts/MANAGE_EMAIL_ALERT_REQUEST',
  MANAGE_EMAIL_ALERT_SUCCESS: '@payouts/MANAGE_EMAIL_ALERT_SUCCESS',
  MANAGE_EMAIL_ALERT_FAILURE: '@payouts/MANAGE_EMAIL_ALERT_FAILURE',
  MANAGE_EMAIL_ALERT_CLEAR: '@payouts/MANAGE_EMAIL_ALERT_CLEAR',

  // post common bulk file approve reject
  POST_COMMON_BULK_FILE_APPROVE_REJECT:
    '@payouts/POST_COMMON_BULK_FILE_APPROVE_REJECT',
  POST_COMMON_BULK_FILE_APPROVE_REJECT_REQUEST:
    '@payouts/POST_COMMON_BULK_FILE_APPROVE_REJECT_REQUEST',
  POST_COMMON_BULK_FILE_APPROVE_REJECT_SUCCESS:
    '@payouts/POST_COMMON_BULK_FILE_APPROVE_REJECT_SUCCESS',
  POST_COMMON_BULK_FILE_APPROVE_REJECT_FAILURE:
    '@payouts/POST_COMMON_BULK_FILE_APPROVE_REJECT_FAILURE',
  POST_COMMON_BULK_FILE_APPROVE_REJECT_CLEAR:
    '@payouts/POST_COMMON_BULK_FILE_APPROVE_REJECT_CLEAR',
  PUT_UPDATE_MERCHANT_TPV_ACTION: '@admin/PUT_UPDATE_MERCHANT_TPV_ACTION',
  PUT_UPDATE_MERCHANT_TPV_REQUEST: '@admin/PUT_UPDATE_MERCHANT_TPV_REQUEST',
  PUT_UPDATE_MERCHANT_TPV_SUCCESS: '@admin/PUT_UPDATE_MERCHANT_TPV_SUCCESS',
  PUT_UPDATE_MERCHANT_TPV_FAILURE: '@admin/PUT_UPDATE_MERCHANT_TPV_FAILURE',
  PUT_UPDATE_MERCHANT_TPV_CLEAR: '@admin/PUT_UPDATE_MERCHANT_TPV_CLEAR',

  PUT_UPDATE_MERCHANT_SUBSCRIPTION_ACTION:
    '@admin/PUT_UPDATE_MERCHANT_SUBSCRIPTION_ACTION',
  PUT_UPDATE_MERCHANT_SUBSCRIPTION_REQUEST:
    '@admin/PUT_UPDATE_MERCHANT_SUBSCRIPTION_REQUEST',
  PUT_UPDATE_MERCHANT_SUBSCRIPTION_SUCCESS:
    '@admin/PUT_UPDATE_MERCHANT_SUBSCRIPTION_SUCCESS',
  PUT_UPDATE_MERCHANT_SUBSCRIPTION_FAILURE:
    '@admin/PUT_UPDATE_MERCHANT_SUBSCRIPTION_FAILURE',
  PUT_UPDATE_MERCHANT_SUBSCRIPTION_CLEAR:
    '@admin/PUT_UPDATE_MERCHANT_SUBSCRIPTION_CLEAR',

  FETCH_LINKED_TXN_IDS_PL: '@payment-link/FETCH_LINKED_TXN_IDS_PL',
  FETCH_LINKED_TXN_IDS_PL_REQUEST:
    '@payment-link/FETCH_LINKED_TXN_IDS_PL_REQUEST',
  FETCH_LINKED_TXN_IDS_PL_SUCCESS:
    '@payment-link/FETCH_LINKED_TXN_IDS_PL_SUCCESS',
  FETCH_LINKED_TXN_IDS_PL_FAILURE:
    '@payment-link/FETCH_LINKED_TXN_IDS_PL_FAILURE',
  FETCH_LINKED_TXN_IDS_PL_CLEAR: '@payment-link/FETCH_LINKED_TXN_IDS_PL_CLEAR',

  // Offers / Get Listing
  GET_OFFERS_LIST: '@offers/GET_OFFERS_LIST',
  GET_OFFERS_LIST_REQUEST: '@offers/GET_OFFERS_LIST_REQUEST',
  GET_OFFERS_LIST_SUCCESS: '@offers/GET_OFFERS_LIST_SUCCESS',
  GET_OFFERS_LIST_FAILURE: '@offers/GET_OFFERS_LIST_FAILURE',
  GET_OFFERS_LIST_CLEAR: '@offers/GET_OFFERS_LIST_CLEAR',

  CREATE_CAMPAIGN: '@offers/CREATE_CAMPAIGN',
  CREATE_CAMPAIGN_REQUEST: '@offers/CREATE_CAMPAIGN_REQUEST',
  CREATE_CAMPAIGN_SUCCESS: '@offers/CREATE_CAMPAIGN_SUCCESS',
  CREATE_CAMPAIGN_FAILURE: '@offers/CREATE_CAMPAIGN_FAILURE',
  CREATE_CAMPAIGN_CLEAR: '@offers/CREATE_CAMPAIGN_CLEAR',

  FETCH_CAMPAIGN_DETAIL: '@offers/FETCH_CAMPAIGN_DETAIL',
  FETCH_CAMPAIGN_DETAIL_REQUEST: '@offers/FETCH_CAMPAIGN_DETAIL_REQUEST',
  FETCH_CAMPAIGN_DETAIL_SUCCESS: '@offers/FETCH_CAMPAIGN_DETAIL_SUCCESS',
  FETCH_CAMPAIGN_DETAIL_FAILURE: '@offers/FETCH_CAMPAIGN_DETAIL_FAILURE',
  FETCH_CAMPAIGN_DETAIL_CLEAR: '@offers/FETCH_CAMPAIGN_DETAIL_CLEAR',

  MANAGE_CAMPAIGN: '@offers/MANAGE_CAMPAIGN',
  MANAGE_CAMPAIGN_REQUEST: '@offers/MANAGE_CAMPAIGN_REQUEST',
  MANAGE_CAMPAIGN_SUCCESS: '@offers/MANAGE_CAMPAIGN_SUCCESS',
  MANAGE_CAMPAIGN_FAILURE: '@offers/MANAGE_CAMPAIGN_FAILURE',
  MANAGE_CAMPAIGN_CLEAR: '@offers/MANAGE_CAMPAIGN_CLEAR',

  FETCH_OFFERS_RULE: '@offers/FETCH_OFFERS_RULE',
  FETCH_OFFERS_RULE_REQUEST: '@offers/FETCH_OFFERS_RULE_REQUEST',
  FETCH_OFFERS_RULE_SUCCESS: '@offers/FETCH_OFFERS_RULE_SUCCESS',
  FETCH_OFFERS_RULE_FAILURE: '@offers/FETCH_OFFERS_RULE_FAILURE',
  FETCH_OFFERS_RULE_CLEAR: '@offers/FETCH_OFFERS_RULE_CLEAR',

  SET_OFFERS_RULE: '@offers/SET_OFFERS_RULE',
  SET_OFFERS_RULE_REQUEST: '@offers/SET_OFFERS_RULE_REQUEST',
  SET_OFFERS_RULE_SUCCESS: '@offers/SET_OFFERS_RULE_SUCCESS',
  SET_OFFERS_RULE_FAILURE: '@offers/SET_OFFERS_RULE_FAILURE',
  SET_OFFERS_RULE_CLEAR: '@offers/SET_OFFERS_RULE_CLEAR',

  FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN:
    '@offers/FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN',
  FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN_REQUEST:
    '@offers/FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN_REQUEST',
  FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN_SUCCESS:
    '@offers/FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN_SUCCESS',
  FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN_FAILURE:
    '@offers/FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN_FAILURE',
  FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN_CLEAR:
    '@offers/FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN_CLEAR',

  DOWNLOAD_BINFILE: '@offers/DOWNLOAD_BINFILE',
  DOWNLOAD_BINFILE_REQUEST: '@offers/DOWNLOAD_BINFILE_REQUEST',
  DOWNLOAD_BINFILE_SUCCESS: '@offers/DOWNLOAD_BINFILE_SUCCESS',
  DOWNLOAD_BINFILE_FAILURE: '@offers/DOWNLOAD_BINFILE_FAILURE',
  DOWNLOAD_BINFILE_CLEAR: '@offers/DOWNLOAD_BINFILE_CLEAR',

  // get plans list
  GET_PLANS_LIST: '@plans/GET_PLANS_LIST',
  GET_PLANS_LIST_REQUEST: '@plans/GET_PLANS_LIST_REQUEST',
  GET_PLANS_LIST_SUCCESS: '@plans/GET_PLANS_LIST_SUCCESS',
  GET_PLANS_LIST_FAILURE: '@plans/GET_PLANS_LIST_FAILURE',
  GET_PLANS_LIST_CLEAR: '@plans/GET_PLANS_LIST_CLEAR',

  // search plans list
  SEARCH_PLANS_BY_NAME: '@plans/SEARCH_PLANS_BY_NAME',
  SEARCH_PLANS_BY_NAME_SUCCESS: '@plans/SEARCH_PLANS_BY_NAME_SUCCESS',
  SEARCH_PLANS_BY_NAME_FAILURE: '@plans/SEARCH_PLANS_BY_NAME_FAILURE',
  SEARCH_PLANS_BY_NAME_REQUEST: '@plans/SEARCH_PLANS_BY_NAME_REQUEST',
  SEARCH_PLANS_BY_NAME_CLEAR: '@plans/SEARCH_PLANS_BY_NAME_CLEAR',

  // get plans list
  POST_CREATE_PLAN: '@plans/POST_CREATE_PLAN',
  POST_CREATE_PLAN_REQUEST: '@plans/POST_CREATE_PLAN_REQUEST',
  POST_CREATE_PLAN_SUCCESS: '@plans/POST_CREATE_PLAN_SUCCESS',
  POST_CREATE_PLAN_FAILURE: '@plans/POST_CREATE_PLAN_FAILURE',
  POST_CREATE_PLAN_CLEAR: '@plans/POST_CREATE_PLAN_CLEAR',

  // get subscription list
  GET_SUBSCRIPTION_LIST: '@plans/GET_SUBSCRIPTION_LIST',
  GET_SUBSCRIPTION_LIST_REQUEST: '@plans/GET_SUBSCRIPTION_LIST_REQUEST',
  GET_SUBSCRIPTION_LIST_SUCCESS: '@plans/GET_SUBSCRIPTION_LIST_SUCCESS',
  GET_SUBSCRIPTION_LIST_FAILURE: '@plans/GET_SUBSCRIPTION_LIST_FAILURE',
  GET_SUBSCRIPTION_LIST_CLEAR: '@plans/GET_SUBSCRIPTION_LIST_CLEAR',

  // get subscription presentations
  GET_SUBSCRIPTION_PRESENTATIONS:
    '@subscription/GET_SUBSCRIPTION_PRESENTATIONS',
  GET_SUBSCRIPTION_PRESENTATIONS_REQUEST:
    '@subscription/GET_SUBSCRIPTION_PRESENTATIONS_REQUEST',
  GET_SUBSCRIPTION_PRESENTATIONS_SUCCESS:
    '@subscription/GET_SUBSCRIPTION_PRESENTATIONS_SUCCESS',
  GET_SUBSCRIPTION_PRESENTATIONS_FAILURE:
    '@subscription/GET_SUBSCRIPTION_PRESENTATIONS_FAILURE',
  GET_SUBSCRIPTION_PRESENTATIONS_CLEAR:
    '@subscription/GET_SUBSCRIPTION_PRESENTATIONS_CLEAR',

  PAUSE_REVOKE_SUBSCRIPTION: '@subscription/PAUSE_REVOKE_SUBSCRIPTION',
  PAUSE_REVOKE_SUBSCRIPTION_SUCCESS:
    '@subscription/PAUSE_REVOKE_SUBSCRIPTION_SUCCESS',
  PAUSE_REVOKE_SUBSCRIPTION_FAILURE:
    '@subscription/PAUSE_REVOKE_SUBSCRIPTION_FAILURE',
  PAUSE_REVOKE_SUBSCRIPTION_REQUEST:
    '@subscription/PAUSE_REVOKE_SUBSCRIPTION_REQUEST',
  PAUSE_REVOKE_SUBSCRIPTION_CLEAR:
    '@subscription/PAUSE_REVOKE_SUBSCRIPTION_CLEAR',

  // Subscription Bulk Upload
  UPLOAD_SUBSCRIPTION_BULK: '@subscription/UPLOAD_SUBSCRIPTION_BULK',
  UPLOAD_SUBSCRIPTION_BULK_REQUEST: '@subscription/UPLOAD_SUBSCRIPTION_BULK_REQUEST',
  UPLOAD_SUBSCRIPTION_BULK_SUCCESS: '@subscription/UPLOAD_SUBSCRIPTION_BULK_SUCCESS',
  UPLOAD_SUBSCRIPTION_BULK_FAILURE: '@subscription/UPLOAD_SUBSCRIPTION_BULK_FAILURE',
  UPLOAD_SUBSCRIPTION_BULK_CLEAR: '@subscription/UPLOAD_SUBSCRIPTION_BULK_CLEAR',

  // Bulk Upload History
  GET_BULK_UPLOAD_HISTORY: '@subscription/GET_BULK_UPLOAD_HISTORY',
  GET_BULK_UPLOAD_HISTORY_REQUEST: '@subscription/GET_BULK_UPLOAD_HISTORY_REQUEST',
  GET_BULK_UPLOAD_HISTORY_SUCCESS: '@subscription/GET_BULK_UPLOAD_HISTORY_SUCCESS',
  GET_BULK_UPLOAD_HISTORY_FAILURE: '@subscription/GET_BULK_UPLOAD_HISTORY_FAILURE',
  GET_BULK_UPLOAD_HISTORY_CLEAR: '@subscription/GET_BULK_UPLOAD_HISTORY_CLEAR',

  // Subscription Links
  CREATE_SUBSCRIPTION_LINK: '@subscription-link/CREATE_SUBSCRIPTION_LINK',
  CREATE_SUBSCRIPTION_LINK_REQUEST: '@subscription-link/CREATE_SUBSCRIPTION_LINK_REQUEST',
  CREATE_SUBSCRIPTION_LINK_SUCCESS: '@subscription-link/CREATE_SUBSCRIPTION_LINK_SUCCESS',
  CREATE_SUBSCRIPTION_LINK_FAILURE: '@subscription-link/CREATE_SUBSCRIPTION_LINK_FAILURE',
  CREATE_SUBSCRIPTION_LINK_CLEAR: '@subscription-link/CREATE_SUBSCRIPTION_LINK_CLEAR',

  GET_SUBSCRIPTION_LINKS: '@subscription-link/GET_SUBSCRIPTION_LINKS',
  GET_SUBSCRIPTION_LINKS_REQUEST: '@subscription-link/GET_SUBSCRIPTION_LINKS_REQUEST',
  GET_SUBSCRIPTION_LINKS_SUCCESS: '@subscription-link/GET_SUBSCRIPTION_LINKS_SUCCESS',
  GET_SUBSCRIPTION_LINKS_FAILURE: '@subscription-link/GET_SUBSCRIPTION_LINKS_FAILURE',
  GET_SUBSCRIPTION_LINKS_CLEAR: '@subscription-link/GET_SUBSCRIPTION_LINKS_CLEAR',

  GET_SUBSCRIPTION_LINK_DETAIL: '@subscription-link/GET_SUBSCRIPTION_LINK_DETAIL',
  GET_SUBSCRIPTION_LINK_DETAIL_REQUEST: '@subscription-link/GET_SUBSCRIPTION_LINK_DETAIL_REQUEST',
  GET_SUBSCRIPTION_LINK_DETAIL_SUCCESS: '@subscription-link/GET_SUBSCRIPTION_LINK_DETAIL_SUCCESS',
  GET_SUBSCRIPTION_LINK_DETAIL_FAILURE: '@subscription-link/GET_SUBSCRIPTION_LINK_DETAIL_FAILURE',
  GET_SUBSCRIPTION_LINK_DETAIL_CLEAR: '@subscription-link/GET_SUBSCRIPTION_LINK_DETAIL_CLEAR',

  CANCEL_SUBSCRIPTION_LINK: '@subscription-link/CANCEL_SUBSCRIPTION_LINK',
  CANCEL_SUBSCRIPTION_LINK_REQUEST: '@subscription-link/CANCEL_SUBSCRIPTION_LINK_REQUEST',
  CANCEL_SUBSCRIPTION_LINK_SUCCESS: '@subscription-link/CANCEL_SUBSCRIPTION_LINK_SUCCESS',
  CANCEL_SUBSCRIPTION_LINK_FAILURE: '@subscription-link/CANCEL_SUBSCRIPTION_LINK_FAILURE',
  CANCEL_SUBSCRIPTION_LINK_CLEAR: '@subscription-link/CANCEL_SUBSCRIPTION_LINK_CLEAR',

  DUPLICATE_SUBSCRIPTION_LINK: '@subscription-link/DUPLICATE_SUBSCRIPTION_LINK',
  DUPLICATE_SUBSCRIPTION_LINK_REQUEST: '@subscription-link/DUPLICATE_SUBSCRIPTION_LINK_REQUEST',
  DUPLICATE_SUBSCRIPTION_LINK_SUCCESS: '@subscription-link/DUPLICATE_SUBSCRIPTION_LINK_SUCCESS',
  DUPLICATE_SUBSCRIPTION_LINK_FAILURE: '@subscription-link/DUPLICATE_SUBSCRIPTION_LINK_FAILURE',
  DUPLICATE_SUBSCRIPTION_LINK_CLEAR: '@subscription-link/DUPLICATE_SUBSCRIPTION_LINK_CLEAR',

  NOTIFY_SUBSCRIPTION_LINK: '@subscription-link/NOTIFY_SUBSCRIPTION_LINK',
  NOTIFY_SUBSCRIPTION_LINK_REQUEST: '@subscription-link/NOTIFY_SUBSCRIPTION_LINK_REQUEST',
  NOTIFY_SUBSCRIPTION_LINK_SUCCESS: '@subscription-link/NOTIFY_SUBSCRIPTION_LINK_SUCCESS',
  NOTIFY_SUBSCRIPTION_LINK_FAILURE: '@subscription-link/NOTIFY_SUBSCRIPTION_LINK_FAILURE',
  NOTIFY_SUBSCRIPTION_LINK_CLEAR: '@subscription-link/NOTIFY_SUBSCRIPTION_LINK_CLEAR',

  EXPORT_SUBSCRIPTION_LINKS: '@subscription-link/EXPORT_SUBSCRIPTION_LINKS',
  EXPORT_SUBSCRIPTION_LINKS_REQUEST: '@subscription-link/EXPORT_SUBSCRIPTION_LINKS_REQUEST',
  EXPORT_SUBSCRIPTION_LINKS_SUCCESS: '@subscription-link/EXPORT_SUBSCRIPTION_LINKS_SUCCESS',
  EXPORT_SUBSCRIPTION_LINKS_FAILURE: '@subscription-link/EXPORT_SUBSCRIPTION_LINKS_FAILURE',
  EXPORT_SUBSCRIPTION_LINKS_CLEAR: '@subscription-link/EXPORT_SUBSCRIPTION_LINKS_CLEAR',

  // create update plan
  POST_CREATE_UPDATE_PLAN: '@plans/POST_CREATE_UPDATE_PLAN',
  POST_CREATE_UPDATE_PLAN_REQUEST: '@plans/POST_CREATE_UPDATE_PLAN_REQUEST',
  PATCH_UPDATE_PLAN_SUCCESS: '@plans/POST_CREATE_UPDATE_PLAN_SUCCESS',
  POST_CREATE_UPDATE_PLAN_FAILURE: '@plans/POST_CREATE_UPDATE_PLAN_FAILURE',
  POST_CREATE_UPDATE_PLAN_CLEAR: '@plans/POST_CREATE_UPDATE_PLAN_CLEAR',

  // delete plan
  DELETE_PLAN: '@plans/DELETE_PLAN',
  DELETE_PLAN_REQUEST: '@plans/DELETE_PLAN_REQUEST',
  DELETE_PLAN_SUCCESS: '@plans/DELETE_PLAN_SUCCESS',
  DELETE_PLAN_FAILURE: '@plans/DELETE_PLAN_FAILURE',
  DELETE_PLAN_CLEAR: '@plans/DELETE_PLAN_CLEAR',

  //

  // Case Management
  GET_CASE_MANAGEMENT_AUTH_ACTION:
    '@casemanagement/GET_CASE_MANAGEMENT_AUTH_ACTION',
  GET_CASE_MANAGEMENT_AUTH_REQUEST:
    '@casemanagement/GET_CASE_MANAGEMENT_AUTH_REQUEST',
  GET_CASE_MANAGEMENT_AUTH_SUCCESS:
    '@casemanagement/GET_CASE_MANAGEMENT_AUTH_SUCCESS',
  GET_CASE_MANAGEMENT_AUTH_FAILURE:
    '@casemanagement/GET_CASE_MANAGEMENT_AUTH_FAILURE',
  GET_TICKET_LIST_ACTION: '@casemanagement/GET_TICKET_LIST_ACTION',
  GET_TICKET_LIST_REQUEST: '@casemanagement/GET_TICKET_LIST_REQUEST',
  GET_TICKET_LIST_SUCCESS: '@casemanagement/GET_TICKET_LIST_SUCCESS',
  GET_TICKET_LIST_FAILURE: '@casemanagement/GET_TICKET_LIST_FAILURE',

  GET_TICKET_DETAIL_ACTION: '@casemanagement/GET_TICKET_DETAIL_ACTION',
  GET_TICKET_DETAIL_REQUEST: '@casemanagement/GET_TICKET_DETAIL_REQUEST',
  GET_TICKET_DETAIL_SUCCESS: '@casemanagement/GET_TICKET_DETAIL_SUCCESS',
  GET_TICKET_DETAIL_FAILURE: '@casemanagement/GET_TICKET_DETAIL_FAILURE',

  GET_CATEGORY_ACTION: '@casemanagement/GET_CATEGORY_ACTION',
  GET_CATEGORY_REQUEST: '@casemanagement/GET_CATEGORY_REQUEST',
  GET_CATEGORY_SUCCESS: '@casemanagement/GET_CATEGORY_SUCCESS',
  GET_CATEGORY_FAILURE: '@casemanagement/GET_CATEGORY_FAILURE',

  GET_SUBCATEGORY_ACTION: '@casemanagement/GET_SUBCATEGORY_ACTION',
  GET_SUBCATEGORY_REQUEST: '@casemanagement/GET_SUBCATEGORY_REQUEST',
  GET_SUBCATEGORY_SUCCESS: '@casemanagement/GET_SUBCATEGORY_SUCCESS',
  GET_SUBCATEGORY_FAILURE: '@casemanagement/GET_SUBCATEGORY_FAILURE',

  GET_CREATE_TICKET_ACTION: '@casemanagement/GET_CREATE_TICKET_ACTION',
  GET_CREATE_TICKET_REQUEST: '@casemanagement/GET_CREATE_TICKET_REQUEST',
  GET_CREATE_TICKET_SUCCESS: '@casemanagement/GET_CREATE_TICKET_SUCCESS',
  GET_CREATE_TICKET_FAILURE: '@casemanagement/GET_CREATE_TICKET_FAILURE',
  GET_CREATE_TICKET_CLEAR: '@casemanagement/GET_CREATE_TICKET_CLEAR',

  GET_UPLOAD_DOCUMENTS_ACTION: '@casemanagement/GET_UPLOAD_DOCUMENTS_ACTION',
  GET_UPLOAD_DOCUMENTS_REQUEST: '@casemanagement/GET_UPLOAD_DOCUMENTS_REQUEST',
  GET_UPLOAD_DOCUMENTS_SUCCESS: '@casemanagement/GET_UPLOAD_DOCUMENTS_SUCCESS',
  GET_UPLOAD_DOCUMENTS_FAILURE: '@casemanagement/GET_UPLOAD_DOCUMENTS_FAILURE',

  GET_LINK_DOCUMENTS_TO_TICKETS_ACTION:
    '@casemanagement/GET_LINK_DOCUMENTS_TO_TICKETS_ACTION',
  GET_LINK_DOCUMENTS_TO_TICKETS_REQUEST:
    '@casemanagement/GET_LINK_DOCUMENTS_TO_TICKETS_REQUEST',
  GET_LINK_DOCUMENTS_TO_TICKETS_SUCCESS:
    '@casemanagement/GET_LINK_DOCUMENTS_TO_TICKETS_SUCCESS',
  GET_LINK_DOCUMENTS_TO_TICKETS_FAILURE:
    '@casemanagement/GET_LINK_DOCUMENTS_TO_TICKETS_FAILURE',

  GET_MERCHANT_PROFILE_ACTION: '@completeprofile/GET_MERCHANT_PROFILE_ACTION',
  GET_MERCHANT_PROFILE_REQUEST: '@completeprofile/GET_MERCHANT_PROFILE_REQUEST',
  GET_MERCHANT_PROFILE_SUCCESS: '@completeprofile/GET_MERCHANT_PROFILE_SUCCESS',
  GET_MERCHANT_PROFILE_FAILURE: '@completeprofile/GET_MERCHANT_PROFILE_FAILURE',

  UPDATE_MERCHANT_PROFILE_ACTION:
    '@completeprofile/UPDATE_MERCHANT_PROFILE_ACTION',
  UPDATE_MERCHANT_PROFILE_REQUEST:
    '@completeprofile/UPDATE_MERCHANT_PROFILE_REQUEST',
  UPDATE_MERCHANT_PROFILE_SUCCESS:
    '@completeprofile/UPDATE_MERCHANT_PROFILE_SUCCESS',
  UPDATE_MERCHANT_PROFILE_FAILURE:
    '@completeprofile/UPDATE_MERCHANT_PROFILE_FAILURE',
  UPDATE_MERCHANT_PROFILE_UPDATE:
    '@completeprofile/UPDATE_MERCHANT_PROFILE_UPDATE',

  GET_IFSC_ACTION: '@completeprofile/GET_IFSC_ACTION',
  GET_IFSC_REQUEST: '@completeprofile/GET_IFSC_REQUEST',
  GET_IFSC_SUCCESS: '@completeprofile/GET_IFSC_SUCCESS',
  GET_IFSC_FAILURE: '@completeprofile/GET_IFSC_FAILURE',

  GET_SIGNZY_ACTION: '@completeprofile/GET_SIGNZY_ACTION',
  GET_SIGNZY_REQUEST: '@completeprofile/GET_SIGNZY_REQUEST',
  GET_SIGNZY_SUCCESS: '@completeprofile/GET_SIGNZY_SUCCESS',
  GET_SIGNZY_FAILURE: '@completeprofile/GET_SIGNZY_FAILURE',

  GET_PANTOGSTLIST_ACTION: '@completeprofile/GET_PANTOGSTLIST_ACTION',
  GET_PANTOGSTLIST_REQUEST: '@completeprofile/GET_PANTOGSTLIST_REQUEST',
  GET_PANTOGSTLIST_SUCCESS: '@completeprofile/GET_PANTOGSTLIST_SUCCESS',
  GET_PANTOGSTLIST_FAILURE: '@completeprofile/GET_PANTOGSTLIST_FAILURE',

  GET_PAN_VERIFY_ACTION: '@completeprofile/GET_PAN_VERIFY_ACTION',
  GET_PAN_VERIFY_REQUEST: '@completeprofile/GET_PAN_VERIFY_REQUEST',
  GET_PAN_VERIFY_SUCCESS: '@completeprofile/GET_PAN_VERIFY_SUCCESS',
  GET_PAN_VERIFY_FAILURE: '@completeprofile/GET_PAN_VERIFY_FAILURE',

  GET_BANK_VERIFY_ACTION: '@completeprofile/GET_BANK_VERIFY_ACTION',
  GET_BANK_VERIFY_REQUEST: '@completeprofile/GET_BANK_VERIFY_REQUEST',
  GET_BANK_VERIFY_SUCCESS: '@completeprofile/GET_BANK_VERIFY_SUCCESS',
  GET_BANK_VERIFY_FAILURE: '@completeprofile/GET_BANK_VERIFY_FAILURE',

  GET_ALL_COMMENTS_ACTION: '@completeprofile/GET_ALL_COMMENTS_ACTION',
  GET_ALL_COMMENTS_REQUEST: '@completeprofile/GET_ALL_COMMENTS_REQUEST',
  GET_ALL_COMMENTS_SUCCESS: '@completeprofile/GET_ALL_COMMENTS_SUCCESS',
  GET_ALL_COMMENTS_FAILURE: '@completeprofile/GET_ALL_COMMENTS_FAILURE',

  GET_ALL_ATTACHMENTS_ACTION: '@completeprofile/GET_ALL_ATTACHMENTS_ACTION',
  GET_ALL_ATTACHMENTS_REQUEST: '@completeprofile/GET_ALL_ATTACHMENTS_REQUEST',
  GET_ALL_ATTACHMENTS_SUCCESS: '@completeprofile/GET_ALL_ATTACHMENTS_SUCCESS',
  GET_ALL_ATTACHMENTS_FAILURE: '@completeprofile/GET_ALL_ATTACHMENTS_FAILURE',

  GET_PREVIEW_ACTION: '@completeprofile/GET_PREVIEW_ACTION',
  GET_PREVIEW_REQUEST: '@completeprofile/GET_PREVIEW_REQUEST',
  GET_PREVIEW_SUCCESS: '@completeprofile/GET_PREVIEW_SUCCESS',
  GET_PREVIEW_FAILURE: '@completeprofile/GET_PREVIEW_FAILURE',

  ADD_COMMENTS_ACTION: '@completeprofile/ADD_COMMENTS_ACTION',
  ADD_COMMENTS_REQUEST: '@completeprofile/ADD_COMMENTS_REQUEST',
  ADD_COMMENTS_SUCCESS: '@completeprofile/ADD_COMMENTS_SUCCESS',
  ADD_COMMENTS_FAILURE: '@completeprofile/ADD_COMMENTS_FAILURE',

  VERIFY_KYC_ACTION: '@completeprofile/VERIFY_KYC_ACTION',
  VERIFY_KYC_REQUEST: '@completeprofile/VERIFY_KYC_REQUEST',
  VERIFY_KYC_SUCCESS: '@completeprofile/VERIFY_KYC_SUCCESS',
  VERIFY_KYC_FAILURE: '@completeprofile/VERIFY_KYC_FAILURE',

  GET_STATE_ACTION: '@completeprofile/GET_STATE_ACTION',
  GET_STATE_REQUEST: '@completeprofile/GET_STATE_REQUEST',
  GET_STATE_SUCCESS: '@completeprofile/GET_STATE_SUCCESS',
  GET_STATE_FAILURE: '@completeprofile/GET_STATE_FAILURE',

  GET_CITY_ACTION: '@completeprofile/GET_CITY_ACTION',
  GET_CITY_REQUEST: '@completeprofile/GET_CITY_REQUEST',
  GET_CITY_SUCCESS: '@completeprofile/GET_CITY_SUCCESS',
  GET_CITY_FAILURE: '@completeprofile/GET_CITY_FAILURE',

  KYC_FORM_SUBMIT_ACTION: '@completeprofile/KYC_FORM_SUBMIT_ACTION',
  KYC_FORM_SUBMIT_REQUEST: '@completeprofile/KYC_FORM_SUBMIT_REQUEST',
  KYC_FORM_SUBMIT_SUCCESS: '@completeprofile/KYC_FORM_SUBMIT_SUCCESS',
  KYC_FORM_SUBMIT_FAILURE: '@completeprofile/KYC_FORM_SUBMIT_FAILURE',
  KYC_FORM_SUBMIT_CLEAR: '@completeprofile/KYC_FORM_SUBMIT_CLEAR',

  KYC_FORM_RESUBMIT_ACTION: '@completeprofile/KYC_FORM_RESUBMIT_ACTION',
  KYC_FORM_RESUBMIT_REQUEST: '@completeprofile/KYC_FORM_RESUBMIT_REQUEST',
  KYC_FORM_RESUBMIT_SUCCESS: '@completeprofile/KYC_FORM_RESUBMIT_SUCCESS',
  KYC_FORM_RESUBMIT_FAILURE: '@completeprofile/KYC_FORM_RESUBMIT_FAILURE',

  UPDATE_ACCOUNT_ACTION: '@completeprofile/UPDATE_ACCOUNT_ACTION',
  UPDATE_ACCOUNT_REQUEST: '@completeprofile/UPDATE_ACCOUNT_REQUEST',
  UPDATE_ACCOUNT_SUCCESS: '@completeprofile/UPDATE_ACCOUNT_SUCCESS',
  UPDATE_ACCOUNT_FAILURE: '@completeprofile/UPDATE_ACCOUNT_FAILURE',

  TOGGLE_ENV_ACTION: '@completeprofile/TOGGLE_ENV_ACTION',
  TOGGLE_ENV_REQUEST: '@completeprofile/TOGGLE_ENV_REQUEST',
  TOGGLE_ENV_SUCCESS: '@completeprofile/TOGGLE_ENV_SUCCESS',
  TOGGLE_ENV_FAILURE: '@completeprofile/TOGGLE_ENV_FAILURE',
  TOGGLE_ENV_CLEAR: '@completeprofile/TOGGLE_ENV_CLEAR',
  //get webhook event
  GET_WEBHOOK_EVENT_LIST: '@webhook/GET_WEBHOOK_EVENT_LIST',
  GET_WEBHOOK_EVENT_LIST_REQUEST: '@webhook/GET_WEBHOOK_EVENT_LIST_REQUEST',
  GET_WEBHOOK_EVENT_LIST_SUCCESS: '@webhook/GET_WEBHOOK_EVENT_LIST_SUCCESS',
  GET_WEBHOOK_EVENT_LIST_FAILURE: '@webhook/GET_WEBHOOK_EVENT_LIST_FAILURE',
  GET_WEBHOOK_EVENT_LIST_CLEAR: '@webhook/GET_WEBHOOK_EVENT_LIST_CLEAR',

  GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION:
    '@webhook/GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION',
  GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION_REQUEST:
    '@webhook/GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION_REQUEST',
  GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION_SUCCESS:
    '@webhook/GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION_SUCCESS',
  GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION_FAILURE:
    '@webhook/GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION_FAILURE',
  GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION_CLEAR:
    '@webhook/GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION_CLEAR',

  //get subscription event
  GET_SUBSCRIPTION_EVENT_LIST: '@webhook/GET_SUBSCRIPTION_EVENT_LIST',
  GET_SUBSCRIPTION_EVENT_LIST_REQUEST:
    '@webhook/GET_SUBSCRIPTION_EVENT_LIST_REQUEST',
  GET_SUBSCRIPTION_EVENT_LIST_SUCCESS:
    '@webhook/GET_SUBSCRIPTION_EVENT_LIST_SUCCESS',
  GET_SUBSCRIPTION_EVENT_LIST_FAILURE:
    '@webhook/GET_SUBSCRIPTION_EVENT_LIST_FAILURE',
  GET_SUBSCRIPTION_EVENT_LIST_CLEAR:
    '@webhook/GET_SUBSCRIPTION_EVENT_LIST_CLEAR',

  //register webhook event
  REGISTER_WEBHOOK_EVENT_LIST: '@webhook/REGISTER_WEBHOOK_EVENT_LIST',
  REGISTER_WEBHOOK_EVENT_LIST_REQUEST:
    '@webhook/REGISTER_WEBHOOK_EVENT_LIST_REQUEST',
  REGISTER_WEBHOOK_EVENT_LIST_SUCCESS:
    '@webhook/REGISTER_WEBHOOK_EVENT_LIST_SUCCESS',
  REGISTER_WEBHOOK_EVENT_LIST_FAILURE:
    '@webhook/REGISTER_WEBHOOK_EVENT_LIST_FAILURE',
  REGISTER_WEBHOOK_EVENT_LIST_CLEAR:
    '@webhook/REGISTER_WEBHOOK_EVENT_LIST_CLEAR',

  UNREGISTER_WEBHOOK_EVENT_LIST: '@webhook/UNREGISTER_WEBHOOK_EVENT_LIST',
  UNREGISTER_WEBHOOK_EVENT_LIST_REQUEST:
    '@webhook/UNREGISTER_WEBHOOK_EVENT_LIST_REQUEST',
  UNREGISTER_WEBHOOK_EVENT_LIST_SUCCESS:
    '@webhook/UNREGISTER_WEBHOOK_EVENT_LIST_SUCCESS',
  UNREGISTER_WEBHOOK_EVENT_LIST_FAILURE:
    '@webhook/UNREGISTER_WEBHOOK_EVENT_LIST_FAILURE',
  UNREGISTER_WEBHOOK_EVENT_LIST_CLEAR:
    '@webhook/UNREGISTER_WEBHOOK_EVENT_LIST_CLEAR',

  REGISTER_MERCHANT_ON_WEBHOOK_EVENT:
    '@webhook/REGISTER_MERCHANT_ON_WEBHOOK_EVENT',
  REGISTER_MERCHANT_ON_WEBHOOK_EVENT_REQUEST:
    '@webhook/REGISTER_MERCHANT_ON_WEBHOOK_EVENT_REQUEST',
  REGISTER_MERCHANT_ON_WEBHOOK_EVENT_SUCCESS:
    '@webhook/REGISTER_MERCHANT_ON_WEBHOOK_EVENT_SUCCESS',
  REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FAILURE:
    '@webhook/REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FAILURE',
  REGISTER_MERCHANT_ON_WEBHOOK_EVENT_CLEAR:
    '@webhook/REGISTER_MERCHANT_ON_WEBHOOK_EVENT_CLEAR',

  STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT:
    '@webhook/STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT',
  STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_REQUEST:
    '@webhook/STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_REQUEST',
  STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_SUCCESS:
    '@webhook/STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_SUCCESS',
  STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FAILURE:
    '@webhook/STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FAILURE',
  STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_CLEAR:
    '@webhook/STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_CLEAR',

  STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION:
    '@webhook/STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION',
  STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION_REQUEST:
    '@webhook/STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION_REQUEST',
  STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION_SUCCESS:
    '@webhook/STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION_SUCCESS',
  STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION_FAILURE:
    '@webhook/STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION_FAILURE',
  STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION_CLEAR:
    '@webhook/STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION_CLEAR',

  //merchant details
  GET_MERCHANT_DETAILS_FOR_DASHBOARD:
    '@admin/GET_MERCHANT_DETAILS_FOR_DASHBOARD',
  GET_MERCHANT_DETAILS_FOR_DASHBOARD_REQUEST:
    '@admin/GET_MERCHANT_DETAILS_FOR_DASHBOARD_REQUEST',
  GET_MERCHANT_DETAILS_FOR_DASHBOARD_SUCCESS:
    '@admin/GET_MERCHANT_DETAILS_FOR_DASHBOARD_SUCCESS',
  GET_MERCHANT_DETAILS_FOR_DASHBOARD_FAILURE:
    '@admin/GET_MERCHANT_DETAILS_FOR_DASHBOARD_FAILURE',
  GET_MERCHANT_DETAILS_FOR_DASHBOARD_CLEAR:
    '@admin/GET_MERCHANT_DETAILS_FOR_DASHBOARD_CLEAR',
  
     //PARTNER merchant details
GET_PARTNER_MERCHANT_DETAILS_FOR_DASHBOARD:
  '@admin/GET_PARTNER_MERCHANT_DETAILS_FOR_DASHBOARD',
  GET_PARTNER_MERCHANT_DETAILS_FOR_DASHBOARD_REQUEST:
  '@admin/GET_MERCHANT_DETAILS_FOR_DASHBOARD_REQUEST',
  GET_PARTNER_MERCHANT_DETAILS_FOR_DASHBOARD_SUCCESS:
  '@admin/GET_PARTNER_MERCHANT_DETAILS_FOR_DASHBOARD_SUCCESS',
  GET_PARTNER_MERCHANT_DETAILS_FOR_DASHBOARD_FAILURE:
  '@admin/GET_PARTNER_MERCHANT_DETAILS_FOR_DASHBOARD_FAILURE',
  GET_PARTNER_MERCHANT_DETAILS_FOR_DASHBOARD_CLEAR:
  '@admin/GET_PARTNER_MERCHANT_DETAILS_FOR_DASHBOARD_CLEAR',

  UPDATE_SELECTED_PRODUCT_ON_PATH_CHANGE:
    '@refresh-token/UPDATE_SELECTED_PRODUCT_ON_PATH_CHANGE',

  // Refund for V3/ create V3 Refund
  POST_CREATE_V3_REFUND: '@refund/POST_CREATE_V3_REFUND',
  POST_CREATE_V3_REFUND_REQUEST: '@refund/POST_CREATE_V3_REFUND_REQUEST',
  POST_CREATE_V3_REFUND_SUCCESS: '@refund/POST_CREATE_V3_REFUND_SUCCESS',
  POST_CREATE_V3_REFUND_FAILURE: '@refund/POST_CREATE_V3_REFUND_FAILURE',
  POST_CREATE_V3_REFUND_CLEAR: '@refund/POST_CREATE_V3_REFUND_CLEAR',

  // update version of edge merchants
  POST_UPDATE_MERCHANT_VERSION: '@settings/POST_UPDATE_MERCHANT_VERSION',
  POST_UPDATE_MERCHANT_VERSION_REQUEST: '@settings/POST_UPDATE_MERCHANT_VERSION_REQUEST',
  POST_UPDATE_MERCHANT_VERSION_SUCCESS: '@settings/POST_UPDATE_MERCHANT_VERSION_SUCCESS',
  POST_UPDATE_MERCHANT_VERSION_FAILURE: '@settings/POST_UPDATE_MERCHANT_VERSION_FAILURE',
  POST_UPDATE_MERCHANT_VERSION_CLEAR: '@settings/POST_UPDATE_MERCHANT_VERSION_CLEAR',

   //IMEI VALIDATION
   GET_EDGE_IMEI_TRANSACTION:'@imei/GET_EDGE_IMEI_TRANSACTION' ,
   GET_EDGE_IMEI_TRANSACTION_SUCCESS: '@imei/GET_EDGE_IMEI_TRANSACTION_SUCCESS',
   GET_EDGE_IMEI_TRANSACTION_FAILURE:'@imei/GET_EDGE_IMEI_TRANSACTION_FAILURE',
   GET_EDGE_IMEI_TRANSACTION_REQUEST:'@imei/GET_EDGE_IMEI_TRANSACTION_REQUEST',
   GET_EDGE_IMEI_TRANSACTION_CLEAR:'@imei/GET_EDGE_IMEI_TRANSACTION_CLEAR',

   //IMEI TRANSACTION DETAILS
   GET_EDGE_IMEI_TRANSACTION_DETAILS: '@imei/GET_EDGE_IMEI_TRANSACTION_DETAILS',
   GET_EDGE_IMEI_TRANSACTION_DETAILS_REQUEST: '@imei/GET_EDGE_IMEI_TRANSACTION_DETAILS_REQUEST',
   GET_EDGE_IMEI_TRANSACTION_DETAILS_SUCCESS: '@imei/GET_EDGE_IMEI_TRANSACTION_DETAILS_SUCCESS',
  GET_EDGE_IMEI_TRANSACTION_DETAILS_FAILURE: '@imei/GET_EDGE_IMEI_TRANSACTION_DETAILS_FAILURE',
  GET_EDGE_IMEI_TRANSACTION_DETAILS_CLEAR: '@imei/GET_EDGE_IMEI_TRANSACTION_DETAILS_CLEAR',
  
    //IMEI VALIDATION DETAILS
    GET_EDGE_IMEI_VALIDATION_DETAILS: '@imei/GET_EDGE_IMEI_VALIDATION_DETAILS',
    GET_EDGE_IMEI_VALIDATION_DETAILS_REQUEST: '@imei/GET_EDGE_IMEI_VALIDATION_DETAILS_REQUEST',
    GET_EDGE_IMEI_VALIDATION_DETAILS_SUCCESS: '@imei/GET_EDGE_IMEI_VALIDATION_DETAILS_SUCCESS',
   GET_EDGE_IMEI_VALIDATION_DETAILS_FAILURE: '@imei/GET_EDGE_IMEI_VALIDATION_DETAILS_FAILURE',
   GET_EDGE_IMEI_VALIDATION_DETAILS_CLEAR: '@imei/GET_EDGE_IMEI_VALIDATION_DETAILS_CLEAR',
   
   //IMEI VALIDATION BLOCKING
   POST_IMEI_BLOCK: '@imei/POST_IMEI_BLOCK',
   POST_IMEI_BLOCK_SUCCESS: '@imei/POST_IMEI_BLOCK_SUCCESS',
   POST_IMEI_BLOCK_REQUEST: '@imei/POST_IMEI_BLOCK_REQUEST',
   POST_IMEI_BLOCK_FAILURE: '@imei/POST_IMEI_BLOCK_FAILURE',
   POST_IMEI_BLOCK_CLEAR: '@imei/POST_IMEI_BLOCK_CLEAR',
  // EDGE Settlement/ Transaction List
  GET_EDGE_SETTLEMENT_TRANSACTION_LIST: '@settlement/GET_EDGE_SETTLEMENT_TRANSACTION_LIST',
  GET_EDGE_SETTLEMENT_TRANSACTION_LIST_REQUEST:
    '@settlement/GET_EDGE_SETTLEMENT_TRANSACTION_LIST_REQUEST',
  GET_EDGE_SETTLEMENT_TRANSACTION_LIST_SUCCESS:
    '@settlement/GET_EDGE_SETTLEMENT_TRANSACTION_LIST_SUCCESS',
  GET_EDGE_SETTLEMENT_TRANSACTION_LIST_FAILURE:
    '@settlement/GET_EDGE_SETTLEMENT_TRANSACTION_LIST_FAILURE',
  GET_EDGE_SETTLEMENT_TRANSACTION_LIST_CLEAR: '@settlement/GET_EDGE_SETTLEMENT_TRANSACTION_LIST_CLEAR',


  // EDGE Settlement/ Transaction List
  GET_DEDUCTION_DETAILS: '@settlement/GET_DEDUCTION_DETAILS',
  GET_DEDUCTION_DETAILS_REQUEST:
    '@settlement/GET_DEDUCTION_DETAILS_REQUEST',
  GET_DEDUCTION_DETAILS_SUCCESS:
    '@settlement/GET_DEDUCTION_DETAILS_SUCCESS',
  GET_DEDUCTION_DETAILS_FAILURE:
    '@settlement/GET_DEDUCTION_DETAILS_FAILURE',
  GET_DEDUCTION_DETAILS_CLEAR: '@settlement/GET_DEDUCTION_DETAILS_CLEAR',

  // EDGE Settlement/ MPR file location by UTR
  GET_SETTLEMENT_MPR_FILE_LOCATION:
    '@settlement/GET_SETTLEMENT_MPR_FILE_LOCATION',
  GET_SETTLEMENT_MPR_FILE_LOCATION_REQUEST:
    '@settlement/GET_SETTLEMENT_MPR_FILE_LOCATION_REQUEST',
  GET_SETTLEMENT_MPR_FILE_LOCATION_SUCCESS:
    '@settlement/GET_SETTLEMENT_MPR_FILE_LOCATION_SUCCESS',
  GET_SETTLEMENT_MPR_FILE_LOCATION_FAILURE:
    '@settlement/GET_SETTLEMENT_MPR_FILE_LOCATION_FAILURE',
  GET_SETTLEMENT_MPR_FILE_LOCATION_CLEAR:
    '@settlement/GET_SETTLEMENT_MPR_FILE_LOCATION_CLEAR',

  // EDGE Settlement/ Transaction Details List
  GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS: '@settlement/GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS',
  GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS_REQUEST:
    '@settlement/GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS_REQUEST',
  GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS_SUCCESS:
    '@settlement/GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS_SUCCESS',
  GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS_FAILURE:
    '@settlement/GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS_FAILURE',
  GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS_CLEAR: '@settlement/GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS_CLEAR',
  POST_ONDEMAND_SETTLEMENT:'@settlement/POST_ONDEMAND_SETTLEMENT',
  POST_ONDEMAND_SETTLEMENT_SUCCESS:'@settlement/POST_ONDEMAND_SETTLEMENT_SUCCESS',
  POST_ONDEMAND_SETTLEMENT_FAILURE:'@settlement/POST_ONDEMAND_SETTLEMENT_FAILURE:',
  POST_ONDEMAND_SETTLEMENT_REQUEST:'@settlement/POST_ONDEMAND_SETTLEMENT_REQUEST',
  POST_ONDEMAND_SETTLEMENT_CLEAR:'@settlement/POST_ONDEMAND_SETTLEMENT_CLEAR',

  // save and next
  POST_SELF_SERVE_SAVE_AND_NEXT: '@onboarding/POST_SELF_SERVE_SAVE_AND_NEXT',
  POST_SELF_SERVE_SAVE_AND_NEXT_REQUEST: '@onboarding/POST_SELF_SERVE_SAVE_AND_NEXT_REQUEST',
  POST_SELF_SERVE_SAVE_AND_NEXT_SUCCESS: '@onboarding/POST_SELF_SERVE_SAVE_AND_NEXT_SUCCESS',
  POST_SELF_SERVE_SAVE_AND_NEXT_FAILURE: '@onboarding/POST_SELF_SERVE_SAVE_AND_NEXT_FAILURE',
  POST_SELF_SERVE_SAVE_AND_NEXT_CLEAR: '@onboarding/POST_SELF_SERVE_SAVE_AND_NEXT_CLEAR',

  // autosave draft
  POST_AUTOSAVE_STEP: '@onboarding/POST_AUTOSAVE_STEP',
  POST_AUTOSAVE_STEP_REQUEST: '@onboarding/POST_AUTOSAVE_STEP_REQUEST',
  POST_AUTOSAVE_STEP_SUCCESS: '@onboarding/POST_AUTOSAVE_STEP_SUCCESS',
  POST_AUTOSAVE_STEP_FAILURE: '@onboarding/POST_AUTOSAVE_STEP_FAILURE',
  POST_AUTOSAVE_STEP_CLEAR: '@onboarding/POST_AUTOSAVE_STEP_CLEAR',

  // sidebar step click
  SIDEBAR_STEP_CLICK: '@onboarding/SIDEBAR_STEP_CLICK',
  SIDEBAR_STEP_CLICK_REQUEST: '@onboarding/SIDEBAR_STEP_CLICK_REQUEST',
  SIDEBAR_STEP_CLICK_SUCCESS: '@onboarding/SIDEBAR_STEP_CLICK_SUCCESS',
  SIDEBAR_STEP_CLICK_FAILURE: '@onboarding/SIDEBAR_STEP_CLICK_FAILURE',
  SIDEBAR_STEP_CLICK_CLEAR: '@onboarding/SIDEBAR_STEP_CLICK_CLEAR',

  // ALL TRANSACTIONS IN PARTNER LIST
  GET_ALL_TRANSACTION_LIST: '@transactions/GET_ALL_TRANSACTION_LIST',
  GET_ALL_TRANSACTION_LIST_SUCCESS: '@transactions/GET_ALL_TRANSACTION_LIST_SUCCESS',
  GET_ALL_TRANSACTION_LIST_FAILURE: '@transactions/GET_ALL_TRANSACTION_LIST_FAILURE',
  GET_ALL_TRANSACTION_LIST_REQUEST: '@transactions/GET_ALL_TRANSACTION_LIST_REQUEST',
  GET_ALL_TRANSACTION_LIST_CLEAR: '@transactions/GET_ALL_TRANSACTION_LIST_CLEAR',
  
  // ALL MERCHANTS IN PARTNER LIST
  GET_ALL_MERCHANT_LIST: '@merchants/GET_ALL_MERCHANT_LIST',
  GET_ALL_MERCHANT_LIST_SUCCESS: '@merchants/GET_ALL_MERCHANT_LIST_SUCCESS',
  GET_ALL_MERCHANT_LIST_FAILURE: '@merchants/GET_ALL_MERCHANT_LIST_FAILURE',
  GET_ALL_MERCHANT_LIST_REQUEST: '@merchants/GET_ALL_MERCHANT_LIST_REQUEST',
  GET_ALL_MERCHANT_LIST_CLEAR: '@merchants/GET_ALL_MERCHANT_LIST_CLEAR',
 
  // ALL MERCHANTS SUMMARY
  GET_ALL_MERCHANT_SUMMARY_LIST:'@merchants/GET_ALL_MERCHANT_SUMMARY_LIST',
  GET_ALL_MERCHANT_SUMMARY_SUCCESS:'@merchants/GET_ALL_MERCHANT_SUMMARY_LIST_SUCCESS',
  GET_ALL_MERCHANT_SUMMARY_FAILURE:'@merchants/GET_ALL_MERCHANT_SUMMARY_LIST_FAILURE',
  GET_ALL_MERCHANT_SUMMARY_REQUEST:'@merchants/GET_ALL_MERCHANT_SUMMARY_LIST_REQUEST',
  GET_ALL_MERCHANT_SUMMARY_CLEAR:'@merchants/GET_ALL_MERCHANT_SUMMARY_LIST_CLEAR',


    // ALL MERCHANTS IN PARTNER LIST
    GET_PARTNER_SUMMARY_GRAPH: '@merchants/GET_PARTNER_SUMMARY_GRAPH',
    GET_PARTNER_SUMMARY_GRAPH_SUCCESS: '@merchants/GET_PARTNER_SUMMARY_GRAPH_SUCCESS',
    GET_PARTNER_SUMMARY_GRAPH_FAILURE: '@merchants/GET_PARTNER_SUMMARY_GRAPH_FAILURE',
    GET_PARTNER_SUMMARY_GRAPH_REQUEST: '@merchants/GET_PARTNER_SUMMARY_GRAPH_REQUEST',
    GET_PARTNER_SUMMARY_GRAPH_CLEAR: '@merchants/GET_PARTNER_SUMMARY_GRAPH_CLEAR',
  // get report features
  GET_REPORT_FEATURES: '@reports/GET_REPORT_FEATURES',
  GET_REPORT_FEATURES_REQUEST: '@reports/GET_REPORT_FEATURES_REQUEST',
  GET_REPORT_FEATURES_SUCCESS: '@reports/GET_REPORT_FEATURES_SUCCESS',
  GET_REPORT_FEATURES_FAILURE: '@reports/GET_REPORT_FEATURES_FAILURE',
  GET_REPORT_FEATURES_CLEAR: '@reports/GET_REPORT_FEATURES_CLEAR',

  // Download Report

   GET_DOWNLOAD_REPORT: '@reports/GET_DOWNLOAD_REPORT',
   GET_DOWNLOAD_REPORT_REQUEST: '@reports/GET_DOWNLOAD_REPORT_REQUEST',
   GET_DOWNLOAD_REPORT_SUCCESS: '@reports/GET_DOWNLOAD_REPORT_SUCCESS',
   GET_DOWNLOAD_REPORT_FAILURE: '@reports/GET_DOWNLOAD_REPORT_FAILURE',
   GET_DOWNLOAD_REPORT_CLEAR: '@reports/GET_DOWNLOAD_REPORT_CLEAR',


  // Reports Category Details 
  GET_REPORT_CATEGORY_DETAILS: '@reports/GET_REPORT_CATEGORY_DETAILS',
  GET_REPORT_CATEGORY_DETAILS_REQUEST: '@reports/GET_REPORT_CATEGORY_DETAILS_REQUEST',
  GET_REPORT_CATEGORY_DETAILS_SUCCESS: '@reports/GET_REPORT_CATEGORY_DETAILS_SUCCESS',
  GET_REPORT_CATEGORY_DETAILS_FAILURE: '@reports/GET_REPORT_CATEGORY_DETAILS_FAILURE',
  GET_REPORT_CATEGORY_DETAILS_CLEAR: '@reports/GET_REPORT_CATEGORY_DETAILS_CLEAR',


  // get user emails
  GET_REPORT_USER_EMAILS: '@reports/GET_REPORT_USER_EMAILS',
  GET_REPORT_USER_EMAILS_REQUEST: '@reports/GET_REPORT_USER_EMAILS_REQUEST',
  GET_REPORT_USER_EMAILS_SUCCESS: '@reports/GET_REPORT_USER_EMAILS_SUCCESS',
  GET_REPORT_USER_EMAILS_FAILURE: '@reports/GET_REPORT_USER_EMAILS_FAILURE',
  GET_REPORT_USER_EMAILS_CLEAR: '@reports/GET_REPORT_USER_EMAILS_CLEAR',

  // generate instant reports
  GENERATE_INSTANT_REPORTS: '@reports/GENERATE_INSTANT_REPORTS',
  GENERATE_INSTANT_REPORTS_REQUEST: '@reports/GENERATE_INSTANT_REPORTS_REQUEST',
  GENERATE_INSTANT_REPORTS_SUCCESS: '@reports/GENERATE_INSTANT_REPORTS_SUCCESS',
  GENERATE_INSTANT_REPORTS_FAILURE: '@reports/GENERATE_INSTANT_REPORTS_FAILURE',
  GENERATE_INSTANT_REPORTS_CLEAR: '@reports/GENERATE_INSTANT_REPORTS_CLEAR',

  GET_ALL_REPORT_LIST: '@reports/GET_ALL_REPORT_LIST',
  GET_ALL_REPORT_LIST_SUCCESS: '@reports/GET_ALL_REPORT_LIST_SUCCESS',
  GET_ALL_REPORT_LIST_FAILURE: '@reports/GET_ALL_REPORT_LIST_FAILURE',
  GET_ALL_REPORT_LIST_REQUEST: '@reports/GET_ALL_REPORT_LIST_REQUEST',
  GET_ALL_REPORT_LIST_CLEAR: '@reports/GET_ALL_REPORT_LIST_CLEAR',

  GET_SCHEDULE_REPORT_LIST: '@reports/GET_SCHEDULE_REPORT_LIST',
  GET_SCHEDULE_REPORT_LIST_SUCCESS: '@reports/GET_SCHEDULE_REPORT_LIST_SUCCESS',
  GET_SCHEDULE_REPORT_LIST_FAILURE: '@reports/GET_SCHEDULE_REPORT_LIST_FAILURE',
  GET_SCHEDULE_REPORT_LIST_REQUEST: '@reports/GET_SCHEDULE_REPORT_LIST_REQUEST',
  GET_SCHEDULE_REPORT_LIST_CLEAR: '@reports/GET_SCHEDULE_REPORT_LIST_CLEAR',

  GET_MASTER_LIST: '@reports/ GET_MASTER_LIST',
  GET_MASTER_LIST_SUCCESS: '@reports/ GET_MASTER_LIST_SUCCESS',
  GET_MASTER_LIST_FAILURE: '@reports/ GET_MASTER_LIST_FAILURE',
  GET_MASTER_LIST_REQUEST: '@reports/ GET_MASTER_LIST_REQUEST',
  GET_MASTER_LIST_CLEAR: '@reports/ GET_MASTER_LIST_CLEAR',
  // Save Business Details
  POST_SAVE_BUSINESS_DETAILS: '@onboarding/POST_SAVE_BUSINESS_DETAILS',
  POST_SAVE_BUSINESS_DETAILS_REQUEST: '@onboarding/POST_SAVE_BUSINESS_DETAILS_REQUEST',
  POST_SAVE_BUSINESS_DETAILS_SUCCESS: '@onboarding/POST_SAVE_BUSINESS_DETAILS_SUCCESS',
  POST_SAVE_BUSINESS_DETAILS_FAILURE: '@onboarding/POST_SAVE_BUSINESS_DETAILS_FAILURE',
  POST_SAVE_BUSINESS_DETAILS_CLEAR: '@onboarding/POST_SAVE_BUSINESS_DETAILS_CLEAR',

  // KYC Verification
  POST_KYC_VERIFICATION: '@onboarding/POST_KYC_VERIFICATION',
  POST_KYC_VERIFICATION_REQUEST: '@onboarding/POST_KYC_VERIFICATION_REQUEST',
  POST_KYC_VERIFICATION_SUCCESS: '@onboarding/POST_KYC_VERIFICATION_SUCCESS',
  POST_KYC_VERIFICATION_FAILURE: '@onboarding/POST_KYC_VERIFICATION_FAILURE',
  POST_KYC_VERIFICATION_CLEAR: '@onboarding/POST_KYC_VERIFICATION_CLEAR',

  // POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_SUCCESS
  POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION: '@onboarding/POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION',
  POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_REQUEST: '@onboarding/POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_REQUEST',
  POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_SUCCESS: '@onboarding/POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_SUCCESS',
  POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_FAILURE: '@onboarding/POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_FAILURE',
  POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_CLEAR: '@onboarding/POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_CLEAR',

  // Fetch KYC Details
  POST_FETCH_KYC_DETAILS: '@onboarding/POST_FETCH_KYC_DETAILS',
  POST_FETCH_KYC_DETAILS_REQUEST: '@onboarding/POST_FETCH_KYC_DETAILS_REQUEST',
  POST_FETCH_KYC_DETAILS_SUCCESS: '@onboarding/POST_FETCH_KYC_DETAILS_SUCCESS',
  POST_FETCH_KYC_DETAILS_FAILURE: '@onboarding/POST_FETCH_KYC_DETAILS_FAILURE',
  POST_FETCH_KYC_DETAILS_CLEAR: '@onboarding/POST_FETCH_KYC_DETAILS_CLEAR',

  // Product Listing
  GET_PRODUCT_LISTING: '@onboarding/GET_PRODUCT_LISTING',
  GET_PRODUCT_LISTING_REQUEST: '@onboarding/GET_PRODUCT_LISTING_REQUEST',
  GET_PRODUCT_LISTING_SUCCESS: '@onboarding/GET_PRODUCT_LISTING_SUCCESS',
  GET_PRODUCT_LISTING_FAILURE: '@onboarding/GET_PRODUCT_LISTING_FAILURE',
  GET_PRODUCT_LISTING_CLEAR: '@onboarding/GET_PRODUCT_LISTING_CLEAR',

  // Selcted Product Listing
  POST_SELECTED_PRODUCT_LISTING: '@onboarding/POST_SELECTED_PRODUCT_LISTING',
  POST_SELECTED_PRODUCT_LISTING_REQUEST: '@onboarding/POST_SELECTED_PRODUCT_LISTING_REQUEST',
  POST_SELECTED_PRODUCT_LISTING_SUCCESS: '@onboarding/POST_SELECTED_PRODUCT_LISTING_SUCCESS',
  POST_SELECTED_PRODUCT_LISTING_FAILURE: '@onboarding/POST_SELECTED_PRODUCT_LISTING_FAILURE',
  POST_SELECTED_PRODUCT_LISTING_CLEAR: '@onboarding/POST_SELECTED_PRODUCT_LISTING_CLEAR',

  // PAN validation
  POST_PAN_VALIDATION: '@onboarding/POST_PAN_VALIDATION',
  POST_PAN_VALIDATION_REQUEST: '@onboarding/POST_PAN_VALIDATION_REQUEST',
  POST_PAN_VALIDATION_SUCCESS: '@onboarding/POST_PAN_VALIDATION_SUCCESS',
  POST_PAN_VALIDATION_FAILURE: '@onboarding/POST_PAN_VALIDATION_FAILURE',
  POST_PAN_VALIDATION_CLEAR: '@onboarding/POST_PAN_VALIDATION_CLEAR',

  // Fetch GST number from PAN
  POST_FETCH_GST_DETAILS: '@onboarding/POST_FETCH_GST_DETAILS',
  POST_FETCH_GST_DETAILS_REQUEST: '@onboarding/POST_FETCH_GST_DETAILS_REQUEST',
  POST_FETCH_GST_DETAILS_SUCCESS: '@onboarding/POST_FETCH_GST_DETAILS_SUCCESS',
  POST_FETCH_GST_DETAILS_FAILURE: '@onboarding/POST_FETCH_GST_DETAILS_FAILURE',
  POST_FETCH_GST_DETAILS_CLEAR: '@onboarding/POST_FETCH_GST_DETAILS_CLEAR',
  
  // GST Validation
  POST_GST_VALIDATION: '@onboarding/POST_GST_VALIDATION',
  POST_GST_VALIDATION_REQUEST: '@onboarding/POST_GST_VALIDATION_REQUEST',
  POST_GST_VALIDATION_SUCCESS: '@onboarding/POST_GST_VALIDATION_SUCCESS',
  POST_GST_VALIDATION_FAILURE: '@onboarding/POST_GST_VALIDATION_FAILURE',
  POST_GST_VALIDATION_CLEAR: '@onboarding/POST_GST_VALIDATION_CLEAR',

  // Account Verification
  POST_BANK_ACCOUNT_VERIFICATION: 'POST_BANK_ACCOUNT_VERIFICATION',
  POST_BANK_ACCOUNT_VERIFICATION_SUCCESS: 'POST_BANK_ACCOUNT_VERIFICATION_SUCCESS',
  POST_BANK_ACCOUNT_VERIFICATION_FAILURE: 'POST_BANK_ACCOUNT_VERIFICATION_FAILURE',
  POST_BANK_ACCOUNT_VERIFICATION_REQUEST: 'POST_BANK_ACCOUNT_VERIFICATION_REQUEST',
  POST_BANK_ACCOUNT_VERIFICATION_CLEAR: 'POST_BANK_ACCOUNT_VERIFICATION_CLEAR',

  // GET STEP DETAILS
  GET_STEP_DETAILS: '@onboarding/GET_STEP_DETAILS',
  GET_STEP_DETAILS_SUCCESS: '@onboarding/GET_STEP_DETAILS_SUCCESS',
  GET_STEP_DETAILS_FAILURE: '@onboarding/GET_STEP_DETAILS_FAILURE',
  GET_STEP_DETAILS_REQUEST: '@onboarding/GET_STEP_DETAILS_REQUEST',

  // fetch mcc details
  GET_MCC_DETAILS: '@onboarding/GET_MCC_DETAILS',
  GET_MCC_DETAILS_SUCCESS: '@onboarding/GET_MCC_DETAILS_SUCCESS',
  GET_MCC_DETAILS_FAILURE: '@onboarding/GET_MCC_DETAILS_FAILURE',
  GET_MCC_DETAILS_REQUEST: '@onboarding/GET_MCC_DETAILS_REQUEST',
  GET_MCC_DETAILS_CLEAR: '@onboarding/GET_MCC_DETAILS_CLEAR',

  // get verification from digilocker
  
  GET_DIGI_VERIFY: '@onboarding/GET_DIGI_VERIFY',
  GET_DIGI_VERIFY_SUCCESS: '@onboarding/GET_DIGI_VERIFY_SUCCESS',
  GET_DIGI_VERIFY_FAILURE: '@onboarding/GET_DIGI_VERIFY_FAILURE',
  GET_DIGI_VERIFY_REQUEST: '@onboarding/GET_DIGI_VERIFY_REQUEST',
  GET_DIGI_VERIFY_CLEAR: '@onboarding/GET_DIGI_VERIFY_CLEAR',

  // get details from digilocker
  GET_DIGI_DETAILS: '@onboarding/GET_DIGI_DETAILS',
  GET_DIGI_DETAILS_SUCCESS: '@onboarding/GET_DIGI_DETAILS_SUCCESS',
  GET_DIGI_DETAILS_FAILURE: '@onboarding/GET_DIGI_DETAILS_FAILURE',
  GET_DIGI_DETAILS_REQUEST: '@onboarding/GET_DIGI_DETAILS_REQUEST',
  GET_DIGI_DETAILS_CLEAR: '@onboarding/GET_DIGI_DETAILS_CLEAR',

  // get pan and gst details
  
  GET_PAN_AND_GST_DETAILS: '@onboarding/GET_PAN_AND_GST_DETAILS',
  GET_PAN_AND_GST_DETAILS_SUCCESS: '@onboarding/GET_PAN_AND_GST_DETAILS_SUCCESS',
  GET_PAN_AND_GST_DETAILS_FAILURE: '@onboarding/GET_PAN_AND_GST_DETAILS_FAILURE',
  GET_PAN_AND_GST_DETAILS_REQUEST: '@onboarding/GET_PAN_AND_GST_DETAILS_REQUEST',
  GET_PAN_AND_GST_DETAILS_CLEAR: '@onboarding/GET_PAN_AND_GST_DETAILS_CLEAR',


  // get video kyc url

  GET_VIDEO_KYC_URL: '@onboarding/GET_VIDEO_KYC_URL',
  GET_VIDEO_KYC_URL_SUCCESS: '@onboarding/GET_VIDEO_KYC_URL_SUCCESS',
  GET_VIDEO_KYC_URL_FAILURE: '@onboarding/GET_VIDEO_KYC_URL_FAILURE',
  GET_VIDEO_KYC_URL_REQUEST: '@onboarding/GET_VIDEO_KYC_URL_REQUEST',
  GET_VIDEO_KYC_URL_CLEAR: '@onboarding/GET_VIDEO_KYC_URL_CLEAR',


  // get video kyc status 
  GET_VIDEO_KYC_STATUS: '@onboarding/GET_VIDEO_KYC_STATUS',
  GET_VIDEO_KYC_STATUS_SUCCESS: '@onboarding/GET_VIDEO_KYC_STATUS_SUCCESS',
  GET_VIDEO_KYC_STATUS_FAILURE: '@onboarding/GET_VIDEO_KYC_STATUS_FAILURE',
  GET_VIDEO_KYC_STATUS_REQUEST: '@onboarding/GET_VIDEO_KYC_STATUS_REQUEST',

  // complete video kyc journey

  COMPLETE_VIDEO_KYC_JOURNEY: '@onboarding/COMPLETE_VIDEO_KYC_JOURNEY',
  COMPLETE_VIDEO_KYC_JOURNEY_SUCCESS: '@onboarding/COMPLETE_VIDEO_KYC_JOURNEY_SUCCESS',
  COMPLETE_VIDEO_KYC_JOURNEY_FAILURE: '@onboarding/COMPLETE_VIDEO_KYC_JOURNEY_FAILURE',
  COMPLETE_VIDEO_KYC_JOURNEY_REQUEST: '@onboarding/COMPLETE_VIDEO_KYC_JOURNEY_REQUEST',


  // get states data of cities 
  GET_STATES_DATA: '@onboarding/GET_STATES_DATA',
  GET_STATES_DATA_SUCCESS: '@onboarding/GET_STATES_DATA_SUCCESS',
  GET_STATES_DATA_FAILURE: '@onboarding/GET_STATES_DATA_FAILURE',
  GET_STATES_DATA_REQUEST: '@onboarding/GET_STATES_DATA_REQUEST',

  // get cities data from states 
  GET_CITY_DATA: '@onboarding/GET_CITY_DATA',
  GET_CITY_DATA_SUCCESS: '@onboarding/GET_CITY_DATA_SUCCESS',
  GET_CITY_DATA_FAILURE: '@onboarding/GET_CITY_DATA_FAILURE',
  GET_CITY_DATA_REQUEST: '@onboarding/GET_CITY_DATA_REQUEST',


  // update review details step
  UPDATE_REVIEW_STEP: '@onboarding/UPDATE_REVIEW_STEP',
  UPDATE_REVIEW_STEP_SUCCESS: '@onboarding/UPDATE_REVIEW_STEP_SUCCESS',
  UPDATE_REVIEW_STEP_FAILURE: '@onboarding/UPDATE_REVIEW_STEP_FAILURE',
  UPDATE_REVIEW_STEP_REQUEST: '@onboarding/UPDATE_REVIEW_STEP_REQUEST',


  // get kyc image 

  GET_KYC_IMAGE: '@onboarding/GET_KYC_IMAGE',
  GET_KYC_IMAGE_SUCCESS: '@onboarding/GET_KYC_IMAGE_SUCCESS',
  GET_KYC_IMAGE_FAILURE: '@onboarding/GET_KYC_IMAGE_FAILURE',
  GET_KYC_IMAGE_REQUEST: '@onboarding/GET_KYC_IMAGE_REQUEST',

  // send otp pdf

  POST_SEND_OTP_PDF: '@onboarding/POST_SEND_OTP_PDF',
  POST_SEND_OTP_PDF_SUCCESS: '@onboarding/POST_SEND_OTP_PDF_SUCCESS',
  POST_SEND_OTP_PDF_FAILURE: '@onboarding/POST_SEND_OTP_PDF_FAILURE',
  POST_SEND_OTP_PDF_REQUEST: '@onboarding/POST_SEND_OTP_PDF_REQUEST',
  POST_SEND_OTP_PDF_CLEAR: '@onboarding/POST_SEND_OTP_PDF_CLEAR',

  // verify otp
  
  POST_VERIFY_OTP_PDF: '@onboarding/POST_VERIFY_OTP_PDF',
  POST_VERIFY_OTP_PDF_SUCCESS: '@onboarding/POST_VERIFY_OTP_PDF_SUCCESS',
  POST_VERIFY_OTP_PDF_FAILURE: '@onboarding/POST_VERIFY_OTP_PDF_FAILURE',
  POST_VERIFY_OTP_PDF_REQUEST: '@onboarding/POST_VERIFY_OTP_PDF_REQUEST',
  POST_VERIFY_OTP_PDF_CLEAR: '@onboarding/POST_VERIFY_OTP_PDF_CLEAR',

  // show pdf

  SHOW_PDF: '@onboarding/SHOW_PDF',
  SHOW_PDF_SUCCESS: '@onboarding/SHOW_PDF_SUCCESS',
  SHOW_PDF_FAILURE: '@onboarding/SHOW_PDF_FAILURE',
  SHOW_PDF_REQUEST: '@onboarding/SHOW_PDF_REQUEST',
  SHOW_PDF_CLEAR: '@onboarding/SHOW_PDF_CLEAR',

  // opportunity status

  SHOW_OPPORTUNITY_STATUS: '@onboarding/SHOW_OPPORTUNITY_STATUS',
  SHOW_OPPORTUNITY_STATUS_SUCCESS: '@onboarding/SHOW_OPPORTUNITY_STATUS_SUCCESS',
  SHOW_OPPORTUNITY_STATUS_FAILURE: '@onboarding/SHOW_OPPORTUNITY_STATUS_FAILURE',
  SHOW_OPPORTUNITY_STATUS_REQUEST: '@onboarding/SHOW_OPPORTUNITY_STATUS_REQUEST',

  // toggle environment
  TOGGLE_ENVIRONMENT: '@onboarding/TOGGLE_ENVIRONMENT',
  TOGGLE_ENVIRONMENT_SUCCESS: '@onboarding/TOGGLE_ENVIRONMENT_SUCCESS',
  TOGGLE_ENVIRONMENT_FAILURE: '@onboarding/TOGGLE_ENVIRONMENT_FAILURE',
  TOGGLE_ENVIRONMENT_REQUEST: '@onboarding/TOGGLE_ENVIRONMENT_REQUEST',
  TOGGLE_ENVIRONMENT_CLEAR: '@onboarding/TOGGLE_ENVIRONMENT_CLEAR',
  GET_ONDEMAND_SETTLEMENT:'@settlement/GET_ONDEMAND_SETTLEMENT',
  GET_ONDEMAND_SETTLEMENT_SUCCESS:'@settlement/GET_ONDEMAND_SETTLEMENT_SUCCESS',
  GET_ONDEMAND_SETTLEMENT_FAILURE:'@settlement/GET_ONDEMAND_SETTLEMENT_FAILURE',
  GET_ONDEMAND_SETTLEMENT_REQUEST:'@settlement/GET_ONDEMAND_SETTLEMENT_REQUEST',

  // BPCL Onboarding

  POST_CIN_NUMBER_VALIDATION: '@onboarding/POST_CIN_NUMBER_VALIDATION',
  POST_CIN_NUMBER_VALIDATION_REQUEST: '@onboarding/POST_CIN_NUMBER_VALIDATION_REQUEST',
  POST_CIN_NUMBER_VALIDATION_SUCCESS: '@onboarding/POST_CIN_NUMBER_VALIDATION_SUCCESS',
  POST_CIN_NUMBER_VALIDATION_FAILURE: '@onboarding/POST_CIN_NUMBER_VALIDATION_FAILURE',
  POST_CIN_NUMBER_VALIDATION_CLEAR: '@onboarding/POST_CIN_NUMBER_VALIDATION_CLEAR',

  CREATE_REVIEW_REQUEST: '@onboarding/CREATE_REVIEW_REQUEST',
  CREATE_REVIEW_REQUEST_SUCCESS: '@onboarding/CREATE_REVIEW_REQUEST_SUCCESS',
  CREATE_REVIEW_REQUEST_FAILURE: '@onboarding/CREATE_REVIEW_REQUEST_FAILURE',
  CREATE_REVIEW_REQUEST_REQUEST: '@onboarding/CREATE_REVIEW_REQUEST_REQUEST',
  CREATE_REVIEW_REQUEST_CLEAR: '@onboarding/CREATE_REVIEW_REQUEST_CLEAR',

  DELETE_REVIEW_REQUEST: '@onboarding/DELETE_REVIEW_REQUEST',
  DELETE_REVIEW_REQUEST_SUCCESS: '@onboarding/DELETE_REVIEW_REQUEST_SUCCESS',
  DELETE_REVIEW_REQUEST_FAILURE: '@onboarding/DELETE_REVIEW_REQUEST_FAILURE',
  DELETE_REVIEW_REQUEST_REQUEST: '@onboarding/DELETE_REVIEW_REQUEST_REQUEST',
  DELETE_REVIEW_REQUEST_CLEAR: '@onboarding/DELETE_REVIEW_REQUEST_CLEAR',


  CONFIRM_CHILD_SELECTION: '@onboarding/CONFIRM_CHILD_SELECTION',
  CONFIRM_CHILD_SELECTION_SUCCESS: '@onboarding/CONFIRM_CHILD_SELECTION_SUCCESS',
  CONFIRM_CHILD_SELECTION_FAILURE: '@onboarding/CONFIRM_CHILD_SELECTION_FAILURE',
  CONFIRM_CHILD_SELECTION_REQUEST: '@onboarding/CONFIRM_CHILD_SELECTION_REQUEST',
  CONFIRM_CHILD_SELECTION_CLEAR: '@onboarding/CONFIRM_CHILD_SELECTION_CLEAR',

  FETCH_UPLOAD_DOCUMENTS: '@onboarding/FETCH_UPLOAD_DOCUMENTS',
  FETCH_UPLOAD_DOCUMENTS_SUCCESS: '@onboarding/FETCH_UPLOAD_DOCUMENTS_SUCCESS',
  FETCH_UPLOAD_DOCUMENTS_FAILURE: '@onboarding/FETCH_UPLOAD_DOCUMENTS_FAILURE',
  FETCH_UPLOAD_DOCUMENTS_REQUEST: '@onboarding/FETCH_UPLOAD_DOCUMENTS_REQUEST',
  FETCH_UPLOAD_DOCUMENTS_CLEAR: '@onboarding/FETCH_UPLOAD_DOCUMENTS_CLEAR',

  UPLOAD_DOCUMENT: '@onboarding/UPLOAD_DOCUMENT',
  UPLOAD_DOCUMENT_SUCCESS: '@onboarding/UPLOAD_DOCUMENT_SUCCESS',
  UPLOAD_DOCUMENT_FAILURE: '@onboarding/UPLOAD_DOCUMENT_FAILURE',
  UPLOAD_DOCUMENT_REQUEST: '@onboarding/UPLOAD_DOCUMENT_REQUEST',
  UPLOAD_DOCUMENT_CLEAR: '@onboarding/UPLOAD_DOCUMENT_CLEAR',

  REJECTION_CLARIFICATION: '@onboarding/REJECTION_CLARIFICATION',
  REJECTION_CLARIFICATION_SUCCESS: '@onboarding/REJECTION_CLARIFICATION_SUCCESS',
  REJECTION_CLARIFICATION_FAILURE: '@onboarding/REJECTION_CLARIFICATION_FAILURE',
  REJECTION_CLARIFICATION_REQUEST: '@onboarding/REJECTION_CLARIFICATION_REQUEST',
  REJECTION_CLARIFICATION_CLEAR: '@onboarding/REJECTION_CLARIFICATION_CLEAR',

  GENERATE_ESIGN_URL: '@onboarding/GENERATE_ESIGN_URL',
  GENERATE_ESIGN_URL_SUCCESS: '@onboarding/GENERATE_ESIGN_URL_SUCCESS',
  GENERATE_ESIGN_URL_FAILURE: '@onboarding/GENERATE_ESIGN_URL_FAILURE',
  GENERATE_ESIGN_URL_REQUEST: '@onboarding/GENERATE_ESIGN_URL_REQUEST',
  GENERATE_ESIGN_URL_CLEAR: '@onboarding/GENERATE_ESIGN_URL_CLEAR',

  GET_ESIGN_STATUS: '@onboarding/GET_ESIGN_STATUS',
  GET_ESIGN_STATUS_SUCCESS: '@onboarding/GET_ESIGN_STATUS_SUCCESS',
  GET_ESIGN_STATUS_FAILURE: '@onboarding/GET_ESIGN_STATUS_FAILURE',
  GET_ESIGN_STATUS_REQUEST: '@onboarding/GET_ESIGN_STATUS_REQUEST',
  GET_ESIGN_STATUS_CLEAR: '@onboarding/GET_ESIGN_STATUS_CLEAR',

  SEND_EMAIL_COMPANY_DIRECTOR: '@onboarding/SEND_EMAIL_COMPANY_DIRECTOR',
  SEND_EMAIL_COMPANY_DIRECTOR_SUCCESS: '@onboarding/SEND_EMAIL_COMPANY_DIRECTOR_SUCCESS',
  SEND_EMAIL_COMPANY_DIRECTOR_FAILURE: '@onboarding/SEND_EMAIL_COMPANY_DIRECTOR_FAILURE',
  SEND_EMAIL_COMPANY_DIRECTOR_REQUEST: '@onboarding/SEND_EMAIL_COMPANY_DIRECTOR_REQUEST',
  SEND_EMAIL_COMPANY_DIRECTOR_CLEAR: '@onboarding/SEND_EMAIL_COMPANY_DIRECTOR_CLEAR',

  ADD_AND_UPDATE_BENEFICIARY: '@onboarding/ADD_AND_UPDATE_BENEFICIARY',
  ADD_AND_UPDATE_BENEFICIARY_SUCCESS: '@onboarding/ADD_AND_UPDATE_BENEFICIARY_SUCCESS',
  ADD_AND_UPDATE_BENEFICIARY_FAILURE: '@onboarding/ADD_AND_UPDATE_BENEFICIARY_FAILURE',
  ADD_AND_UPDATE_BENEFICIARY_REQUEST: '@onboarding/ADD_AND_UPDATE_BENEFICIARY_REQUEST',
  ADD_AND_UPDATE_BENEFICIARY_CLEAR: '@onboarding/ADD_AND_UPDATE_BENEFICIARY_CLEAR',

  RESEND_EMAIL_BENEFICIARY: '@onboarding/RESEND_EMAIL_BENEFICIARY',
  RESEND_EMAIL_BENEFICIARY_SUCCESS: '@onboarding/RESEND_EMAIL_BENEFICIARY_SUCCESS',
  RESEND_EMAIL_BENEFICIARY_FAILURE: '@onboarding/RESEND_EMAIL_BENEFICIARY_FAILURE',
  RESEND_EMAIL_BENEFICIARY_REQUEST: '@onboarding/RESEND_EMAIL_BENEFICIARY_REQUEST',
  RESEND_EMAIL_BENEFICIARY_CLEAR: '@onboarding/RESEND_EMAIL_BENEFICIARY_CLEAR',

  GET_BENEFICIARY_OWNERS: '@onboarding/GET_BENEFICIARY_OWNERS',
  GET_BENEFICIARY_OWNERS_SUCCESS: '@onboarding/GET_BENEFICIARY_OWNERS_SUCCESS',
  GET_BENEFICIARY_OWNERS_FAILURE: '@onboarding/GET_BENEFICIARY_OWNERS_FAILURE',
  GET_BENEFICIARY_OWNERS_REQUEST: '@onboarding/GET_BENEFICIARY_OWNERS_REQUEST',
  GET_BENEFICIARY_OWNERS_CLEAR: '@onboarding/GET_BENEFICIARY_OWNERS_CLEAR',

  SEND_EMAIL_KYC_AGREEMENT: '@onboarding/SEND_EMAIL_KYC_AGREEMENT',
  SEND_EMAIL_KYC_AGREEMENT_SUCCESS: '@onboarding/SEND_EMAIL_KYC_AGREEMENT_SUCCESS',
  SEND_EMAIL_KYC_AGREEMENT_FAILURE: '@onboarding/SEND_EMAIL_KYC_AGREEMENT_FAILURE',
  SEND_EMAIL_KYC_AGREEMENT_REQUEST: '@onboarding/SEND_EMAIL_KYC_AGREEMENT_REQUEST',
  SEND_EMAIL_KYC_AGREEMENT_CLEAR: '@onboarding/SEND_EMAIL_KYC_AGREEMENT_CLEAR',

  PAN_KYC_AGREEMENT: '@onboarding/PAN_KYC_AGREEMENT',
  PAN_KYC_AGREEMENT_SUCCESS: '@onboarding/PAN_KYC_AGREEMENT_SUCCESS',
  PAN_KYC_AGREEMENT_FAILURE: '@onboarding/PAN_KYC_AGREEMENT_FAILURE',
  PAN_KYC_AGREEMENT_REQUEST: '@onboarding/PAN_KYC_AGREEMENT_REQUEST',
  PAN_KYC_AGREEMENT_CLEAR: '@onboarding/PAN_KYC_AGREEMENT_CLEAR',

  GET_AGREEMENT_ESIGN_URL: '@onboarding/GET_AGREEMENT_ESIGN_URL',
  GET_AGREEMENT_ESIGN_URL_SUCCESS: '@onboarding/GET_AGREEMENT_ESIGN_URL_SUCCESS',
  GET_AGREEMENT_ESIGN_URL_FAILURE: '@onboarding/GET_AGREEMENT_ESIGN_URL_FAILURE',
  GET_AGREEMENT_ESIGN_URL_REQUEST: '@onboarding/GET_AGREEMENT_ESIGN_URL_REQUEST',
  GET_AGREEMENT_ESIGN_URL_CLEAR: '@onboarding/GET_AGREEMENT_ESIGN_URL_CLEAR',

  GET_DOCUMENT_ESIGN_STATUS: '@onboarding/GET_DOCUMENT_ESIGN_STATUS',
  GET_DOCUMENT_ESIGN_STATUS_SUCCESS: '@onboarding/GET_DOCUMENT_ESIGN_STATUS_SUCCESS',
  GET_DOCUMENT_ESIGN_STATUS_FAILURE: '@onboarding/GET_DOCUMENT_ESIGN_STATUS_FAILURE',
  GET_DOCUMENT_ESIGN_STATUS_REQUEST: '@onboarding/GET_DOCUMENT_ESIGN_STATUS_REQUEST',
  GET_DOCUMENT_ESIGN_STATUS_CLEAR: '@onboarding/GET_DOCUMENT_ESIGN_STATUS_CLEAR',

  GET_AGREEMENT_ESIGN_STATUS: '@onboarding/GET_AGREEMENT_ESIGN_STATUS',
  GET_AGREEMENT_ESIGN_STATUS_SUCCESS: '@onboarding/GET_AGREEMENT_ESIGN_STATUS_SUCCESS',
  GET_AGREEMENT_ESIGN_STATUS_FAILURE: '@onboarding/GET_AGREEMENT_ESIGN_STATUS_FAILURE',
  GET_AGREEMENT_ESIGN_STATUS_REQUEST: '@onboarding/GET_AGREEMENT_ESIGN_STATUS_REQUEST',
  GET_AGREEMENT_ESIGN_STATUS_CLEAR: '@onboarding/GET_AGREEMENT_ESIGN_STATUS_CLEAR',

  DOWNLOAD_REPORTS: '@onboarding/DOWNLOAD_REPORTS',
  DOWNLOAD_REPORTS_SUCCESS: '@onboarding/DOWNLOAD_REPORTS_SUCCESS',
  DOWNLOAD_REPORTS_FAILURE: '@onboarding/DOWNLOAD_REPORTS_FAILURE',
  DOWNLOAD_REPORTS_REQUEST: '@onboarding/DOWNLOAD_REPORTS_REQUEST',
  DOWNLOAD_REPORTS_CLEAR: '@onboarding/DOWNLOAD_REPORTS_CLEAR',

  GET_ONDEMAND_SETTLEMENT_STATUS:'@settlement/GET_ONDEMAND_SETTLEMENT_STATUS',
  GET_ONDEMAND_SETTLEMENT_STATUS_SUCCESS:'@settlement/GET_ONDEMAND_SETTLEMENT_STATUS_SUCCESS',
  GET_ONDEMAND_SETTLEMENT_STATUS_FAILURE:'@settlement/GET_ONDEMAND_SETTLEMENT_STATUS_FAILURE',
  GET_ONDEMAND_SETTLEMENT_STATUS_REQUEST:'@settlement/GET_ONDEMAND_SETTLEMENT_STATUS_REQUEST',


  MERCHANT_ODS_DATA:'@merchant-listing/MERCHANT_ODS_DATA',
  MERCHANT_ODS_DATA_SUCCESS:'@merchant-listing/MERCHANT_ODS_DATA_SUCCESS',
  MERCHANT_ODS_DATA_FAILURE:'@merchant-listing/MERCHANT_ODS_DATA_FAILURE',
  MERCHANT_ODS_DATA_REQUEST:'@merchant-listing/MERCHANT_ODS_DATA_REQUEST',

  GET_ONDEMAND_SETTLEMENT_HISTORY_DATA:'@settlement/GET_ONDEMAND_SETTLEMENT_HISTORY_DATA',
  GET_ONDEMAND_SETTLEMENT_HISTORY_DATA_SUCCESS:'@settlement/GET_ONDEMAND_SETTLEMENT_HISTORY_DATA_SUCCESS',
  GET_ONDEMAND_SETTLEMENT_HISTORY_DATA_FAILURE: '@settlement/GET_ONDEMAND_SETTLEMENT_HISTORY_DATA_FAILURE',
  GET_ONDEMAND_SETTLEMENT_HISTORY_DATA_REQUEST: '@settlement/GET_ONDEMAND_SETTLEMENT_HISTORY_DATA_REQUEST',
  GET_ONDEMAND_SETTLEMENT_HISTORY_DATA_CLEAR: '@settlement/GET_ONDEMAND_SETTLEMENT_HISTORY_DATA_CLEAR',

  // RCU Dashboard

  POST_ADMIN_TRANSACTION_ACTION: '@transaction/POST_ADMIN_TRANSACTION_ACTION',
  POST_ADMIN_TRANSACTION_REQUEST: '@transaction/POST_ADMIN_TRANSACTION_REQUEST',
  POST_ADMIN_TRANSACTION_SUCCESS: '@transaction/POST_ADMIN_TRANSACTION_SUCCESS',
  POST_ADMIN_TRANSACTION_FAILURE: '@transaction/POST_ADMIN_TRANSACTION_FAILURE',
  POST_ADMIN_TRANSACTION_CLEAR: '@transaction/POST_ADMIN_TRANSACTION_CLEAR',

  POST_ADMIN_MERCHANT_ACTION: '@merchant/POST_ADMIN_MERCHANT_ACTION',
  POST_ADMIN_MERCHANT_REQUEST: '@merchant/POST_ADMIN_MERCHANT_REQUEST',
  POST_ADMIN_MERCHANT_SUCCESS: '@merchant/POST_ADMIN_MERCHANT_SUCCESS',
  POST_ADMIN_MERCHANT_FAILURE: '@merchant/POST_ADMIN_MERCHANT_FAILURE',
  POST_ADMIN_MERCHANT_CLEAR: '@merchant/POST_ADMIN_MERCHANT_CLEAR',

  POST_ADMIN_REFUNDS_AND_SETTLEMENT_ACTION: '@transaction/POST_ADMIN_REFUNDS_AND_SETTLEMENT_ACTION',
  POST_ADMIN_REFUNDS_AND_SETTLEMENT_REQUEST: '@transaction/POST_ADMIN_REFUNDS_AND_SETTLEMENT_REQUEST',
  POST_ADMIN_REFUNDS_AND_SETTLEMENT_SUCCESS: '@transaction/POST_ADMIN_REFUNDS_AND_SETTLEMENT_SUCCESS',
  POST_ADMIN_REFUNDS_AND_SETTLEMENT_FAILURE: '@transaction/POST_ADMIN_REFUNDS_AND_SETTLEMENT_FAILURE',
  POST_ADMIN_REFUNDS_AND_SETTLEMENT_CLEAR: '@transaction/POST_ADMIN_REFUNDS_AND_SETTLEMENT_CLEAR',

  ADMIN_DOWNLOAD_LIST_ACTION: '@download/ADMIN_DOWNLOAD_LIST_ACTION',
  ADMIN_DOWNLOAD_LIST_REQUEST: '@download/ADMIN_DOWNLOAD_LIST_REQUEST',
  ADMIN_DOWNLOAD_LIST_SUCCESS: '@download/ADMIN_DOWNLOAD_LIST_SUCCESS',
  ADMIN_DOWNLOAD_LIST_FAILURE: '@download/ADMIN_DOWNLOAD_LIST_FAILURE',
  ADMIN_DOWNLOAD_LIST_CLEAR: '@download/ADMIN_DOWNLOAD_LIST_CLEAR',

  BULK_DOWNLOAD_LIST_ACTION:
  '@download/BULK_DOWNLOAD_LIST_ACTION',
BULK_DOWNLOAD_LIST_REQUEST:
  '@download/BULK_DOWNLOAD_LIST_REQUEST',
BULK_DOWNLOAD_LIST_SUCCESS:
  '@download/BULK_DOWNLOAD_LIST_SUCCESS',
BULK_DOWNLOAD_LIST_FAILURE:
  '@download/BULK_DOWNLOAD_LIST_FAILURE',
BULK_DOWNLOAD_LIST_CLEAR:
  '@download/BULK_DOWNLOAD_LIST_CLEAR',


  POST_PLURAL_TRANSACTION_API_ACTION: '@transaction/POST_PLURAL_TRANSACTION_API_ACTION',
  POST_PLURAL_TRANSACTION_API_REQUEST: '@transaction/POST_PLURAL_TRANSACTION_API_REQUEST',
  POST_PLURAL_TRANSACTION_API_SUCCESS: '@transaction/POST_PLURAL_TRANSACTION_API_SUCCESS',
  POST_PLURAL_TRANSACTION_API_FAILURE: '@transaction/POST_PLURAL_TRANSACTION_API_FAILURE',
  POST_PLURAL_TRANSACTION_API_CLEAR: '@transaction/POST_PLURAL_TRANSACTION_API_CLEAR',


  POST_EDGE_TRANSACTION_API_ACTION: '@transaction/POST_EDGE_TRANSACTION_API_ACTION',
  POST_EDGE_TRANSACTION_API_REQUEST: '@transaction/POST_EDGE_TRANSACTION_API_REQUEST',
  POST_EDGE_TRANSACTION_API_SUCCESS: '@transaction/POST_EDGE_TRANSACTION_API_SUCCESS',
  POST_EDGE_TRANSACTION_API_FAILURE: '@transaction/POST_EDGE_TRANSACTION_API_FAILURE',
  POST_EDGE_TRANSACTION_API_CLEAR: '@transaction/POST_EDGE_TRANSACTION_API_CLEAR',

  GET_ACQUIRERS_ACTION:'@acquirers/GET_ACQUIRERS_ACTION',
  GET_ACQUIRERS_REQUEST:'@acquirers/GET_ACQUIRERS_REQUEST',
  GET_ACQUIRERS_SUCCESS: '@acquirers/GET_ACQUIRERS_SUCCESS',
  GET_ACQUIRERS_FAILURE: '@acquirers/GET_ACQUIRERS_FAILURE',
  GET_ACQUIRERS_CLEAR: '@acquirers/GET_ACQUIRERS_CLEAR',

  POST_ADMIN_COLUMN_VISIBLE_ACTION: '@transaction/POST_ADMIN_COLUMN_VISIBLE_ACTION',

  POST_ADMIN_REFUNDS_ACTION: '@transaction/POST_ADMIN_REFUNDS_ACTION',
  POST_ADMIN_REFUNDS_REQUEST: '@transaction/POST_ADMIN_REFUNDS_REQUEST',
  POST_ADMIN_REFUNDS_SUCCESS: '@transaction/POST_ADMIN_REFUNDS_SUCCESS',
  POST_ADMIN_REFUNDS_FAILURE: '@transaction/POST_ADMIN_REFUNDS_FAILURE',
  POST_ADMIN_REFUNDS_CLEAR: '@transaction/POST_ADMIN_REFUNDS_CLEAR',


POST_ADMIN_SETTLEMENTS_ACTION: '@transaction/POST_ADMIN_SETTLEMENTS_ACTION',
POST_ADMIN_SETTLEMENTS_REQUEST: '@transaction/POST_ADMIN_SETTLEMENTS_REQUEST',
POST_ADMIN_SETTLEMENTS_SUCCESS: '@transaction/POST_ADMIN_SETTLEMENTS_SUCCESS',
POST_ADMIN_SETTLEMENTS_FAILURE: '@transaction/POST_ADMIN_SETTLEMENTS_FAILURE',
POST_ADMIN_SETTLEMENTS_CLEAR: '@transaction/POST_ADMIN_SETTLEMENTS_CLEAR',

// Max payment link

UPDATE_MAX_PAYMENT_LINK_ACTION: '@paymentLink/UPDATE_MAX_PAYMENT_LINK_ACTION',
UPDATE_MAX_PAYMENT_LINK_REQUEST: '@paymentLink/UPDATE_MAX_PAYMENT_LINK_REQUEST',
UPDATE_MAX_PAYMENT_LINK_SUCCESS: '@paymentLink/UPDATE_MAX_PAYMENT_LINK_SUCCESS',
UPDATE_MAX_PAYMENT_LINK_FAILURE: '@paymentLink/UPDATE_MAX_PAYMENT_LINK_FAILURE',
UPDATE_MAX_PAYMENT_LINK_CLEAR: '@paymentLink/UPDATE_MAX_PAYMENT_LINK_CLEAR',

// Merchant settings flag (isAllowedForConvenienceFeeRefund)
GET_MERCHANT_SETTINGS_FLAG: '@merchantSettings/GET_MERCHANT_SETTINGS_FLAG',
GET_MERCHANT_SETTINGS_FLAG_REQUEST: '@merchantSettings/GET_MERCHANT_SETTINGS_FLAG_REQUEST',
GET_MERCHANT_SETTINGS_FLAG_SUCCESS: '@merchantSettings/GET_MERCHANT_SETTINGS_FLAG_SUCCESS',
GET_MERCHANT_SETTINGS_FLAG_FAILURE: '@merchantSettings/GET_MERCHANT_SETTINGS_FLAG_FAILURE',
SET_MERCHANT_SETTINGS_FLAG: '@merchantSettings/SET_MERCHANT_SETTINGS_FLAG',
SET_MERCHANT_SETTINGS_FLAG_REQUEST: '@merchantSettings/SET_MERCHANT_SETTINGS_FLAG_REQUEST',
SET_MERCHANT_SETTINGS_FLAG_SUCCESS: '@merchantSettings/SET_MERCHANT_SETTINGS_FLAG_SUCCESS',
SET_MERCHANT_SETTINGS_FLAG_FAILURE: '@merchantSettings/SET_MERCHANT_SETTINGS_FLAG_FAILURE',
SET_MERCHANT_SETTINGS_FLAG_CLEAR: '@merchantSettings/SET_MERCHANT_SETTINGS_FLAG_CLEAR',

// Refund via payout api

POST_CREATE_REFUND_VIA_PAYOUT: '@refund/POST_CREATE_REFUND_VIA_PAYOUT',
POST_CREATE_REFUND_VIA_PAYOUT_REQUEST: '@refund/POST_CREATE_REFUND_VIA_PAYOUT_REQUEST',
POST_CREATE_REFUND_VIA_PAYOUT_SUCCESS: '@refund/POST_CREATE_REFUND_VIA_PAYOUT_SUCCESS',
POST_CREATE_REFUND_VIA_PAYOUT_FAILURE: '@refund/POST_CREATE_REFUND_VIA_PAYOUT_FAILURE',
POST_CREATE_REFUND_VIA_PAYOUT_CLEAR: '@refund/POST_CREATE_REFUND_VIA_PAYOUT_CLEAR',

//BPCL onboarding
// ALL MERCHANTS IN PARTNER LIST
GET_ALL_MERCHANT_STAGE_LIST: '@bpcl/GET_ALL_MERCHANT_STAGE_LIST',
GET_ALL_MERCHANT_STAGE_LIST_SUCCESS: '@bpcl/GET_ALL_MERCHANT_STAGE_LIST_SUCCESS',
GET_ALL_MERCHANT_STAGE_LIST_FAILURE: '@bpcl/GET_ALL_MERCHANT_STAGE_LIST_FAILURE',
GET_ALL_MERCHANT_STAGE_LIST_REQUEST: '@bpcl/GET_ALL_MERCHANT_STAGE_LIST_REQUEST',
GET_ALL_MERCHANT_STAGE_LIST_CLEAR: '@bpcl/GET_ALL_MERCHANT_STAGE_LIST_CLEAR',

//PENDING REVIEW REQUESTS SUMMARY
GET_PENDING_MERCHANT_STAGE_LIST:'@bpcl/GET_PENDING_MERCHANT_STAGE_LIST',
GET_PENDING_MERCHANT_STAGE_LIST_SUCCESS:'@bpcl/GET_PENDING_MERCHANT_STAGE_LIST_SUCCESS',
GET_PENDING_MERCHANT_STAGE_LIST_FAILURE:'@bpcl/GET_PENDING_MERCHANT_STAGE_LIST_FAILURE',
GET_PENDING_MERCHANT_STAGE_LIST_REQUEST:'@bpcl/GET_PENDING_MERCHANT_STAGE_LIST_REQUEST',
GET_PENDING_MERCHANT_STAGE_LIST_CLEAR:'@bpcl/GET_PENDING_MERCHANT_STAGE_LIST_CLEAR',

// ALL REVIEW REQUESTS SUMMARY
GET_REVIEW_REQUESTS:'@bpcl/GET_REVIEW_REQUESTS',
GET_REVIEW_REQUESTS_SUCCESS:'@bpcl/GET_REVIEW_REQUESTS_SUCCESS',
GET_REVIEW_REQUESTS_FAILURE:'@bpcl/GET_REVIEW_REQUESTS_FAILURE',
GET_REVIEW_REQUESTS_REQUEST:'@bpcl/GET_REVIEW_REQUESTS_REQUEST',
GET_REVIEW_REQUESTS_CLEAR:'@bpcl/GET_REVIEW_REQUESTS_CLEAR',

// ALL REVIEW REQUESTS SUMMARY
UPDATE_REVIEW_REQUESTS:'@bpcl/UPDATE_REVIEW_REQUESTS',
UPDATE_REVIEW_REQUESTS_SUCCESS:'@bpcl/UPDATE_REVIEW_REQUESTS_SUCCESS',
UPDATE_REVIEW_REQUESTS_FAILURE:'@bpcl/UPDATE_REVIEW_REQUESTS_FAILURE',
UPDATE_REVIEW_REQUESTS_REQUEST:'@bpcl/UPDATE_REVIEW_REQUESTS_REQUEST',
UPDATE_REVIEW_REQUESTS_CLEAR:'@bpcl/UPDATE_REVIEW_REQUESTS_CLEAR',

//BULK UPLOAD
UPLOAD_BULK_MERCHANT_DATA: '@bpcl/UPLOAD_BULK_MERCHANT_DATA',
UPLOAD_BULK_MERCHANT_DATA_SUCCESS: '@bpcl/UPLOAD_BULK_MERCHANT_DATA_SUCCESS',
UPLOAD_BULK_MERCHANT_DATA_FAILURE: '@bpcl/UPLOAD_BULK_MERCHANT_DATA_FAILURE',
UPLOAD_BULK_MERCHANT_DATA_REQUEST: '@bpcl/UPLOAD_BULK_MERCHANT_DATA_REQUEST',
UPLOAD_BULK_MERCHANT_DATA_CLEAR: '@bpcl/UPLOAD_BULK_MERCHANT_DATA_CLEAR',

//DOWNLOAD TEMPLATE
DOWNLOAD_BULK_MERCHANT_TEMPLATE: '@bpcl/DOWNLOAD_BULK_MERCHANT_TEMPLATE',
DOWNLOAD_BULK_MERCHANT_TEMPLATE_SUCCESS: '@bpcl/DOWNLOAD_BULK_MERCHANT_TEMPLATE_SUCCESS',
DOWNLOAD_BULK_MERCHANT_TEMPLATE_FAILURE: '@bpcl/DOWNLOAD_BULK_MERCHANT_TEMPLATE_FAILURE',
DOWNLOAD_BULK_MERCHANT_TEMPLATE_REQUEST: '@bpcl/DOWNLOAD_BULK_MERCHANT_TEMPLATE_REQUEST',
DOWNLOAD_BULK_MERCHANT_TEMPLATE_CLEAR: '@bpcl/DOWNLOAD_BULK_MERCHANT_TEMPLATE_CLEAR',

// GET History of bulk upload
GET_BPCL_BULK_UPLOAD_HISTORY: '@bpcl/GET_BPCL_BULK_UPLOAD_HISTORY',
GET_BPCL_BULK_UPLOAD_HISTORY_SUCCESS: '@bpcl/GET_BPCL_BULK_UPLOAD_HISTORY_SUCCESS',
GET_BPCL_BULK_UPLOAD_HISTORY_FAILURE: '@bpcl/GET_BPCL_BULK_UPLOAD_HISTORY_FAILURE',
GET_BPCL_BULK_UPLOAD_HISTORY_REQUEST: '@bpcl/GET_BPCL_BULK_UPLOAD_HISTORY_REQUEST',
GET_BPCL_BULK_UPLOAD_HISTORY_CLEAR: '@bpcl/GET_BPCL_BULK_UPLOAD_HISTORY_CLEAR',

// Get checkout version
GET_CHECKOUT_VERSION: '@settings/GET_CHECKOUT_VERSION',
GET_CHECKOUT_VERSION_REQUEST: '@settings/GET_CHECKOUT_VERSION_REQUEST',
GET_CHECKOUT_VERSION_SUCCESS: '@settings/GET_CHECKOUT_VERSION_SUCCESS',
GET_CHECKOUT_VERSION_FAILURE: '@settings/GET_CHECKOUT_VERSION_FAILURE',
GET_CHECKOUT_VERSION_CLEAR: '@settings/GET_CHECKOUT_VERSION_CLEAR',
GET_HAS_MERCHANT_TRANSACTED: '@settings/GET_HAS_MERCHANT_TRANSACTED',
GET_HAS_MERCHANT_TRANSACTED_REQUEST: '@settings/GET_HAS_MERCHANT_TRANSACTED_REQUEST',
GET_HAS_MERCHANT_TRANSACTED_SUCCESS: '@settings/GET_HAS_MERCHANT_TRANSACTED_SUCCESS',
GET_HAS_MERCHANT_TRANSACTED_FAILURE: '@settings/GET_HAS_MERCHANT_TRANSACTED_FAILURE',


// apple pay api integration


GET_DOWNLOAD_CSR_APPLE_PAY: '@settings/GET_DOWNLOAD_CSR_APPLE_PAY',
GET_DOWNLOAD_CSR_APPLE_PAY_REQUEST: '@settings/GET_DOWNLOAD_CSR_APPLE_PAY_REQUEST',
GET_DOWNLOAD_CSR_APPLE_PAY_SUCCESS: '@settings/GET_DOWNLOAD_CSR_APPLE_PAY_SUCCESS',
GET_DOWNLOAD_CSR_APPLE_PAY_FAILURE: '@settings/GET_DOWNLOAD_CSR_APPLE_PAY_FAILURE',
GET_DOWNLOAD_CSR_APPLE_PAY_CLEAR: '@settings/GET_DOWNLOAD_CSR_APPLE_PAY_CLEAR',


GET_APPLE_PAY_WALLET_STATUS: '@settings/GET_APPLE_PAY_WALLET_STATUS',
GET_APPLE_PAY_WALLET_STATUS_REQUEST: '@settings/GET_APPLE_PAY_WALLET_STATUS_REQUEST',
GET_APPLE_PAY_WALLET_STATUS_SUCCESS: '@settings/GET_APPLE_PAY_WALLET_STATUS_SUCCESS',
GET_APPLE_PAY_WALLET_STATUS_FAILURE: '@settings/GET_APPLE_PAY_WALLET_STATUS_FAILURE',
GET_APPLE_PAY_WALLET_STATUS_CLEAR: '@settings/GET_APPLE_PAY_WALLET_STATUS_CLEAR',



GET_APPLE_PAY_INTEGRATION_STATUS: '@settings/GET_APPLE_PAY_INTEGRATION_STATUS',
GET_APPLE_PAY_INTEGRATION_STATUS_REQUEST: '@settings/GET_APPLE_PAY_INTEGRATION_STATUS_REQUEST',
GET_APPLE_PAY_INTEGRATION_STATUS_SUCCESS: '@settings/GET_APPLE_PAY_INTEGRATION_STATUS_SUCCESS',
GET_APPLE_PAY_INTEGRATION_STATUS_FAILURE: '@settings/GET_APPLE_PAY_INTEGRATION_STATUS_FAILURE',
GET_APPLE_PAY_INTEGRATION_STATUS_CLEAR: '@settings/GET_APPLE_PAY_INTEGRATION_STATUS_CLEAR',


WEB_REGISTRATION_APPLE_PAY: '@settings/WEB_REGISTRATION_APPLE_PAY',
WEB_REGISTRATION_APPLE_PAY_REQUEST: '@settings/WEB_REGISTRATION_APPLE_PAY_REQUEST',
WEB_REGISTRATION_APPLE_PAY_SUCCESS: '@settings/WEB_REGISTRATION_APPLE_PAY_SUCCESS',
WEB_REGISTRATION_APPLE_PAY_FAILURE: '@settings/WEB_REGISTRATION_APPLE_PAY_FAILURE',
WEB_REGISTRATION_APPLE_PAY_CLEAR: '@settings/WEB_REGISTRATION_APPLE_PAY_CLEAR',


ACTIVATE_APPLE_PAY_CERTIFICATE: '@settings/ACTIVATE_APPLE_PAY_CERTIFICATE',
ACTIVATE_APPLE_PAY_CERTIFICATE_REQUEST: '@settings/ACTIVATE_APPLE_PAY_CERTIFICATE_REQUEST',
ACTIVATE_APPLE_PAY_CERTIFICATE_SUCCESS: '@settings/ACTIVATE_APPLE_PAY_CERTIFICATE_SUCCESS',
ACTIVATE_APPLE_PAY_CERTIFICATE_FAILURE: '@settings/ACTIVATE_APPLE_PAY_CERTIFICATE_FAILURE',
ACTIVATE_APPLE_PAY_CERTIFICATE_CLEAR: '@settings/ACTIVATE_APPLE_PAY_CERTIFICATE_CLEAR',


GET_PAYMENT_MODES: '@settings/GET_PAYMENT_MODES',
GET_PAYMENT_MODES_REQUEST: '@settings/GET_PAYMENT_MODES_REQUEST',
GET_PAYMENT_MODES_SUCCESS: '@settings/GET_PAYMENT_MODES_SUCCESS',
GET_PAYMENT_MODES_FAILURE: '@settings/GET_PAYMENT_MODES_FAILURE',
GET_PAYMENT_MODES_CLEAR: '@settings/GET_PAYMENT_MODES_CLEAR',
GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_SUCCESS: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_SUCCESS',
GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_FAILURE: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_FAILURE',
GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_REQUEST: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_REQUEST',
GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_ACTION: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_ACTION',
GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_CLEAR: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_CLEAR',

GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_SUCCESS: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_SUCCESS',
GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_FAILURE: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_FAILURE',
GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_REQUEST: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_REQUEST',
GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_ACTION: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_ACTION',
GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_CLEAR: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_CLEAR',

GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_SUCCESS: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_SUCCESS',
GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_FAILURE: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_FAILURE',
GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_REQUEST: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_REQUEST',
GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_ACTION: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_ACTION',
GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_CLEAR: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_CLEAR',

GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_SUCCESS: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_SUCCESS',
GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_FAILURE: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_FAILURE',
GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_REQUEST: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_REQUEST',
GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_ACTION: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_ACTION',
GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_CLEAR: '@checkoutinsights/GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_CLEAR',

GET_CUSTOMER_WALLET_SUCCESS: '@wallet/GET_CUSTOMER_WALLET_SUCCESS',
GET_CUSTOMER_WALLET_FAILURE: '@wallet/GET_CUSTOMER_WALLET_FAILURE',
GET_CUSTOMER_WALLET_REQUEST: '@wallet/GET_CUSTOMER_WALLET_REQUEST',
GET_CUSTOMER_WALLET_ACTION: '@wallet/GET_CUSTOMER_WALLET_ACTION',
GET_CUSTOMER_WALLET_CLEAR: '@wallet/GET_CUSTOMER_WALLET_CLEAR',

CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_SUCCESS: '@wallet/CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_SUCCESS',
CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_FAILURE: '@wallet/CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_FAILURE',
CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_REQUEST: '@wallet/CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_REQUEST',
CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_ACTION: '@wallet/CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_ACTION',
CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_CLEAR: '@wallet/CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_CLEAR',

CREATE_BULK_WALLET_SUCCESS: '@wallet/CREATE_BULK_WALLET_SUCCESS',
CREATE_BULK_WALLET_FAILURE: '@wallet/CREATE_BULK_WALLET_FAILURE',
CREATE_BULK_WALLET_REQUEST: '@wallet/CREATE_BULK_WALLET_REQUEST',
CREATE_BULK_WALLET_ACTION: '@wallet/CREATE_BULK_WALLET_ACTION',
CREATE_BULK_WALLET_CLEAR: '@wallet/CREATE_BULK_WALLET_CLEAR',

LOAD_BULK_WALLET_SUCCESS: '@wallet/LOAD_BULK_WALLET_SUCCESS',
LOAD_BULK_WALLET_FAILURE: '@wallet/LOAD_BULK_WALLET_FAILURE',
LOAD_BULK_WALLET_REQUEST: '@wallet/LOAD_BULK_WALLET_REQUEST',
LOAD_BULK_WALLET_ACTION: '@wallet/LOAD_BULK_WALLET_ACTION',
LOAD_BULK_WALLET_CLEAR: '@wallet/LOAD_BULK_WALLET_CLEAR',

LIST_CREATED_WALLET_SUCCESS: '@wallet/LIST_CREATED_WALLET_SUCCESS',
LIST_CREATED_WALLET_FAILURE: '@wallet/LIST_CREATED_WALLET_FAILURE',
LIST_CREATED_WALLET_REQUEST: '@wallet/LIST_CREATED_WALLET_REQUEST',
LIST_CREATED_WALLET_ACTION: '@wallet/LIST_CREATED_WALLET_ACTION',
LIST_CREATED_WALLET_CLEAR: '@wallet/LIST_CREATED_WALLET_CLEAR',

LIST_LOAD_WALLET_SUCCESS: '@wallet/LIST_LOAD_WALLET_SUCCESS',
LIST_LOAD_WALLET_FAILURE: '@wallet/LIST_LOAD_WALLET_FAILURE',
LIST_LOAD_WALLET_REQUEST: '@wallet/LIST_LOAD_WALLET_REQUEST',
LIST_LOAD_WALLET_ACTION: '@wallet/LIST_LOAD_WALLET_ACTION',
LIST_LOAD_WALLET_CLEAR: '@wallet/LIST_LOAD_WALLET_CLEAR',

DOWNLOAD_ERROR_REPORT_SUCCESS: '@wallet/DOWNLOAD_ERROR_REPORT_SUCCESS',
DOWNLOAD_ERROR_REPORT_FAILURE: '@wallet/DOWNLOAD_ERROR_REPORT_FAILURE',
DOWNLOAD_ERROR_REPORT_REQUEST: '@wallet/DOWNLOAD_ERROR_REPORT_REQUEST',
DOWNLOAD_ERROR_REPORT_ACTION: '@wallet/DOWNLOAD_ERROR_REPORT_ACTION',
DOWNLOAD_ERROR_REPORT_CLEAR: '@wallet/DOWNLOAD_ERROR_REPORT_CLEAR',

GET_WALLET_TRANSACTION_DETAILS_SUCCESS: '@wallet/GET_WALLET_TRANSACTION_DETAILS_SUCCESS',
GET_WALLET_TRANSACTION_DETAILS_FAILURE: '@wallet/GET_WALLET_TRANSACTION_DETAILS_FAILURE',
GET_WALLET_TRANSACTION_DETAILS_REQUEST: '@wallet/GET_WALLET_TRANSACTION_DETAILS_REQUEST',
GET_WALLET_TRANSACTION_DETAILS_ACTION: '@wallet/GET_WALLET_TRANSACTION_DETAILS_ACTION',
GET_WALLET_TRANSACTION_DETAILS_CLEAR: '@wallet/GET_WALLET_TRANSACTION_DETAILS_CLEAR',

GET_WALLET_DETAILS_SUCCESS: '@wallet/GET_WALLET_DETAILS_SUCCESS',
GET_WALLET_DETAILS_FAILURE: '@wallet/GET_WALLET_DETAILS_FAILURE',
GET_WALLET_DETAILS_REQUEST: '@wallet/GET_WALLET_DETAILS_REQUEST',
GET_WALLET_DETAILS_ACTION: '@wallet/GET_WALLET_DETAILS_ACTION',
GET_WALLET_DETAILS_CLEAR: '@wallet/GET_WALLET_DETAILS_CLEAR',

FETCH_PAYMENT_MODES: '@settings/FETCH_PAYMENT_MODES',
FETCH_PAYMENT_MODES_REQUEST: '@settings/FETCH_PAYMENT_MODES_REQUEST',
FETCH_PAYMENT_MODES_SUCCESS: '@settings/FETCH_PAYMENT_MODES_SUCCESS',
FETCH_PAYMENT_MODES_FAILURE: '@settings/FETCH_PAYMENT_MODES_FAILURE',
FETCH_PAYMENT_MODES_CLEAR: '@settings/FETCH_PAYMENT_MODES_CLEAR',
// ckyc 

POST_SEND_VERIFICATION_CODE_CKYC: '@onboarding/POST_SEND_VERIFICATION_CODE_CKYC',
POST_SEND_VERIFICATION_CODE_CKYC_REQUEST: '@onboarding/POST_SEND_VERIFICATION_CODE_CKYC_REQUEST',
POST_SEND_VERIFICATION_CODE_CKYC_SUCCESS: '@onboarding/POST_SEND_VERIFICATION_CODE_CKYC_SUCCESS',
POST_SEND_VERIFICATION_CODE_CKYC_FAILURE: '@onboarding/POST_SEND_VERIFICATION_CODE_CKYC_FAILURE',
POST_SEND_VERIFICATION_CODE_CKYC_CLEAR: '@onboarding/POST_SEND_VERIFICATION_CODE_CKYC_CLEAR',

POST_VERIFY_CKYC_CODE: '@onboarding/POST_VERIFY_CKYC_CODE',
POST_VERIFY_CKYC_CODE_REQUEST: '@onboarding/POST_VERIFY_CKYC_CODE_REQUEST',
POST_VERIFY_CKYC_CODE_SUCCESS: '@onboarding/POST_VERIFY_CKYC_CODE_SUCCESS',
POST_VERIFY_CKYC_CODE_FAILURE: '@onboarding/POST_VERIFY_CKYC_CODE_FAILURE',
POST_VERIFY_CKYC_CODE_CLEAR: '@onboarding/POST_VERIFY_CKYC_CODE_CLEAR',

POST_DOWNLOAD_CKYC_DATA: '@onboarding/POST_DOWNLOAD_CKYC_DATA',
POST_DOWNLOAD_CKYC_DATA_REQUEST: '@onboarding/POST_DOWNLOAD_CKYC_DATA_REQUEST',
POST_DOWNLOAD_CKYC_DATA_SUCCESS: '@onboarding/POST_DOWNLOAD_CKYC_DATA_SUCCESS',
POST_DOWNLOAD_CKYC_DATA_FAILURE: '@onboarding/POST_DOWNLOAD_CKYC_DATA_FAILURE',
POST_DOWNLOAD_CKYC_DATA_CLEAR: '@onboarding/POST_DOWNLOAD_CKYC_DATA_CLEAR',


POST_MAP_CKYC_DATA: '@onboarding/POST_MAP_CKYC_DATA',
POST_MAP_CKYC_DATA_REQUEST: '@onboarding/POST_MAP_CKYC_DATA_REQUEST',
POST_MAP_CKYC_DATA_SUCCESS: '@onboarding/POST_MAP_CKYC_DATA_SUCCESS',
POST_MAP_CKYC_DATA_FAILURE: '@onboarding/POST_MAP_CKYC_DATA_FAILURE',
POST_MAP_CKYC_DATA_CLEAR: '@onboarding/POST_MAP_CKYC_DATA_CLEAR',

  // UI Filters Persistence
  SET_EDGE_V3_TRANSACTIONS_FILTERS: '@uiFilters/SET_EDGE_V3_TRANSACTIONS_FILTERS',
  RESET_EDGE_V3_TRANSACTIONS_FILTERS: '@uiFilters/RESET_EDGE_V3_TRANSACTIONS_FILTERS',
  SET_TRANSACTION_LEVEL_LISTING_FILTERS: '@uiFilters/SET_TRANSACTION_LEVEL_LISTING_FILTERS',
  RESET_TRANSACTION_LEVEL_LISTING_FILTERS: '@uiFilters/RESET_TRANSACTION_LEVEL_LISTING_FILTERS',
  SET_ORDER_LEVEL_LISTING_FILTERS: '@uiFilters/SET_ORDER_LEVEL_LISTING_FILTERS',
  RESET_ORDER_LEVEL_LISTING_FILTERS: '@uiFilters/RESET_ORDER_LEVEL_LISTING_FILTERS',
  SET_UPDATED_SETTLEMENTS_FILTERS: '@uiFilters/SET_UPDATED_SETTLEMENTS_FILTERS',
  RESET_UPDATED_SETTLEMENTS_FILTERS: '@uiFilters/RESET_UPDATED_SETTLEMENTS_FILTERS',
  SET_ORDER_DETAILS_FILTERS: '@uiFilters/SET_ORDER_DETAILS_FILTERS',
  RESET_ORDER_DETAILS_FILTERS: '@uiFilters/RESET_ORDER_DETAILS_FILTERS',
  // Custom Report Save
  SAVE_CUSTOM_REPORT: '@reports/SAVE_CUSTOM_REPORT',
  SAVE_CUSTOM_REPORT_REQUEST: '@reports/SAVE_CUSTOM_REPORT_REQUEST',
  SAVE_CUSTOM_REPORT_SUCCESS: '@reports/SAVE_CUSTOM_REPORT_SUCCESS',
  SAVE_CUSTOM_REPORT_FAILURE: '@reports/SAVE_CUSTOM_REPORT_FAILURE',
  SAVE_CUSTOM_REPORT_CLEAR: '@reports/SAVE_CUSTOM_REPORT_CLEAR',

  UPDATE_PCI_DSS_CONSENT: '@onboarding/UPDATE_PCI_DSS_CONSENT',
  UPDATE_PCI_DSS_CONSENT_REQUEST: '@onboarding/UPDATE_PCI_DSS_CONSENT_REQUEST',
  UPDATE_PCI_DSS_CONSENT_SUCCESS: '@onboarding/UPDATE_PCI_DSS_CONSENT_SUCCESS',
  UPDATE_PCI_DSS_CONSENT_FAILURE: '@onboarding/UPDATE_PCI_DSS_CONSENT_FAILURE',
  UPDATE_PCI_DSS_CONSENT_CLEAR: '@onboarding/UPDATE_PCI_DSS_CONSENT_CLEAR',


  // Create Scheduled Report
  CREATE_SCHEDULED_REPORT: '@reports/CREATE_SCHEDULED_REPORT',
  CREATE_SCHEDULED_REPORT_REQUEST: '@reports/CREATE_SCHEDULED_REPORT_REQUEST',
  CREATE_SCHEDULED_REPORT_SUCCESS: '@reports/CREATE_SCHEDULED_REPORT_SUCCESS',
  CREATE_SCHEDULED_REPORT_FAILURE: '@reports/CREATE_SCHEDULED_REPORT_FAILURE',
  CREATE_SCHEDULED_REPORT_CLEAR: '@reports/CREATE_SCHEDULED_REPORT_CLEAR',

  // Pause Scheduled Report
  PAUSE_SCHEDULED_REPORT: '@reports/PAUSE_SCHEDULED_REPORT',
  PAUSE_SCHEDULED_REPORT_REQUEST: '@reports/PAUSE_SCHEDULED_REPORT_REQUEST',
  PAUSE_SCHEDULED_REPORT_SUCCESS: '@reports/PAUSE_SCHEDULED_REPORT_SUCCESS',
  PAUSE_SCHEDULED_REPORT_FAILURE: '@reports/PAUSE_SCHEDULED_REPORT_FAILURE',
  PAUSE_SCHEDULED_REPORT_CLEAR: '@reports/PAUSE_SCHEDULED_REPORT_CLEAR',

  // Resume Scheduled Report
  RESUME_SCHEDULED_REPORT: '@reports/RESUME_SCHEDULED_REPORT',
  RESUME_SCHEDULED_REPORT_REQUEST: '@reports/RESUME_SCHEDULED_REPORT_REQUEST',
  RESUME_SCHEDULED_REPORT_SUCCESS: '@reports/RESUME_SCHEDULED_REPORT_SUCCESS',
  RESUME_SCHEDULED_REPORT_FAILURE: '@reports/RESUME_SCHEDULED_REPORT_FAILURE',
  RESUME_SCHEDULED_REPORT_CLEAR: '@reports/RESUME_SCHEDULED_REPORT_CLEAR',

  UPDATE_SCHEDULED_REPORT: '@reports/UPDATE_SCHEDULED_REPORT',
  UPDATE_SCHEDULED_REPORT_REQUEST: '@reports/UPDATE_SCHEDULED_REPORT_REQUEST',
  UPDATE_SCHEDULED_REPORT_SUCCESS: '@reports/UPDATE_SCHEDULED_REPORT_SUCCESS',
  UPDATE_SCHEDULED_REPORT_FAILURE: '@reports/UPDATE_SCHEDULED_REPORT_FAILURE',
  UPDATE_SCHEDULED_REPORT_CLEAR: '@reports/UPDATE_SCHEDULED_REPORT_CLEAR',

// Maker Checker - Force Refund
SUBMIT_FORCE_REFUND_REQUEST: '@makerChecker/SUBMIT_FORCE_REFUND_REQUEST',
SUBMIT_FORCE_REFUND_REQUEST_REQUEST: '@makerChecker/SUBMIT_FORCE_REFUND_REQUEST_REQUEST',
SUBMIT_FORCE_REFUND_REQUEST_SUCCESS: '@makerChecker/SUBMIT_FORCE_REFUND_REQUEST_SUCCESS',
SUBMIT_FORCE_REFUND_REQUEST_FAILURE: '@makerChecker/SUBMIT_FORCE_REFUND_REQUEST_FAILURE',
SUBMIT_FORCE_REFUND_REQUEST_CLEAR: '@makerChecker/SUBMIT_FORCE_REFUND_REQUEST_CLEAR',

  GET_FORCE_REFUND_REQUESTS: '@makerChecker/GET_FORCE_REFUND_REQUESTS',
  GET_FORCE_REFUND_REQUESTS_REQUEST: '@makerChecker/GET_FORCE_REFUND_REQUESTS_REQUEST',
  GET_FORCE_REFUND_REQUESTS_SUCCESS: '@makerChecker/GET_FORCE_REFUND_REQUESTS_SUCCESS',
  GET_FORCE_REFUND_REQUESTS_FAILURE: '@makerChecker/GET_FORCE_REFUND_REQUESTS_FAILURE',
  GET_FORCE_REFUND_REQUESTS_CLEAR: '@makerChecker/GET_FORCE_REFUND_REQUESTS_CLEAR',

  APPROVE_FORCE_REFUND_REQUEST: '@makerChecker/APPROVE_FORCE_REFUND_REQUEST',
  APPROVE_FORCE_REFUND_REQUEST_REQUEST: '@makerChecker/APPROVE_FORCE_REFUND_REQUEST_REQUEST',
  APPROVE_FORCE_REFUND_REQUEST_SUCCESS: '@makerChecker/APPROVE_FORCE_REFUND_REQUEST_SUCCESS',
  APPROVE_FORCE_REFUND_REQUEST_FAILURE: '@makerChecker/APPROVE_FORCE_REFUND_REQUEST_FAILURE',
  APPROVE_FORCE_REFUND_REQUEST_CLEAR: '@makerChecker/APPROVE_FORCE_REFUND_REQUEST_CLEAR',

  REJECT_FORCE_REFUND_REQUEST: '@makerChecker/REJECT_FORCE_REFUND_REQUEST',
  REJECT_FORCE_REFUND_REQUEST_REQUEST: '@makerChecker/REJECT_FORCE_REFUND_REQUEST_REQUEST',
  REJECT_FORCE_REFUND_REQUEST_SUCCESS: '@makerChecker/REJECT_FORCE_REFUND_REQUEST_SUCCESS',
  REJECT_FORCE_REFUND_REQUEST_FAILURE: '@makerChecker/REJECT_FORCE_REFUND_REQUEST_FAILURE',
  REJECT_FORCE_REFUND_REQUEST_CLEAR: '@makerChecker/REJECT_FORCE_REFUND_REQUEST_CLEAR',

  GET_FORCE_REFUND_REQUEST_DETAILS: '@makerChecker/GET_FORCE_REFUND_REQUEST_DETAILS',
  GET_FORCE_REFUND_REQUEST_DETAILS_REQUEST: '@makerChecker/GET_FORCE_REFUND_REQUEST_DETAILS_REQUEST',
  GET_FORCE_REFUND_REQUEST_DETAILS_SUCCESS: '@makerChecker/GET_FORCE_REFUND_REQUEST_DETAILS_SUCCESS',
  GET_FORCE_REFUND_REQUEST_DETAILS_FAILURE: '@makerChecker/GET_FORCE_REFUND_REQUEST_DETAILS_FAILURE',
  GET_FORCE_REFUND_REQUEST_DETAILS_CLEAR: '@makerChecker/GET_FORCE_REFUND_REQUEST_DETAILS_CLEAR',

  GET_FORCE_REFUND_EXECUTION_STATUS: '@makerChecker/GET_FORCE_REFUND_EXECUTION_STATUS',
  GET_FORCE_REFUND_EXECUTION_STATUS_REQUEST: '@makerChecker/GET_FORCE_REFUND_EXECUTION_STATUS_REQUEST',
  GET_FORCE_REFUND_EXECUTION_STATUS_SUCCESS: '@makerChecker/GET_FORCE_REFUND_EXECUTION_STATUS_SUCCESS',
  GET_FORCE_REFUND_EXECUTION_STATUS_FAILURE: '@makerChecker/GET_FORCE_REFUND_EXECUTION_STATUS_FAILURE',
  GET_FORCE_REFUND_EXECUTION_STATUS_CLEAR: '@makerChecker/GET_FORCE_REFUND_EXECUTION_STATUS_CLEAR',

// Maker Checker - Force Update Order
SUBMIT_FORCE_UPDATE_ORDER_REQUEST: '@makerChecker/SUBMIT_FORCE_UPDATE_ORDER_REQUEST',
SUBMIT_FORCE_UPDATE_ORDER_REQUEST_REQUEST: '@makerChecker/SUBMIT_FORCE_UPDATE_ORDER_REQUEST_REQUEST',
SUBMIT_FORCE_UPDATE_ORDER_REQUEST_SUCCESS: '@makerChecker/SUBMIT_FORCE_UPDATE_ORDER_REQUEST_SUCCESS',
SUBMIT_FORCE_UPDATE_ORDER_REQUEST_FAILURE: '@makerChecker/SUBMIT_FORCE_UPDATE_ORDER_REQUEST_FAILURE',
SUBMIT_FORCE_UPDATE_ORDER_REQUEST_CLEAR: '@makerChecker/SUBMIT_FORCE_UPDATE_ORDER_REQUEST_CLEAR',

GET_FORCE_UPDATE_ORDER_REQUESTS: '@makerChecker/GET_FORCE_UPDATE_ORDER_REQUESTS',
GET_FORCE_UPDATE_ORDER_REQUESTS_REQUEST: '@makerChecker/GET_FORCE_UPDATE_ORDER_REQUESTS_REQUEST',
GET_FORCE_UPDATE_ORDER_REQUESTS_SUCCESS: '@makerChecker/GET_FORCE_UPDATE_ORDER_REQUESTS_SUCCESS',
GET_FORCE_UPDATE_ORDER_REQUESTS_FAILURE: '@makerChecker/GET_FORCE_UPDATE_ORDER_REQUESTS_FAILURE',
GET_FORCE_UPDATE_ORDER_REQUESTS_CLEAR: '@makerChecker/GET_FORCE_UPDATE_ORDER_REQUESTS_CLEAR',

APPROVE_FORCE_UPDATE_ORDER_REQUEST: '@makerChecker/APPROVE_FORCE_UPDATE_ORDER_REQUEST',
APPROVE_FORCE_UPDATE_ORDER_REQUEST_REQUEST: '@makerChecker/APPROVE_FORCE_UPDATE_ORDER_REQUEST_REQUEST',
APPROVE_FORCE_UPDATE_ORDER_REQUEST_SUCCESS: '@makerChecker/APPROVE_FORCE_UPDATE_ORDER_REQUEST_SUCCESS',
APPROVE_FORCE_UPDATE_ORDER_REQUEST_FAILURE: '@makerChecker/APPROVE_FORCE_UPDATE_ORDER_REQUEST_FAILURE',
APPROVE_FORCE_UPDATE_ORDER_REQUEST_CLEAR: '@makerChecker/APPROVE_FORCE_UPDATE_ORDER_REQUEST_CLEAR',

REJECT_FORCE_UPDATE_ORDER_REQUEST: '@makerChecker/REJECT_FORCE_UPDATE_ORDER_REQUEST',
REJECT_FORCE_UPDATE_ORDER_REQUEST_REQUEST: '@makerChecker/REJECT_FORCE_UPDATE_ORDER_REQUEST_REQUEST',
REJECT_FORCE_UPDATE_ORDER_REQUEST_SUCCESS: '@makerChecker/REJECT_FORCE_UPDATE_ORDER_REQUEST_SUCCESS',
REJECT_FORCE_UPDATE_ORDER_REQUEST_FAILURE: '@makerChecker/REJECT_FORCE_UPDATE_ORDER_REQUEST_FAILURE',
REJECT_FORCE_UPDATE_ORDER_REQUEST_CLEAR: '@makerChecker/REJECT_FORCE_UPDATE_ORDER_REQUEST_CLEAR',

GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS: '@makerChecker/GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS',
GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS_REQUEST: '@makerChecker/GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS_REQUEST',
GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS_SUCCESS: '@makerChecker/GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS_SUCCESS',
GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS_FAILURE: '@makerChecker/GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS_FAILURE',
GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS_CLEAR: '@makerChecker/GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS_CLEAR',

GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS: '@makerChecker/GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS',
GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS_REQUEST: '@makerChecker/GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS_REQUEST',
GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS_SUCCESS: '@makerChecker/GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS_SUCCESS',
GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS_FAILURE: '@makerChecker/GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS_FAILURE',
GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS_CLEAR: '@makerChecker/GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS_CLEAR',

// Fee Configuration Platform - Entity CRUD
GET_FEE_CONFIG_CONVENIENCE_FEES: '@feeConfig/GET_CONVENIENCE_FEES',
GET_FEE_CONFIG_CONVENIENCE_FEES_REQUEST: '@feeConfig/GET_CONVENIENCE_FEES_REQUEST',
GET_FEE_CONFIG_CONVENIENCE_FEES_SUCCESS: '@feeConfig/GET_CONVENIENCE_FEES_SUCCESS',
GET_FEE_CONFIG_CONVENIENCE_FEES_FAILURE: '@feeConfig/GET_CONVENIENCE_FEES_FAILURE',
GET_FEE_CONFIG_CONVENIENCE_FEES_CLEAR: '@feeConfig/GET_CONVENIENCE_FEES_CLEAR',

GET_FEE_CONFIG_CONVENIENCE_FEE_DETAIL: '@feeConfig/GET_CONVENIENCE_FEE_DETAIL',
GET_FEE_CONFIG_CONVENIENCE_FEE_DETAIL_REQUEST: '@feeConfig/GET_CONVENIENCE_FEE_DETAIL_REQUEST',
GET_FEE_CONFIG_CONVENIENCE_FEE_DETAIL_SUCCESS: '@feeConfig/GET_CONVENIENCE_FEE_DETAIL_SUCCESS',
GET_FEE_CONFIG_CONVENIENCE_FEE_DETAIL_FAILURE: '@feeConfig/GET_CONVENIENCE_FEE_DETAIL_FAILURE',
GET_FEE_CONFIG_CONVENIENCE_FEE_DETAIL_CLEAR: '@feeConfig/GET_CONVENIENCE_FEE_DETAIL_CLEAR',

GET_FEE_CONFIG_FEATURE_FEES: '@feeConfig/GET_FEATURE_FEES',
GET_FEE_CONFIG_FEATURE_FEES_REQUEST: '@feeConfig/GET_FEATURE_FEES_REQUEST',
GET_FEE_CONFIG_FEATURE_FEES_SUCCESS: '@feeConfig/GET_FEATURE_FEES_SUCCESS',
GET_FEE_CONFIG_FEATURE_FEES_FAILURE: '@feeConfig/GET_FEATURE_FEES_FAILURE',
GET_FEE_CONFIG_FEATURE_FEES_CLEAR: '@feeConfig/GET_FEATURE_FEES_CLEAR',

GET_FEE_CONFIG_MERCHANT_MAPPINGS: '@feeConfig/GET_MERCHANT_MAPPINGS',
GET_FEE_CONFIG_MERCHANT_MAPPINGS_REQUEST: '@feeConfig/GET_MERCHANT_MAPPINGS_REQUEST',
GET_FEE_CONFIG_MERCHANT_MAPPINGS_SUCCESS: '@feeConfig/GET_MERCHANT_MAPPINGS_SUCCESS',
GET_FEE_CONFIG_MERCHANT_MAPPINGS_FAILURE: '@feeConfig/GET_MERCHANT_MAPPINGS_FAILURE',
GET_FEE_CONFIG_MERCHANT_MAPPINGS_CLEAR: '@feeConfig/GET_MERCHANT_MAPPINGS_CLEAR',

GET_FEE_CONFIG_MERCHANT_FEE_MAPPINGS: '@feeConfig/GET_MERCHANT_FEE_MAPPINGS',
GET_FEE_CONFIG_MERCHANT_FEE_MAPPINGS_REQUEST: '@feeConfig/GET_MERCHANT_FEE_MAPPINGS_REQUEST',
GET_FEE_CONFIG_MERCHANT_FEE_MAPPINGS_SUCCESS: '@feeConfig/GET_MERCHANT_FEE_MAPPINGS_SUCCESS',
GET_FEE_CONFIG_MERCHANT_FEE_MAPPINGS_FAILURE: '@feeConfig/GET_MERCHANT_FEE_MAPPINGS_FAILURE',
GET_FEE_CONFIG_MERCHANT_FEE_MAPPINGS_CLEAR: '@feeConfig/GET_MERCHANT_FEE_MAPPINGS_CLEAR',

GET_FEE_CONFIG_PAYMENT_MODES: '@feeConfig/GET_PAYMENT_MODES',
GET_FEE_CONFIG_PAYMENT_MODES_REQUEST: '@feeConfig/GET_PAYMENT_MODES_REQUEST',
GET_FEE_CONFIG_PAYMENT_MODES_SUCCESS: '@feeConfig/GET_PAYMENT_MODES_SUCCESS',
GET_FEE_CONFIG_PAYMENT_MODES_FAILURE: '@feeConfig/GET_PAYMENT_MODES_FAILURE',
GET_FEE_CONFIG_PAYMENT_MODES_CLEAR: '@feeConfig/GET_PAYMENT_MODES_CLEAR',

GET_FEE_CONFIG_NETWORK_TYPES: '@feeConfig/GET_NETWORK_TYPES',
GET_FEE_CONFIG_NETWORK_TYPES_REQUEST: '@feeConfig/GET_NETWORK_TYPES_REQUEST',
GET_FEE_CONFIG_NETWORK_TYPES_SUCCESS: '@feeConfig/GET_NETWORK_TYPES_SUCCESS',
GET_FEE_CONFIG_NETWORK_TYPES_FAILURE: '@feeConfig/GET_NETWORK_TYPES_FAILURE',
GET_FEE_CONFIG_NETWORK_TYPES_CLEAR: '@feeConfig/GET_NETWORK_TYPES_CLEAR',

// Fee Configuration Platform - Change Requests (approval workflow)
SUBMIT_FEE_CONFIG_CHANGE_REQUEST: '@feeConfig/SUBMIT_CHANGE_REQUEST',
SUBMIT_FEE_CONFIG_CHANGE_REQUEST_REQUEST: '@feeConfig/SUBMIT_CHANGE_REQUEST_REQUEST',
SUBMIT_FEE_CONFIG_CHANGE_REQUEST_SUCCESS: '@feeConfig/SUBMIT_CHANGE_REQUEST_SUCCESS',
SUBMIT_FEE_CONFIG_CHANGE_REQUEST_FAILURE: '@feeConfig/SUBMIT_CHANGE_REQUEST_FAILURE',
SUBMIT_FEE_CONFIG_CHANGE_REQUEST_CLEAR: '@feeConfig/SUBMIT_CHANGE_REQUEST_CLEAR',

GET_FEE_CONFIG_CHANGE_REQUESTS: '@feeConfig/GET_CHANGE_REQUESTS',
GET_FEE_CONFIG_CHANGE_REQUESTS_REQUEST: '@feeConfig/GET_CHANGE_REQUESTS_REQUEST',
GET_FEE_CONFIG_CHANGE_REQUESTS_SUCCESS: '@feeConfig/GET_CHANGE_REQUESTS_SUCCESS',
GET_FEE_CONFIG_CHANGE_REQUESTS_FAILURE: '@feeConfig/GET_CHANGE_REQUESTS_FAILURE',
GET_FEE_CONFIG_CHANGE_REQUESTS_CLEAR: '@feeConfig/GET_CHANGE_REQUESTS_CLEAR',

GET_FEE_CONFIG_CHANGE_REQUEST_DETAIL: '@feeConfig/GET_CHANGE_REQUEST_DETAIL',
GET_FEE_CONFIG_CHANGE_REQUEST_DETAIL_REQUEST: '@feeConfig/GET_CHANGE_REQUEST_DETAIL_REQUEST',
GET_FEE_CONFIG_CHANGE_REQUEST_DETAIL_SUCCESS: '@feeConfig/GET_CHANGE_REQUEST_DETAIL_SUCCESS',
GET_FEE_CONFIG_CHANGE_REQUEST_DETAIL_FAILURE: '@feeConfig/GET_CHANGE_REQUEST_DETAIL_FAILURE',
GET_FEE_CONFIG_CHANGE_REQUEST_DETAIL_CLEAR: '@feeConfig/GET_CHANGE_REQUEST_DETAIL_CLEAR',

APPROVE_FEE_CONFIG_CHANGE_REQUEST: '@feeConfig/APPROVE_CHANGE_REQUEST',
APPROVE_FEE_CONFIG_CHANGE_REQUEST_REQUEST: '@feeConfig/APPROVE_CHANGE_REQUEST_REQUEST',
APPROVE_FEE_CONFIG_CHANGE_REQUEST_SUCCESS: '@feeConfig/APPROVE_CHANGE_REQUEST_SUCCESS',
APPROVE_FEE_CONFIG_CHANGE_REQUEST_FAILURE: '@feeConfig/APPROVE_CHANGE_REQUEST_FAILURE',
APPROVE_FEE_CONFIG_CHANGE_REQUEST_CLEAR: '@feeConfig/APPROVE_CHANGE_REQUEST_CLEAR',

REJECT_FEE_CONFIG_CHANGE_REQUEST: '@feeConfig/REJECT_CHANGE_REQUEST',
REJECT_FEE_CONFIG_CHANGE_REQUEST_REQUEST: '@feeConfig/REJECT_CHANGE_REQUEST_REQUEST',
REJECT_FEE_CONFIG_CHANGE_REQUEST_SUCCESS: '@feeConfig/REJECT_CHANGE_REQUEST_SUCCESS',
REJECT_FEE_CONFIG_CHANGE_REQUEST_FAILURE: '@feeConfig/REJECT_CHANGE_REQUEST_FAILURE',
REJECT_FEE_CONFIG_CHANGE_REQUEST_CLEAR: '@feeConfig/REJECT_CHANGE_REQUEST_CLEAR',

GET_FEE_CONFIG_EXECUTION_STATUS: '@feeConfig/GET_EXECUTION_STATUS',
GET_FEE_CONFIG_EXECUTION_STATUS_REQUEST: '@feeConfig/GET_EXECUTION_STATUS_REQUEST',
GET_FEE_CONFIG_EXECUTION_STATUS_SUCCESS: '@feeConfig/GET_EXECUTION_STATUS_SUCCESS',
GET_FEE_CONFIG_EXECUTION_STATUS_FAILURE: '@feeConfig/GET_EXECUTION_STATUS_FAILURE',
GET_FEE_CONFIG_EXECUTION_STATUS_CLEAR: '@feeConfig/GET_EXECUTION_STATUS_CLEAR',

  // LEAD SUMMARY (independent)
  GET_LEAD_SUMMARY: '@merchants/GET_LEAD_SUMMARY',
  GET_LEAD_SUMMARY_SUCCESS: '@merchants/GET_LEAD_SUMMARY_SUCCESS',
  GET_LEAD_SUMMARY_FAILURE: '@merchants/GET_LEAD_SUMMARY_FAILURE',
  GET_LEAD_SUMMARY_REQUEST: '@merchants/GET_LEAD_SUMMARY_REQUEST',
  GET_LEAD_SUMMARY_CLEAR: '@merchants/GET_LEAD_SUMMARY_CLEAR',

  // PARTNER ONBOARDING - Stage Details
  GET_PARTNER_ONBOARDING_STAGE_LIST: '@partner/GET_PARTNER_ONBOARDING_STAGE_LIST',
  GET_PARTNER_ONBOARDING_STAGE_LIST_SUCCESS: '@partner/GET_PARTNER_ONBOARDING_STAGE_LIST_SUCCESS',
  GET_PARTNER_ONBOARDING_STAGE_LIST_FAILURE: '@partner/GET_PARTNER_ONBOARDING_STAGE_LIST_FAILURE',
  GET_PARTNER_ONBOARDING_STAGE_LIST_REQUEST: '@partner/GET_PARTNER_ONBOARDING_STAGE_LIST_REQUEST',
  GET_PARTNER_ONBOARDING_STAGE_LIST_CLEAR: '@partner/GET_PARTNER_ONBOARDING_STAGE_LIST_CLEAR',

  // PARTNER ONBOARDING - Invite Merchant
  INVITE_PARTNER_MERCHANT: '@partner/INVITE_PARTNER_MERCHANT',
  INVITE_PARTNER_MERCHANT_SUCCESS: '@partner/INVITE_PARTNER_MERCHANT_SUCCESS',
  INVITE_PARTNER_MERCHANT_FAILURE: '@partner/INVITE_PARTNER_MERCHANT_FAILURE',
  INVITE_PARTNER_MERCHANT_REQUEST: '@partner/INVITE_PARTNER_MERCHANT_REQUEST',
  INVITE_PARTNER_MERCHANT_CLEAR: '@partner/INVITE_PARTNER_MERCHANT_CLEAR',

  // PARTNER ONBOARDING - Payment Methods
  GET_PARTNER_PAYMENT_METHODS: '@partner/GET_PARTNER_PAYMENT_METHODS',
  GET_PARTNER_PAYMENT_METHODS_SUCCESS: '@partner/GET_PARTNER_PAYMENT_METHODS_SUCCESS',
  GET_PARTNER_PAYMENT_METHODS_FAILURE: '@partner/GET_PARTNER_PAYMENT_METHODS_FAILURE',
  GET_PARTNER_PAYMENT_METHODS_REQUEST: '@partner/GET_PARTNER_PAYMENT_METHODS_REQUEST',
  GET_PARTNER_PAYMENT_METHODS_CLEAR: '@partner/GET_PARTNER_PAYMENT_METHODS_CLEAR',

  GET_PARTNER_SUB_MERCHANT_LIST: '@partnermerchants/GET_PARTNER_SUB_MERCHANT_LIST',
  GET_PARTNER_SUB_MERCHANT_LIST_SUCCESS: '@partnermerchants/GET_PARTNER_SUB_MERCHANT_LIST_SUCCESS',
  GET_PARTNER_SUB_MERCHANT_LIST_FAILURE: '@partnermerchants/GET_PARTNER_SUB_MERCHANT_LIST_FAILURE',
  GET_PARTNER_SUB_MERCHANT_LIST_REQUEST: '@partnermerchants/GET_PARTNER_SUB_MERCHANT_LIST_REQUEST',
  GET_PARTNER_SUB_MERCHANT_LIST_CLEAR: '@partnermerchants/GET_PARTNER_SUB_MERCHANT_LIST_CLEAR',

  // Setting / Dashboard Theme / Update Theme
  GET_DASHBOARD_THEME: '@settings/GET_DASHBOARD_THEME',
  GET_DASHBOARD_THEME_REQUEST: '@settings/GET_DASHBOARD_THEME_REQUEST',
  GET_DASHBOARD_THEME_SUCCESS: '@settings/GET_DASHBOARD_THEME_SUCCESS',
  GET_DASHBOARD_THEME_FAILURE: '@settings/GET_DASHBOARD_THEME_FAILURE',
  GET_DASHBOARD_THEME_CLEAR: '@settings/GET_DASHBOARD_THEME_CLEAR',
  POST_DASHBOARD_THEME: '@settings/POST_UPDATE_DASHBOARD_THEME',
  POST_UPDATE_DASHBOARD_THEME_REQUEST: '@settings/POST_UPDATE_DASHBOARD_THEME_REQUEST',
  POST_UPDATE_DASHBOARD_THEME_SUCCESS: '@settings/POST_UPDATE_DASHBOARD_THEME_SUCCESS',
  POST_UPDATE_DASHBOARD_THEME_FAILURE: '@settings/POST_UPDATE_DASHBOARD_THEME_FAILURE',
  POST_UPDATE_DASHBOARD_THEME_CLEAR: '@settings/POST_UPDATE_DASHBOARD_THEME_CLEAR',
  POST_UPDATE_DASHBOARD_THEME: '@settings/POST_UPDATE_DASHBOARD_THEME',

  // Split Settlement
  GET_SPLIT_SETTLEMENT_CHILDREN: '@splitSettlement/GET_CHILDREN',
  GET_SPLIT_SETTLEMENT_CHILDREN_REQUEST: '@splitSettlement/GET_CHILDREN_REQUEST',
  GET_SPLIT_SETTLEMENT_CHILDREN_SUCCESS: '@splitSettlement/GET_CHILDREN_SUCCESS',
  GET_SPLIT_SETTLEMENT_CHILDREN_FAILURE: '@splitSettlement/GET_CHILDREN_FAILURE',
  GET_SPLIT_SETTLEMENT_CHILDREN_CLEAR: '@splitSettlement/GET_CHILDREN_CLEAR',
  UPDATE_SPLIT_SETTLEMENT_CHILD: '@splitSettlement/UPDATE_CHILD',
  UPDATE_SPLIT_SETTLEMENT_CHILD_REQUEST: '@splitSettlement/UPDATE_CHILD_REQUEST',
  UPDATE_SPLIT_SETTLEMENT_CHILD_SUCCESS: '@splitSettlement/UPDATE_CHILD_SUCCESS',
  UPDATE_SPLIT_SETTLEMENT_CHILD_FAILURE: '@splitSettlement/UPDATE_CHILD_FAILURE',
  UPDATE_SPLIT_SETTLEMENT_CHILD_CLEAR: '@splitSettlement/UPDATE_CHILD_CLEAR',
  GET_SPLIT_SETTLEMENT_AUDIT: '@splitSettlement/GET_AUDIT',
  GET_SPLIT_SETTLEMENT_AUDIT_REQUEST: '@splitSettlement/GET_AUDIT_REQUEST',
  GET_SPLIT_SETTLEMENT_AUDIT_SUCCESS: '@splitSettlement/GET_AUDIT_SUCCESS',
  GET_SPLIT_SETTLEMENT_AUDIT_FAILURE: '@splitSettlement/GET_AUDIT_FAILURE',
  GET_SPLIT_SETTLEMENT_AUDIT_CLEAR: '@splitSettlement/GET_AUDIT_CLEAR',

  GET_ASSISTED_VKYC_STATUS: '@assistedVkyc/GET_STATUS',
  GET_ASSISTED_VKYC_STATUS_REQUEST: '@assistedVkyc/GET_STATUS_REQUEST',
  GET_ASSISTED_VKYC_STATUS_SUCCESS: '@assistedVkyc/GET_STATUS_SUCCESS',
  GET_ASSISTED_VKYC_STATUS_FAILURE: '@assistedVkyc/GET_STATUS_FAILURE',
  GET_ASSISTED_KYC_DATA: '@assistedVkyc/GET_KYC_DATA',
  GET_ASSISTED_KYC_DATA_REQUEST: '@assistedVkyc/GET_KYC_DATA_REQUEST',
  GET_ASSISTED_KYC_DATA_SUCCESS: '@assistedVkyc/GET_KYC_DATA_SUCCESS',
  GET_ASSISTED_KYC_DATA_FAILURE: '@assistedVkyc/GET_KYC_DATA_FAILURE',
  UPDATE_ASSISTED_SIGNATORY_DETAILS: '@assistedVkyc/UPDATE_SIGNATORY_DETAILS',
  UPDATE_ASSISTED_SIGNATORY_DETAILS_REQUEST: '@assistedVkyc/UPDATE_SIGNATORY_DETAILS_REQUEST',
  UPDATE_ASSISTED_SIGNATORY_DETAILS_SUCCESS: '@assistedVkyc/UPDATE_SIGNATORY_DETAILS_SUCCESS',
  UPDATE_ASSISTED_SIGNATORY_DETAILS_FAILURE: '@assistedVkyc/UPDATE_SIGNATORY_DETAILS_FAILURE',
  INITIATE_ASSISTED_VKYC: '@assistedVkyc/INITIATE',
  INITIATE_ASSISTED_VKYC_REQUEST: '@assistedVkyc/INITIATE_REQUEST',
  INITIATE_ASSISTED_VKYC_SUCCESS: '@assistedVkyc/INITIATE_SUCCESS',
  INITIATE_ASSISTED_VKYC_FAILURE: '@assistedVkyc/INITIATE_FAILURE',
  CLEAR_ASSISTED_VKYC_STATE: '@assistedVkyc/CLEAR_STATE',
};
